(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9OVGD", function(module, exports) {

var $22yUM = parcelRequire("22yUM");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if ((0, $22yUM._)(module.exports) === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return (typeof obj === "undefined" ? "undefined" : (0, $22yUM._)(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $22yUM._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if ((typeof target === "undefined" ? "undefined" : (0, $22yUM._)(target)) !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, _dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[_dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                ((typeof returned === "undefined" ? "undefined" : (0, $22yUM._)(returned)) === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, _data) {
            return dataUser.access(elem, name, _data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, $22yUM._)(key)) === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if ((typeof types === "undefined" ? "undefined" : (0, $22yUM._)(types)) === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, _handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = _handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = _handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < _handlers.length) handlerQueue.push({
                elem: cur,
                handlers: _handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, $22yUM._)(types)) === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $22yUM._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && (typeof speed === "undefined" ? "undefined" : (0, $22yUM._)(speed)) === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $22yUM._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : (0, $22yUM._)(event)) === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, $22yUM._)(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if ((typeof url === "undefined" ? "undefined" : (0, $22yUM._)(url)) === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && (typeof params === "undefined" ? "undefined" : (0, $22yUM._)(params)) === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("22yUM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17c6da0aa640e82f$export$71511d61b312f219; });
function $17c6da0aa640e82f$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("e4rvh", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $a3e6c60bea301201$export$caec2af78bcc877f; });
$parcel$export(module.exports, "Button", function () { return $a3e6c60bea301201$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "Carousel", function () { return $a3e6c60bea301201$export$144901db2ea8e967; });
$parcel$export(module.exports, "Collapse", function () { return $a3e6c60bea301201$export$78768a9af065a7b; });
$parcel$export(module.exports, "Dropdown", function () { return $a3e6c60bea301201$export$931cbfb6bfb85fc; });
$parcel$export(module.exports, "Modal", function () { return $a3e6c60bea301201$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "Offcanvas", function () { return $a3e6c60bea301201$export$591ca0244c9dfcd4; });
$parcel$export(module.exports, "Tooltip", function () { return $a3e6c60bea301201$export$28c660c63b792dea; });
$parcel$export(module.exports, "Popover", function () { return $a3e6c60bea301201$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "ScrollSpy", function () { return $a3e6c60bea301201$export$a6472a5298a374be; });
$parcel$export(module.exports, "Tab", function () { return $a3e6c60bea301201$export$3e41faf802a29e71; });
$parcel$export(module.exports, "Toast", function () { return $a3e6c60bea301201$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $g1iGh = parcelRequire("g1iGh");

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $9HFeY = parcelRequire("9HFeY");

var $5oewZ = parcelRequire("5oewZ");

var $hzVoy = parcelRequire("hzVoy");

var $5IDCd = parcelRequire("5IDCd");

var $4udDG = parcelRequire("4udDG");

var $beyvH = parcelRequire("beyvH");

var $8cFxo = parcelRequire("8cFxo");

var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");

var $2VHbc = parcelRequire("2VHbc");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$elementMap = new Map();
var $a3e6c60bea301201$var$Data = {
    set: function(element, key, instance) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) $a3e6c60bea301201$var$elementMap.set(element, new Map());
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($a3e6c60bea301201$var$elementMap.has(element)) return $a3e6c60bea301201$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) return;
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $a3e6c60bea301201$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$MAX_UID = 1000000;
var $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER = 1000;
var $a3e6c60bea301201$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $a3e6c60bea301201$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $a3e6c60bea301201$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $a3e6c60bea301201$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $a3e6c60bea301201$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $a3e6c60bea301201$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER;
};
var $a3e6c60bea301201$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($a3e6c60bea301201$var$TRANSITION_END));
};
var $a3e6c60bea301201$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $22yUM._)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $a3e6c60bea301201$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($a3e6c60bea301201$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($a3e6c60bea301201$var$parseSelector(object));
    return null;
};
var $a3e6c60bea301201$var$isVisible = function(element) {
    if (!$a3e6c60bea301201$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $a3e6c60bea301201$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $a3e6c60bea301201$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $a3e6c60bea301201$var$findShadowRoot(element.parentNode);
};
var $a3e6c60bea301201$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $a3e6c60bea301201$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $a3e6c60bea301201$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $a3e6c60bea301201$var$DOMContentLoadedCallbacks = [];
var $a3e6c60bea301201$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$a3e6c60bea301201$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $a3e6c60bea301201$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $a3e6c60bea301201$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $a3e6c60bea301201$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $a3e6c60bea301201$var$defineJQueryPlugin = function(plugin) {
    $a3e6c60bea301201$var$onDOMContentLoaded(function() {
        var $ = $a3e6c60bea301201$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $a3e6c60bea301201$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    return typeof possibleCallback === 'function' ? possibleCallback.apply(void 0, (0, $2b6Uo._)(args)) : defaultValue;
};
var $a3e6c60bea301201$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $a3e6c60bea301201$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $a3e6c60bea301201$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
        $a3e6c60bea301201$var$execute(callback);
    };
    transitionElement.addEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $a3e6c60bea301201$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $a3e6c60bea301201$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $a3e6c60bea301201$var$stripNameRegex = /\..*/;
var $a3e6c60bea301201$var$stripUidRegex = /::\d+$/;
var $a3e6c60bea301201$var$eventRegistry = {}; // Events storage
var $a3e6c60bea301201$var$uidEvent = 1;
var $a3e6c60bea301201$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $a3e6c60bea301201$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $a3e6c60bea301201$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($a3e6c60bea301201$var$uidEvent++) || element.uidEvent || $a3e6c60bea301201$var$uidEvent++;
}
function $a3e6c60bea301201$var$getElementEvents(element) {
    var uid = $a3e6c60bea301201$var$makeEventUid(element);
    element.uidEvent = uid;
    $a3e6c60bea301201$var$eventRegistry[uid] = $a3e6c60bea301201$var$eventRegistry[uid] || {};
    return $a3e6c60bea301201$var$eventRegistry[uid];
}
function $a3e6c60bea301201$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $a3e6c60bea301201$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $a3e6c60bea301201$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $a3e6c60bea301201$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $a3e6c60bea301201$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $a3e6c60bea301201$var$getTypeEvent(originalTypeEvent);
    if (!$a3e6c60bea301201$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $a3e6c60bea301201$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $iFZdg._)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $a3e6c60bea301201$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $a3e6c60bea301201$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $a3e6c60bea301201$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $a3e6c60bea301201$var$makeEventUid(callable, originalTypeEvent.replace($a3e6c60bea301201$var$namespaceRegex, ''));
    var fn = isDelegated ? $a3e6c60bea301201$var$bootstrapDelegationHandler(element, handler, callable) : $a3e6c60bea301201$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $a3e6c60bea301201$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $iFZdg._)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $a3e6c60bea301201$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($a3e6c60bea301201$var$stripNameRegex, '');
    return $a3e6c60bea301201$var$customEvents[event] || event;
}
var $a3e6c60bea301201$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $iFZdg._)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $a3e6c60bea301201$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $iFZdg._)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($a3e6c60bea301201$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $a3e6c60bea301201$var$getjQuery();
        var typeEvent = $a3e6c60bea301201$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $a3e6c60bea301201$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $a3e6c60bea301201$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $a3e6c60bea301201$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $a3e6c60bea301201$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $a3e6c60bea301201$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = $a3e6c60bea301201$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $a3e6c60bea301201$var$normalizeData(element.getAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $a3e6c60bea301201$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $eCXNS._)(this, Config);
    }
    (0, $7M9bt._)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $4udDG._)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $22yUM._)(jsonConfig)) === 'object' ? jsonConfig : {}, $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $a3e6c60bea301201$var$isElement(value) ? 'element' : $a3e6c60bea301201$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$VERSION = '5.3.3';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $eCXNS._)(this, BaseComponent);
        var _this;
        _this = (0, $g1iGh._)(this, BaseComponent);
        element = $a3e6c60bea301201$var$getElement(element);
        if (!element) return (0, $8cFxo._)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $a3e6c60bea301201$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $7M9bt._)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $a3e6c60bea301201$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $a3e6c60bea301201$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $a3e6c60bea301201$var$Data.get($a3e6c60bea301201$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $a3e6c60bea301201$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $a3e6c60bea301201$var$parseSelector(sel);
    }).join(',') : null;
};
var $a3e6c60bea301201$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$a3e6c60bea301201$var$isDisabled(el) && $a3e6c60bea301201$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        if (selector) return $a3e6c60bea301201$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $a3e6c60bea301201$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($a3e6c60bea301201$var$isDisabled(this)) return;
        var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$f = 'alert';
var $a3e6c60bea301201$var$DATA_KEY$a = 'bs.alert';
var $a3e6c60bea301201$var$EVENT_KEY$b = ".".concat($a3e6c60bea301201$var$DATA_KEY$a);
var $a3e6c60bea301201$var$EVENT_CLOSE = "close".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$EVENT_CLOSED = "closed".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$5 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $a3e6c60bea301201$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Alert, BaseComponent);
    function Alert() {
        (0, $eCXNS._)(this, Alert);
        return (0, $g1iGh._)(this, Alert, arguments);
    }
    (0, $7M9bt._)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$e = 'button';
var $a3e6c60bea301201$var$DATA_KEY$9 = 'bs.button';
var $a3e6c60bea301201$var$EVENT_KEY$a = ".".concat($a3e6c60bea301201$var$DATA_KEY$9);
var $a3e6c60bea301201$var$DATA_API_KEY$6 = '.data-api';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$a).concat($a3e6c60bea301201$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $a3e6c60bea301201$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Button, BaseComponent);
    function Button() {
        (0, $eCXNS._)(this, Button);
        return (0, $g1iGh._)(this, Button, arguments);
    }
    (0, $7M9bt._)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5);
    var data = $a3e6c60bea301201$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$d = 'swipe';
var $a3e6c60bea301201$var$EVENT_KEY$9 = '.bs.swipe';
var $a3e6c60bea301201$var$EVENT_TOUCHSTART = "touchstart".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHMOVE = "touchmove".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHEND = "touchend".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERDOWN = "pointerdown".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERUP = "pointerup".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$POINTER_TYPE_TOUCH = 'touch';
var $a3e6c60bea301201$var$POINTER_TYPE_PEN = 'pen';
var $a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $a3e6c60bea301201$var$SWIPE_THRESHOLD = 40;
var $a3e6c60bea301201$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $a3e6c60bea301201$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(Swipe, Config);
    function Swipe(element, config) {
        (0, $eCXNS._)(this, Swipe);
        var _this;
        _this = (0, $g1iGh._)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $8cFxo._)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $7M9bt._)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $a3e6c60bea301201$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $a3e6c60bea301201$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $a3e6c60bea301201$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_PEN || event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$c = 'carousel';
var $a3e6c60bea301201$var$DATA_KEY$8 = 'bs.carousel';
var $a3e6c60bea301201$var$EVENT_KEY$8 = ".".concat($a3e6c60bea301201$var$DATA_KEY$8);
var $a3e6c60bea301201$var$DATA_API_KEY$5 = '.data-api';
var $a3e6c60bea301201$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $a3e6c60bea301201$var$ORDER_NEXT = 'next';
var $a3e6c60bea301201$var$ORDER_PREV = 'prev';
var $a3e6c60bea301201$var$DIRECTION_LEFT = 'left';
var $a3e6c60bea301201$var$DIRECTION_RIGHT = 'right';
var $a3e6c60bea301201$var$EVENT_SLIDE = "slide".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_SLID = "slid".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_KEYDOWN$1 = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_DRAG_START = "dragstart".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL = 'carousel';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2 = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_SLIDE = 'slide';
var $a3e6c60bea301201$var$CLASS_NAME_END = 'carousel-item-end';
var $a3e6c60bea301201$var$CLASS_NAME_START = 'carousel-item-start';
var $a3e6c60bea301201$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $a3e6c60bea301201$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE = '.active';
var $a3e6c60bea301201$var$SELECTOR_ITEM = '.carousel-item';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM = $a3e6c60bea301201$var$SELECTOR_ACTIVE + $a3e6c60bea301201$var$SELECTOR_ITEM;
var $a3e6c60bea301201$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $a3e6c60bea301201$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $a3e6c60bea301201$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $a3e6c60bea301201$var$_obj;
var $a3e6c60bea301201$var$KEY_TO_DIRECTION = ($a3e6c60bea301201$var$_obj = {}, (0, $9HFeY._)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_LEFT_KEY$1, $a3e6c60bea301201$var$DIRECTION_RIGHT), (0, $9HFeY._)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1, $a3e6c60bea301201$var$DIRECTION_LEFT), $a3e6c60bea301201$var$_obj);
var $a3e6c60bea301201$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $a3e6c60bea301201$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $eCXNS._)(this, Carousel);
        var _this;
        _this = (0, $g1iGh._)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $7M9bt._)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($a3e6c60bea301201$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $a3e6c60bea301201$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($a3e6c60bea301201$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $a3e6c60bea301201$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $5oewZ._)((0, $hzVoy._)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $a3e6c60bea301201$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(img, $a3e6c60bea301201$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $a3e6c60bea301201$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $a3e6c60bea301201$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $a3e6c60bea301201$var$ORDER_NEXT;
                var nextElement = element || $a3e6c60bea301201$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $a3e6c60bea301201$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($a3e6c60bea301201$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_START : $a3e6c60bea301201$var$CLASS_NAME_END;
                var orderClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_NEXT : $a3e6c60bea301201$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $a3e6c60bea301201$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($a3e6c60bea301201$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($a3e6c60bea301201$var$isRTL()) return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_PREV : $a3e6c60bea301201$var$ORDER_NEXT;
                return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($a3e6c60bea301201$var$isRTL()) return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_LEFT : $a3e6c60bea301201$var$DIRECTION_RIGHT;
                return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_RIGHT : $a3e6c60bea301201$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5, $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($a3e6c60bea301201$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$b = 'collapse';
var $a3e6c60bea301201$var$DATA_KEY$7 = 'bs.collapse';
var $a3e6c60bea301201$var$EVENT_KEY$7 = ".".concat($a3e6c60bea301201$var$DATA_KEY$7);
var $a3e6c60bea301201$var$DATA_API_KEY$4 = '.data-api';
var $a3e6c60bea301201$var$EVENT_SHOW$6 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_SHOWN$6 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDE$6 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDDEN$6 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$7).concat($a3e6c60bea301201$var$DATA_API_KEY$4);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$7 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSE = 'collapse';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, " .").concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
var $a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $a3e6c60bea301201$var$WIDTH = 'width';
var $a3e6c60bea301201$var$HEIGHT = 'height';
var $a3e6c60bea301201$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $a3e6c60bea301201$var$Default$a = {
    parent: null,
    toggle: true
};
var $a3e6c60bea301201$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $eCXNS._)(this, Collapse);
        var _this;
        _this = (0, $g1iGh._)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $a3e6c60bea301201$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $a3e6c60bea301201$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $7M9bt._)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $a3e6c60bea301201$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL) ? $a3e6c60bea301201$var$WIDTH : $a3e6c60bea301201$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $a3e6c60bea301201$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$a = 'dropdown';
var $a3e6c60bea301201$var$DATA_KEY$6 = 'bs.dropdown';
var $a3e6c60bea301201$var$EVENT_KEY$6 = ".".concat($a3e6c60bea301201$var$DATA_KEY$6);
var $a3e6c60bea301201$var$DATA_API_KEY$3 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$2 = 'Escape';
var $a3e6c60bea301201$var$TAB_KEY$1 = 'Tab';
var $a3e6c60bea301201$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $a3e6c60bea301201$var$EVENT_HIDE$5 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_HIDDEN$5 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOW$5 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOWN$5 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API = "keyup".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$6 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP = 'dropup';
var $a3e6c60bea301201$var$CLASS_NAME_DROPEND = 'dropend';
var $a3e6c60bea301201$var$CLASS_NAME_DROPSTART = 'dropstart';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, ".").concat($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
var $a3e6c60bea301201$var$SELECTOR_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR = '.navbar';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$PLACEMENT_TOP = $a3e6c60bea301201$var$isRTL() ? 'top-end' : 'top-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPEND = $a3e6c60bea301201$var$isRTL() ? 'top-start' : 'top-end';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOM = $a3e6c60bea301201$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND = $a3e6c60bea301201$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $a3e6c60bea301201$var$PLACEMENT_RIGHT = $a3e6c60bea301201$var$isRTL() ? 'left-start' : 'right-start';
var $a3e6c60bea301201$var$PLACEMENT_LEFT = $a3e6c60bea301201$var$isRTL() ? 'right-start' : 'left-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPCENTER = 'top';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $a3e6c60bea301201$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $a3e6c60bea301201$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $eCXNS._)(this, Dropdown);
        var _this;
        _this = (0, $g1iGh._)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $a3e6c60bea301201$var$SelectorEngine.next(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.prev(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $7M9bt._)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($a3e6c60bea301201$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($a3e6c60bea301201$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $5oewZ._)((0, $hzVoy._)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $a3e6c60bea301201$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $5oewZ._)((0, $hzVoy._)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $22yUM._)(config.reference) === 'object' && !$a3e6c60bea301201$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($a3e6c60bea301201$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $2VHbc === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($a3e6c60bea301201$var$isElement(this._config.reference)) referenceElement = $a3e6c60bea301201$var$getElement(this._config.reference);
                else if ((0, $22yUM._)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $2VHbc.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPEND)) return $a3e6c60bea301201$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPSTART)) return $a3e6c60bea301201$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP)) return isEnd ? $a3e6c60bea301201$var$PLACEMENT_TOPEND : $a3e6c60bea301201$var$PLACEMENT_TOP;
                return isEnd ? $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND : $a3e6c60bea301201$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $a3e6c60bea301201$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $4udDG._)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $a3e6c60bea301201$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $a3e6c60bea301201$var$getNextActiveElement(items, target, key === $a3e6c60bea301201$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $a3e6c60bea301201$var$TAB_KEY$1) return;
                var openToggles = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $a3e6c60bea301201$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $a3e6c60bea301201$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $a3e6c60bea301201$var$ARROW_UP_KEY$1,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3) ? this : $a3e6c60bea301201$var$SelectorEngine.prev(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.next(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_MENU, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $a3e6c60bea301201$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$9 = 'backdrop';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$4 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$5 = 'show';
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($a3e6c60bea301201$var$NAME$9);
var $a3e6c60bea301201$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $a3e6c60bea301201$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(Backdrop, Config);
    function Backdrop(config) {
        (0, $eCXNS._)(this, Backdrop);
        var _this;
        _this = (0, $g1iGh._)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $7M9bt._)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $a3e6c60bea301201$var$reflow(element);
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $a3e6c60bea301201$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $a3e6c60bea301201$var$EventHandler.on(element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN, function() {
                    $a3e6c60bea301201$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $a3e6c60bea301201$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$8 = 'focustrap';
var $a3e6c60bea301201$var$DATA_KEY$5 = 'bs.focustrap';
var $a3e6c60bea301201$var$EVENT_KEY$5 = ".".concat($a3e6c60bea301201$var$DATA_KEY$5);
var $a3e6c60bea301201$var$EVENT_FOCUSIN$2 = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$TAB_KEY = 'Tab';
var $a3e6c60bea301201$var$TAB_NAV_FORWARD = 'forward';
var $a3e6c60bea301201$var$TAB_NAV_BACKWARD = 'backward';
var $a3e6c60bea301201$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $a3e6c60bea301201$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $eCXNS._)(this, FocusTrap);
        var _this;
        _this = (0, $g1iGh._)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $7M9bt._)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5); // guard against infinite focus loop
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $a3e6c60bea301201$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $a3e6c60bea301201$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $a3e6c60bea301201$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $a3e6c60bea301201$var$TAB_NAV_BACKWARD : $a3e6c60bea301201$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $a3e6c60bea301201$var$PROPERTY_PADDING = 'padding-right';
var $a3e6c60bea301201$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $eCXNS._)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $7M9bt._)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $a3e6c60bea301201$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $a3e6c60bea301201$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($a3e6c60bea301201$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$7 = 'modal';
var $a3e6c60bea301201$var$DATA_KEY$4 = 'bs.modal';
var $a3e6c60bea301201$var$EVENT_KEY$4 = ".".concat($a3e6c60bea301201$var$DATA_KEY$4);
var $a3e6c60bea301201$var$DATA_API_KEY$2 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$1 = 'Escape';
var $a3e6c60bea301201$var$EVENT_HIDE$4 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDDEN$4 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOW$4 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOWN$4 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_RESIZE$1 = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$4).concat($a3e6c60bea301201$var$DATA_API_KEY$2);
var $a3e6c60bea301201$var$CLASS_NAME_OPEN = 'modal-open';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$3 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$4 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_STATIC = 'modal-static';
var $a3e6c60bea301201$var$OPEN_SELECTOR$1 = '.modal.show';
var $a3e6c60bea301201$var$SELECTOR_DIALOG = '.modal-dialog';
var $a3e6c60bea301201$var$SELECTOR_MODAL_BODY = '.modal-body';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $a3e6c60bea301201$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $a3e6c60bea301201$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $eCXNS._)(this, Modal);
        var _this;
        _this = (0, $g1iGh._)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $a3e6c60bea301201$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $7M9bt._)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(window, $a3e6c60bea301201$var$EVENT_KEY$4);
                $a3e6c60bea301201$var$EventHandler.off(this._dialog, $a3e6c60bea301201$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $5oewZ._)((0, $hzVoy._)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $a3e6c60bea301201$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $a3e6c60bea301201$var$EventHandler.one(_this._element, $a3e6c60bea301201$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $a3e6c60bea301201$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $a3e6c60bea301201$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$4, function() {
            if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $a3e6c60bea301201$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$6 = 'offcanvas';
var $a3e6c60bea301201$var$DATA_KEY$3 = 'bs.offcanvas';
var $a3e6c60bea301201$var$EVENT_KEY$3 = ".".concat($a3e6c60bea301201$var$DATA_KEY$3);
var $a3e6c60bea301201$var$DATA_API_KEY$1 = '.data-api';
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$ESCAPE_KEY = 'Escape';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$3 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING$1 = 'showing';
var $a3e6c60bea301201$var$CLASS_NAME_HIDING = 'hiding';
var $a3e6c60bea301201$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $a3e6c60bea301201$var$OPEN_SELECTOR = '.offcanvas.show';
var $a3e6c60bea301201$var$EVENT_SHOW$3 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_SHOWN$3 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE$3 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDDEN$3 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_RESIZE = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $a3e6c60bea301201$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $a3e6c60bea301201$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $eCXNS._)(this, Offcanvas);
        var _this;
        _this = (0, $g1iGh._)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $7M9bt._)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$3, $a3e6c60bea301201$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $5oewZ._)((0, $hzVoy._)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $a3e6c60bea301201$var$Backdrop({
                    className: $a3e6c60bea301201$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $a3e6c60bea301201$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $a3e6c60bea301201$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $a3e6c60bea301201$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
var $a3e6c60bea301201$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $a3e6c60bea301201$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($a3e6c60bea301201$var$uriAttributes.has(attributeName)) return Boolean($a3e6c60bea301201$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $a3e6c60bea301201$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $2b6Uo._)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$a3e6c60bea301201$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$5 = 'TemplateFactory';
var $a3e6c60bea301201$var$Default$4 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $a3e6c60bea301201$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $a3e6c60bea301201$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $5IDCd._)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $eCXNS._)(this, TemplateFactory);
        var _this;
        _this = (0, $g1iGh._)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $7M9bt._)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $4udDG._)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $2b6Uo._)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $5oewZ._)((0, $hzVoy._)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $5oewZ._)((0, $hzVoy._)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $a3e6c60bea301201$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($a3e6c60bea301201$var$isElement(content)) {
                    this._putElementInTemplate($a3e6c60bea301201$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $a3e6c60bea301201$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$4 = 'tooltip';
var $a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$2 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_MODAL = 'modal';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$2 = 'show';
var $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $a3e6c60bea301201$var$SELECTOR_MODAL = ".".concat($a3e6c60bea301201$var$CLASS_NAME_MODAL);
var $a3e6c60bea301201$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $a3e6c60bea301201$var$TRIGGER_HOVER = 'hover';
var $a3e6c60bea301201$var$TRIGGER_FOCUS = 'focus';
var $a3e6c60bea301201$var$TRIGGER_CLICK = 'click';
var $a3e6c60bea301201$var$TRIGGER_MANUAL = 'manual';
var $a3e6c60bea301201$var$EVENT_HIDE$2 = 'hide';
var $a3e6c60bea301201$var$EVENT_HIDDEN$2 = 'hidden';
var $a3e6c60bea301201$var$EVENT_SHOW$2 = 'show';
var $a3e6c60bea301201$var$EVENT_SHOWN$2 = 'shown';
var $a3e6c60bea301201$var$EVENT_INSERTED = 'inserted';
var $a3e6c60bea301201$var$EVENT_CLICK$1 = 'click';
var $a3e6c60bea301201$var$EVENT_FOCUSIN$1 = 'focusin';
var $a3e6c60bea301201$var$EVENT_FOCUSOUT$1 = 'focusout';
var $a3e6c60bea301201$var$EVENT_MOUSEENTER = 'mouseenter';
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE = 'mouseleave';
var $a3e6c60bea301201$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $a3e6c60bea301201$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $a3e6c60bea301201$var$isRTL() ? 'right' : 'left'
};
var $a3e6c60bea301201$var$Default$3 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $a3e6c60bea301201$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $eCXNS._)(this, Tooltip);
        var _this;
        if (typeof $2VHbc === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        _this = (0, $g1iGh._)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $7M9bt._)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                this._activeTrigger.click = !this._activeTrigger.click;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $a3e6c60bea301201$var$EventHandler.off(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $5oewZ._)((0, $hzVoy._)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOW$2));
                var shadowRoot = $a3e6c60bea301201$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_FADE$2, $a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $a3e6c60bea301201$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $a3e6c60bea301201$var$TemplateFactory((0, $beyvH._)((0, $4udDG._)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $9HFeY._)({}, $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $a3e6c60bea301201$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $a3e6c60bea301201$var$AttachmentMap[placement.toUpperCase()];
                return $2VHbc.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $4udDG._)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $a3e6c60bea301201$var$EventHandler.on(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context.toggle();
                        });
                        else if (trigger !== $a3e6c60bea301201$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSEENTER) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSELEAVE) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSOUT$1);
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $a3e6c60bea301201$var$EventHandler.on(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $a3e6c60bea301201$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $4udDG._)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $22yUM._)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $a3e6c60bea301201$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$3 = 'popover';
var $a3e6c60bea301201$var$SELECTOR_TITLE = '.popover-header';
var $a3e6c60bea301201$var$SELECTOR_CONTENT = '.popover-body';
var $a3e6c60bea301201$var$Default$2 = (0, $beyvH._)((0, $4udDG._)({}, $a3e6c60bea301201$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $a3e6c60bea301201$var$DefaultType$2 = (0, $beyvH._)((0, $4udDG._)({}, $a3e6c60bea301201$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $a3e6c60bea301201$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $5IDCd._)(Popover, Tooltip);
    function Popover() {
        (0, $eCXNS._)(this, Popover);
        return (0, $g1iGh._)(this, Popover, arguments);
    }
    (0, $7M9bt._)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $9HFeY._)(_obj, $a3e6c60bea301201$var$SELECTOR_TITLE, this._getTitle()), (0, $9HFeY._)(_obj, $a3e6c60bea301201$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$2 = 'scrollspy';
var $a3e6c60bea301201$var$DATA_KEY$2 = 'bs.scrollspy';
var $a3e6c60bea301201$var$EVENT_KEY$2 = ".".concat($a3e6c60bea301201$var$DATA_KEY$2);
var $a3e6c60bea301201$var$DATA_API_KEY = '.data-api';
var $a3e6c60bea301201$var$EVENT_ACTIVATE = "activate".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_CLICK = "click".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$2).concat($a3e6c60bea301201$var$DATA_API_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS = '[href]';
var $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $a3e6c60bea301201$var$SELECTOR_NAV_LINKS = '.nav-link';
var $a3e6c60bea301201$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $a3e6c60bea301201$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS = "".concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_NAV_ITEMS, " > ").concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_LIST_ITEMS);
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN = '.dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $a3e6c60bea301201$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $a3e6c60bea301201$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $eCXNS._)(this, ScrollSpy);
        var _this;
        _this = (0, $g1iGh._)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $7M9bt._)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $5oewZ._)((0, $hzVoy._)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $a3e6c60bea301201$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $a3e6c60bea301201$var$EventHandler.off(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK);
                $a3e6c60bea301201$var$EventHandler.on(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK, $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $a3e6c60bea301201$var$isDisabled(anchor)) continue;
                        var observableSection = $a3e6c60bea301201$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($a3e6c60bea301201$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($a3e6c60bea301201$var$SELECTOR_DROPDOWN)).classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.parents(target, $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $a3e6c60bea301201$var$SelectorEngine.prev(listGroup, $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $a3e6c60bea301201$var$SelectorEngine.find("".concat($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, ".").concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $a3e6c60bea301201$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$1 = 'tab';
var $a3e6c60bea301201$var$DATA_KEY$1 = 'bs.tab';
var $a3e6c60bea301201$var$EVENT_KEY$1 = ".".concat($a3e6c60bea301201$var$DATA_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDE$1 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDDEN$1 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOW$1 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOWN$1 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API = "click".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API = "load".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $a3e6c60bea301201$var$ARROW_UP_KEY = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY = 'ArrowDown';
var $a3e6c60bea301201$var$HOME_KEY = 'Home';
var $a3e6c60bea301201$var$END_KEY = 'End';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$1 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$1 = 'show';
var $a3e6c60bea301201$var$CLASS_DROPDOWN = 'dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $a3e6c60bea301201$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $a3e6c60bea301201$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $a3e6c60bea301201$var$SELECTOR_INNER = ".nav-link".concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $a3e6c60bea301201$var$SELECTOR_INNER_ELEM = "".concat($a3e6c60bea301201$var$SELECTOR_INNER, ", ").concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $a3e6c60bea301201$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Tab, BaseComponent);
    function Tab(element) {
        (0, $eCXNS._)(this, Tab);
        var _this;
        _this = (0, $g1iGh._)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($a3e6c60bea301201$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $8cFxo._)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $a3e6c60bea301201$var$EventHandler.on(_this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $7M9bt._)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $a3e6c60bea301201$var$EventHandler.trigger(active, $a3e6c60bea301201$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(innerElem, $a3e6c60bea301201$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                this._activate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $a3e6c60bea301201$var$ARROW_LEFT_KEY,
                    $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                    $a3e6c60bea301201$var$ARROW_UP_KEY,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY,
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$a3e6c60bea301201$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $a3e6c60bea301201$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                        $a3e6c60bea301201$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $a3e6c60bea301201$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($a3e6c60bea301201$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, $a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU, $a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($a3e6c60bea301201$var$SELECTOR_INNER_ELEM) ? elem : $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($a3e6c60bea301201$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME = 'toast';
var $a3e6c60bea301201$var$DATA_KEY = 'bs.toast';
var $a3e6c60bea301201$var$EVENT_KEY = ".".concat($a3e6c60bea301201$var$DATA_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOVER = "mouseover".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOUT = "mouseout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSIN = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSOUT = "focusout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDE = "hide".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDDEN = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOW = "show".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOWN = "shown".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_FADE = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $a3e6c60bea301201$var$CLASS_NAME_SHOW = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING = 'showing';
var $a3e6c60bea301201$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $a3e6c60bea301201$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $5IDCd._)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $eCXNS._)(this, Toast);
        var _this;
        _this = (0, $g1iGh._)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $7M9bt._)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW, $a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING, $a3e6c60bea301201$var$CLASS_NAME_SHOW);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN);
                };
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW);
                (0, $5oewZ._)((0, $hzVoy._)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$8d8dc7d5f743331b);

});
parcelRegister("g1iGh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba9b3af6d173df65$export$71511d61b312f219; });

var $hzVoy = parcelRequire("hzVoy");

var $wppeX = parcelRequire("wppeX");

var $8cFxo = parcelRequire("8cFxo");
function $ba9b3af6d173df65$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $hzVoy._)(derived);
    return (0, $8cFxo._)(_this, (0, $wppeX._)() ? Reflect.construct(derived, args || [], (0, $hzVoy._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("hzVoy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccc23a021f1e6bc0$export$71511d61b312f219; });
function $ccc23a021f1e6bc0$export$71511d61b312f219(o) {
    $ccc23a021f1e6bc0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ccc23a021f1e6bc0$export$71511d61b312f219(o);
}

});

parcelRegister("wppeX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0616b26550fb407b$export$71511d61b312f219; });
function $0616b26550fb407b$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($0616b26550fb407b$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("8cFxo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5f8faa38aa7bcc75$export$71511d61b312f219; });

var $aabtM = parcelRequire("aabtM");

var $22yUM = parcelRequire("22yUM");
function $5f8faa38aa7bcc75$export$71511d61b312f219(self, call) {
    if (call && ((0, $22yUM._)(call) === "object" || typeof call === "function")) return call;
    return (0, $aabtM._)(self);
}

});
parcelRegister("aabtM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7663be19a9d89647$export$71511d61b312f219; });
function $7663be19a9d89647$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("eCXNS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aa63010954ffd74c$export$71511d61b312f219; });
function $aa63010954ffd74c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7M9bt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5a9423d6bdf9478a$export$71511d61b312f219; });
function $5a9423d6bdf9478a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5a9423d6bdf9478a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("9HFeY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $71081ebd7d211bed$export$71511d61b312f219; });
function $71081ebd7d211bed$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("5oewZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3eca773514dd6a70$export$71511d61b312f219; });

var $2fr3v = parcelRequire("2fr3v");
function $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3eca773514dd6a70$export$71511d61b312f219 = Reflect.get;
    else $3eca773514dd6a70$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $2fr3v._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("2fr3v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1a31f82b87f62ce4$export$71511d61b312f219; });

var $hzVoy = parcelRequire("hzVoy");
function $1a31f82b87f62ce4$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $hzVoy._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("5IDCd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $429fca99a37ce120$export$71511d61b312f219; });

var $cU6r8 = parcelRequire("cU6r8");
function $429fca99a37ce120$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cU6r8._)(subClass, superClass);
}

});
parcelRegister("cU6r8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $964fb531acf43ca5$export$71511d61b312f219; });
function $964fb531acf43ca5$export$71511d61b312f219(o, p) {
    $964fb531acf43ca5$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $964fb531acf43ca5$export$71511d61b312f219(o, p);
}

});


parcelRegister("4udDG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $34448b2f636abc71$export$71511d61b312f219; });

var $9HFeY = parcelRequire("9HFeY");
function $34448b2f636abc71$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9HFeY._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("beyvH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $82dbc585330cff66$export$71511d61b312f219; });
function $82dbc585330cff66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82dbc585330cff66$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $82dbc585330cff66$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("iFZdg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d98b89efad01a571$export$71511d61b312f219; });

var $1SZ4G = parcelRequire("1SZ4G");

var $eXaIS = parcelRequire("eXaIS");

var $2XoEB = parcelRequire("2XoEB");

var $ghR52 = parcelRequire("ghR52");
function $d98b89efad01a571$export$71511d61b312f219(arr, i) {
    return (0, $1SZ4G._)(arr) || (0, $eXaIS._)(arr, i) || (0, $ghR52._)(arr, i) || (0, $2XoEB._)();
}

});
parcelRegister("1SZ4G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15fa35b92343d82d$export$71511d61b312f219; });
function $15fa35b92343d82d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("eXaIS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae2ee4b241bf08f3$export$71511d61b312f219; });
function $ae2ee4b241bf08f3$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("2XoEB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $22743732e33643c8$export$71511d61b312f219; });
function $22743732e33643c8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ghR52", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bdb768849265fd3d$export$71511d61b312f219; });

var $2bDqK = parcelRequire("2bDqK");
function $bdb768849265fd3d$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2bDqK._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2bDqK._)(o, minLen);
}

});
parcelRegister("2bDqK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $197b31e54e99ed29$export$71511d61b312f219; });
function $197b31e54e99ed29$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2b6Uo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1961f7bca441a4c6$export$71511d61b312f219; });

var $jWe67 = parcelRequire("jWe67");

var $f2mBX = parcelRequire("f2mBX");

var $2g5td = parcelRequire("2g5td");

var $ghR52 = parcelRequire("ghR52");
function $1961f7bca441a4c6$export$71511d61b312f219(arr) {
    return (0, $jWe67._)(arr) || (0, $f2mBX._)(arr) || (0, $ghR52._)(arr) || (0, $2g5td._)();
}

});
parcelRegister("jWe67", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e83e5e97102e2c54$export$71511d61b312f219; });

var $2bDqK = parcelRequire("2bDqK");
function $e83e5e97102e2c54$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2bDqK._)(arr);
}

});

parcelRegister("f2mBX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af28950850a78917$export$71511d61b312f219; });
function $af28950850a78917$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("2g5td", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1a5151a9158d4e3a$export$71511d61b312f219; });
function $1a5151a9158d4e3a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2VHbc", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("eUhUr")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("7W9OQ")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("eUhUr")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("gj0kA")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("cvLMA")).createPopper; });

var $hLNOA = parcelRequire("hLNOA");

var $4cJjP = parcelRequire("4cJjP");

var $eUhUr = parcelRequire("eUhUr");
var $7W9OQ = parcelRequire("7W9OQ");

var $gj0kA = parcelRequire("gj0kA");

var $cvLMA = parcelRequire("cvLMA");
$parcel$exportWildcard(module.exports, $hLNOA);
$parcel$exportWildcard(module.exports, $4cJjP);

});
parcelRegister("hLNOA", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $cefd77a409472d8d$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $cefd77a409472d8d$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $cefd77a409472d8d$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $cefd77a409472d8d$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $cefd77a409472d8d$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $cefd77a409472d8d$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $cefd77a409472d8d$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $cefd77a409472d8d$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $cefd77a409472d8d$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $cefd77a409472d8d$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $cefd77a409472d8d$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $cefd77a409472d8d$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $cefd77a409472d8d$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $cefd77a409472d8d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $cefd77a409472d8d$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $cefd77a409472d8d$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $cefd77a409472d8d$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $cefd77a409472d8d$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $cefd77a409472d8d$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $cefd77a409472d8d$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $cefd77a409472d8d$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $cefd77a409472d8d$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $cefd77a409472d8d$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $cefd77a409472d8d$export$d087d3878fdf71d5; });
var $cefd77a409472d8d$export$1e95b668f3b82d = 'top';
var $cefd77a409472d8d$export$40e543e69a8b3fbb = 'bottom';
var $cefd77a409472d8d$export$79ffe56a765070d2 = 'right';
var $cefd77a409472d8d$export$eabcd2c8791e7bf4 = 'left';
var $cefd77a409472d8d$export$dfb5619354ba860 = 'auto';
var $cefd77a409472d8d$export$aec2ce47c367b8c3 = [
    $cefd77a409472d8d$export$1e95b668f3b82d,
    $cefd77a409472d8d$export$40e543e69a8b3fbb,
    $cefd77a409472d8d$export$79ffe56a765070d2,
    $cefd77a409472d8d$export$eabcd2c8791e7bf4
];
var $cefd77a409472d8d$export$b3571188c770cc5a = 'start';
var $cefd77a409472d8d$export$bd5df0f255a350f8 = 'end';
var $cefd77a409472d8d$export$390fd549c5303b4d = 'clippingParents';
var $cefd77a409472d8d$export$d7b7311ec04a3e8f = 'viewport';
var $cefd77a409472d8d$export$ae5ab1c730825774 = 'popper';
var $cefd77a409472d8d$export$ca50aac9f3ba507f = 'reference';
var $cefd77a409472d8d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cefd77a409472d8d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []);
var $cefd77a409472d8d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cefd77a409472d8d$export$aec2ce47c367b8c3, [
    $cefd77a409472d8d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cefd77a409472d8d$export$421679a7c3d56e = 'beforeRead';
var $cefd77a409472d8d$export$aafa59e2e03f2942 = 'read';
var $cefd77a409472d8d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cefd77a409472d8d$export$c65e99957a05207c = 'beforeMain';
var $cefd77a409472d8d$export$f22da7240b7add18 = 'main';
var $cefd77a409472d8d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cefd77a409472d8d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cefd77a409472d8d$export$68d8715fc104d294 = 'write';
var $cefd77a409472d8d$export$70a6e5159acce2e6 = 'afterWrite';
var $cefd77a409472d8d$export$d087d3878fdf71d5 = [
    $cefd77a409472d8d$export$421679a7c3d56e,
    $cefd77a409472d8d$export$aafa59e2e03f2942,
    $cefd77a409472d8d$export$6964f6c886723980,
    $cefd77a409472d8d$export$c65e99957a05207c,
    $cefd77a409472d8d$export$f22da7240b7add18,
    $cefd77a409472d8d$export$bab79516f2d662fe,
    $cefd77a409472d8d$export$8d4d2d70e7d46032,
    $cefd77a409472d8d$export$68d8715fc104d294,
    $cefd77a409472d8d$export$70a6e5159acce2e6
];

});

parcelRegister("4cJjP", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("9XzE9")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("bjTvB")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("5t115")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("jB2gV")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("gnTEb")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("2VS1U")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("BJXkZ")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("lgEf5")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("2bNRN")).default; });

var $9XzE9 = parcelRequire("9XzE9");

var $bjTvB = parcelRequire("bjTvB");

var $5t115 = parcelRequire("5t115");

var $jB2gV = parcelRequire("jB2gV");

var $gnTEb = parcelRequire("gnTEb");

var $2VS1U = parcelRequire("2VS1U");

var $BJXkZ = parcelRequire("BJXkZ");

var $lgEf5 = parcelRequire("lgEf5");

var $2bNRN = parcelRequire("2bNRN");

});
parcelRegister("9XzE9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74054666164da556$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");
// and applies them to the HTMLElements such as popper and arrow
function $74054666164da556$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fnwZW.isHTMLElement)(element) || !(0, $4po09.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $74054666164da556$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fnwZW.isHTMLElement)(element) || !(0, $4po09.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $74054666164da556$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $74054666164da556$var$applyStyles,
    effect: $74054666164da556$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("4po09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $335c1d630991db9d$export$2e2bcd8739ae039; });
function $335c1d630991db9d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("fnwZW", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $02e3a7a40389e518$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $02e3a7a40389e518$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $02e3a7a40389e518$export$af51f0f06c0f328a; });

var $75WJ3 = parcelRequire("75WJ3");
function $02e3a7a40389e518$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $75WJ3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $02e3a7a40389e518$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $75WJ3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $02e3a7a40389e518$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $75WJ3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("75WJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52a68dbbf79b0696$export$2e2bcd8739ae039; });
function $52a68dbbf79b0696$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("bjTvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83dc86f42fc279ac$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $WjiIh = parcelRequire("WjiIh");

var $amSOG = parcelRequire("amSOG");

var $5Ulvj = parcelRequire("5Ulvj");

var $4G5YW = parcelRequire("4G5YW");

var $f3VaM = parcelRequire("f3VaM");

var $cU8tF = parcelRequire("cU8tF");

var $4c890 = parcelRequire("4c890");

var $hLNOA = parcelRequire("hLNOA");
var $83dc86f42fc279ac$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cU8tF.default)(typeof padding !== 'number' ? padding : (0, $4c890.default)(padding, (0, $hLNOA.basePlacements)));
};
function $83dc86f42fc279ac$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5DN8C.default)(state.placement);
    var axis = (0, $4G5YW.default)(basePlacement);
    var isVertical = [
        (0, $hLNOA.left),
        (0, $hLNOA.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $83dc86f42fc279ac$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $WjiIh.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $hLNOA.top) : (0, $hLNOA.left);
    var maxProp = axis === 'y' ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5Ulvj.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $f3VaM.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $83dc86f42fc279ac$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $amSOG.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $83dc86f42fc279ac$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $83dc86f42fc279ac$var$arrow,
    effect: $83dc86f42fc279ac$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("5DN8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b6b608ffa08ca1$export$2e2bcd8739ae039; });

function $41b6b608ffa08ca1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("WjiIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af463a2f2f36779$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");
function $0af463a2f2f36779$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $ce6re.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("ce6re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6bc95b10844cc4$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");

var $hPrig = parcelRequire("hPrig");

var $75WJ3 = parcelRequire("75WJ3");

var $fvgXO = parcelRequire("fvgXO");
function $8e6bc95b10844cc4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fnwZW.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hPrig.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hPrig.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fnwZW.isElement)(element) ? (0, $75WJ3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvgXO.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hPrig", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cfac5f0503fa0c0c$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cfac5f0503fa0c0c$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cfac5f0503fa0c0c$export$2077e0241d6afd3c; });
var $cfac5f0503fa0c0c$export$8960430cfd85939f = Math.max;
var $cfac5f0503fa0c0c$export$96ec731ed4dcb222 = Math.min;
var $cfac5f0503fa0c0c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fvgXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b496e8e32f6ce209$export$2e2bcd8739ae039; });

var $oqoG4 = parcelRequire("oqoG4");
function $b496e8e32f6ce209$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $oqoG4.default)());
}

});
parcelRegister("oqoG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0496b7e7c66765a6$export$2e2bcd8739ae039; });
function $0496b7e7c66765a6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("amSOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c67adc35462806$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");
function $78c67adc35462806$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fnwZW.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5Ulvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d2dcfa9b6528d5$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");

var $4po09 = parcelRequire("4po09");

var $eCVvO = parcelRequire("eCVvO");

var $fnwZW = parcelRequire("fnwZW");

var $wxfkv = parcelRequire("wxfkv");

var $dQ5A6 = parcelRequire("dQ5A6");

var $oqoG4 = parcelRequire("oqoG4");
function $44d2dcfa9b6528d5$var$getTrueOffsetParent(element) {
    if (!(0, $fnwZW.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $eCVvO.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $44d2dcfa9b6528d5$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $oqoG4.default)());
    var isIE = /Trident/i.test((0, $oqoG4.default)());
    if (isIE && (0, $fnwZW.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $eCVvO.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $dQ5A6.default)(element);
    if ((0, $fnwZW.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fnwZW.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4po09.default)(currentNode)) < 0){
        var css = (0, $eCVvO.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $44d2dcfa9b6528d5$export$2e2bcd8739ae039(element) {
    var window = (0, $75WJ3.default)(element);
    var offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $wxfkv.default)(offsetParent) && (0, $eCVvO.default)(offsetParent).position === 'static')offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4po09.default)(offsetParent) === 'html' || (0, $4po09.default)(offsetParent) === 'body' && (0, $eCVvO.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $44d2dcfa9b6528d5$var$getContainingBlock(element) || window;
}

});
parcelRegister("eCVvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa613a05ba685ccb$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
function $aa613a05ba685ccb$export$2e2bcd8739ae039(element) {
    return (0, $75WJ3.default)(element).getComputedStyle(element);
}

});

parcelRegister("wxfkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061cc7497f9f99cf$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");
function $061cc7497f9f99cf$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4po09.default)(element)) >= 0;
}

});

parcelRegister("dQ5A6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a13476024d635e41$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");

var $7oLJz = parcelRequire("7oLJz");

var $fnwZW = parcelRequire("fnwZW");
function $a13476024d635e41$export$2e2bcd8739ae039(element) {
    if ((0, $4po09.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fnwZW.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7oLJz.default)(element) // fallback
    );
}

});
parcelRegister("7oLJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562fcd476b3355d2$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");
function $562fcd476b3355d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fnwZW.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("4G5YW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367fb99255482738$export$2e2bcd8739ae039; });
function $367fb99255482738$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("f3VaM", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $af737c27d799169c$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $af737c27d799169c$export$86c8af6d3ef0b4a; });

var $hPrig = parcelRequire("hPrig");
function $af737c27d799169c$export$f28d906d67a997f3(min, value, max) {
    return (0, $hPrig.max)(min, (0, $hPrig.min)(value, max));
}
function $af737c27d799169c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $af737c27d799169c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("cU8tF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96514a6e68cf3ac6$export$2e2bcd8739ae039; });

var $effgS = parcelRequire("effgS");
function $96514a6e68cf3ac6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $effgS.default)(), paddingObject);
}

});
parcelRegister("effgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5ee4ff71e95e5f9$export$2e2bcd8739ae039; });
function $a5ee4ff71e95e5f9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4c890", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30de99b1366d30c9$export$2e2bcd8739ae039; });
function $30de99b1366d30c9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("5t115", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb07310bceb7864$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $5Ulvj = parcelRequire("5Ulvj");

var $75WJ3 = parcelRequire("75WJ3");

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $5DN8C = parcelRequire("5DN8C");

var $cTtdJ = parcelRequire("cTtdJ");

var $hPrig = parcelRequire("hPrig");
var $3fb07310bceb7864$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3fb07310bceb7864$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hPrig.round)(x * dpr) / dpr || 0,
        y: (0, $hPrig.round)(y * dpr) / dpr || 0
    };
}
function $3fb07310bceb7864$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $hLNOA.left);
    var sideY = (0, $hLNOA.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5Ulvj.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $75WJ3.default)(popper)) {
            offsetParent = (0, $7oLJz.default)(popper);
            if ((0, $eCVvO.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hLNOA.top) || (placement === (0, $hLNOA.left) || placement === (0, $hLNOA.right)) && variation === (0, $hLNOA.end)) {
            sideY = (0, $hLNOA.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hLNOA.left) || (placement === (0, $hLNOA.top) || placement === (0, $hLNOA.bottom)) && variation === (0, $hLNOA.end)) {
            sideX = (0, $hLNOA.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3fb07310bceb7864$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3fb07310bceb7864$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $75WJ3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3fb07310bceb7864$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5DN8C.default)(state.placement),
        variation: (0, $cTtdJ.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3fb07310bceb7864$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3fb07310bceb7864$var$computeStyles,
    data: {}
};

});
parcelRegister("cTtdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $963149affb10e1b3$export$2e2bcd8739ae039; });
function $963149affb10e1b3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("jB2gV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4433c3268ceda30$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
var $e4433c3268ceda30$var$passive = {
    passive: true
};
function $e4433c3268ceda30$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $75WJ3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e4433c3268ceda30$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e4433c3268ceda30$var$effect,
    data: {}
};

});

parcelRegister("gnTEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bed9f5a8c2893a90$export$2e2bcd8739ae039; });

var $kJAhT = parcelRequire("kJAhT");

var $5DN8C = parcelRequire("5DN8C");

var $73k3R = parcelRequire("73k3R");

var $7W9OQ = parcelRequire("7W9OQ");

var $dbB6I = parcelRequire("dbB6I");

var $hLNOA = parcelRequire("hLNOA");

var $cTtdJ = parcelRequire("cTtdJ");
function $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5DN8C.default)(placement) === (0, $hLNOA.auto)) return [];
    var oppositePlacement = (0, $kJAhT.default)(placement);
    return [
        (0, $73k3R.default)(placement),
        oppositePlacement,
        (0, $73k3R.default)(oppositePlacement)
    ];
}
function $bed9f5a8c2893a90$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5DN8C.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kJAhT.default)(preferredPlacement)
    ] : $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5DN8C.default)(placement) === (0, $hLNOA.auto) ? (0, $dbB6I.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5DN8C.default)(placement);
        var isStartVariation = (0, $cTtdJ.default)(placement) === (0, $hLNOA.start);
        var isVertical = [
            (0, $hLNOA.top),
            (0, $hLNOA.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $7W9OQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hLNOA.right) : (0, $hLNOA.left) : isStartVariation ? (0, $hLNOA.bottom) : (0, $hLNOA.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kJAhT.default)(mainVariationSide);
        var altVariationSide = (0, $kJAhT.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bed9f5a8c2893a90$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $bed9f5a8c2893a90$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("kJAhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1842893058158ff$export$2e2bcd8739ae039; });
var $f1842893058158ff$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f1842893058158ff$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f1842893058158ff$var$hash[matched];
    });
}

});

parcelRegister("73k3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52285ff45efd9816$export$2e2bcd8739ae039; });
var $52285ff45efd9816$var$hash = {
    start: 'end',
    end: 'start'
};
function $52285ff45efd9816$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $52285ff45efd9816$var$hash[matched];
    });
}

});

parcelRegister("7W9OQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c75910e995426af$export$2e2bcd8739ae039; });

var $4rmEP = parcelRequire("4rmEP");

var $7oLJz = parcelRequire("7oLJz");

var $ce6re = parcelRequire("ce6re");

var $kx3pR = parcelRequire("kx3pR");

var $7C1zp = parcelRequire("7C1zp");

var $hLNOA = parcelRequire("hLNOA");

var $fnwZW = parcelRequire("fnwZW");

var $cU8tF = parcelRequire("cU8tF");

var $4c890 = parcelRequire("4c890");
function $5c75910e995426af$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hLNOA.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hLNOA.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hLNOA.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cU8tF.default)(typeof padding !== 'number' ? padding : (0, $4c890.default)(padding, (0, $hLNOA.basePlacements)));
    var altContext = elementContext === (0, $hLNOA.popper) ? (0, $hLNOA.reference) : (0, $hLNOA.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4rmEP.default)((0, $fnwZW.isElement)(element) ? element : element.contextElement || (0, $7oLJz.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $ce6re.default)(state.elements.reference);
    var popperOffsets = (0, $kx3pR.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $7C1zp.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hLNOA.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hLNOA.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hLNOA.right),
                (0, $hLNOA.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hLNOA.top),
                (0, $hLNOA.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("4rmEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33bb425c939e76c7$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $8mpYc = parcelRequire("8mpYc");

var $hjPFZ = parcelRequire("hjPFZ");

var $45J2h = parcelRequire("45J2h");

var $5Ulvj = parcelRequire("5Ulvj");

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $fnwZW = parcelRequire("fnwZW");

var $ce6re = parcelRequire("ce6re");

var $dQ5A6 = parcelRequire("dQ5A6");

var $amSOG = parcelRequire("amSOG");

var $4po09 = parcelRequire("4po09");

var $7C1zp = parcelRequire("7C1zp");

var $hPrig = parcelRequire("hPrig");
function $33bb425c939e76c7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $ce6re.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hLNOA.viewport) ? (0, $7C1zp.default)((0, $8mpYc.default)(element, strategy)) : (0, $fnwZW.isElement)(clippingParent) ? $33bb425c939e76c7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7C1zp.default)((0, $hjPFZ.default)((0, $7oLJz.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $33bb425c939e76c7$var$getClippingParents(element) {
    var clippingParents = (0, $45J2h.default)((0, $dQ5A6.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $eCVvO.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fnwZW.isHTMLElement)(element) ? (0, $5Ulvj.default)(element) : element;
    if (!(0, $fnwZW.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fnwZW.isElement)(clippingParent) && (0, $amSOG.default)(clippingParent, clipperElement) && (0, $4po09.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $33bb425c939e76c7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $33bb425c939e76c7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hPrig.max)(rect.top, accRect.top);
        accRect.right = (0, $hPrig.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hPrig.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hPrig.max)(rect.left, accRect.left);
        return accRect;
    }, $33bb425c939e76c7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("8mpYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616485e4a91e3db8$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");

var $7oLJz = parcelRequire("7oLJz");

var $4bBtm = parcelRequire("4bBtm");

var $fvgXO = parcelRequire("fvgXO");
function $616485e4a91e3db8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $75WJ3.default)(element);
    var html = (0, $7oLJz.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvgXO.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4bBtm.default)(element),
        y: y
    };
}

});
parcelRegister("4bBtm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c541c7d797b61f$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");

var $7oLJz = parcelRequire("7oLJz");

var $gTYCU = parcelRequire("gTYCU");
function $30c541c7d797b61f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $ce6re.default)((0, $7oLJz.default)(element)).left + (0, $gTYCU.default)(element).scrollLeft;
}

});
parcelRegister("gTYCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e0cf975615cf4c$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
function $c4e0cf975615cf4c$export$2e2bcd8739ae039(node) {
    var win = (0, $75WJ3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("hjPFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bc4bd93d03c0dd$export$2e2bcd8739ae039; });

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $4bBtm = parcelRequire("4bBtm");

var $gTYCU = parcelRequire("gTYCU");

var $hPrig = parcelRequire("hPrig");
function $c9bc4bd93d03c0dd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7oLJz.default)(element);
    var winScroll = (0, $gTYCU.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hPrig.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hPrig.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4bBtm.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $eCVvO.default)(body || html).direction === 'rtl') x += (0, $hPrig.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("45J2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2faa903c271e9c84$export$2e2bcd8739ae039; });

var $6AhnN = parcelRequire("6AhnN");

var $dQ5A6 = parcelRequire("dQ5A6");

var $75WJ3 = parcelRequire("75WJ3");

var $7kmIM = parcelRequire("7kmIM");
function $2faa903c271e9c84$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6AhnN.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $75WJ3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $7kmIM.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2faa903c271e9c84$export$2e2bcd8739ae039((0, $dQ5A6.default)(target)));
}

});
parcelRegister("6AhnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb396b5b9e812c5$export$2e2bcd8739ae039; });

var $dQ5A6 = parcelRequire("dQ5A6");

var $7kmIM = parcelRequire("7kmIM");

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");
function $4cb396b5b9e812c5$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4po09.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fnwZW.isHTMLElement)(node) && (0, $7kmIM.default)(node)) return node;
    return $4cb396b5b9e812c5$export$2e2bcd8739ae039((0, $dQ5A6.default)(node));
}

});
parcelRegister("7kmIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555c06a00f1841ba$export$2e2bcd8739ae039; });

var $eCVvO = parcelRequire("eCVvO");
function $555c06a00f1841ba$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $eCVvO.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("7C1zp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58ad4cd3a98c7161$export$2e2bcd8739ae039; });
function $58ad4cd3a98c7161$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("kx3pR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef298a14a6d7c348$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $cTtdJ = parcelRequire("cTtdJ");

var $4G5YW = parcelRequire("4G5YW");

var $hLNOA = parcelRequire("hLNOA");
function $ef298a14a6d7c348$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5DN8C.default)(placement) : null;
    var variation = placement ? (0, $cTtdJ.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hLNOA.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hLNOA.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hLNOA.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hLNOA.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4G5YW.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $hLNOA.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hLNOA.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("dbB6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99991629c512342a$export$2e2bcd8739ae039; });

var $cTtdJ = parcelRequire("cTtdJ");

var $hLNOA = parcelRequire("hLNOA");

var $7W9OQ = parcelRequire("7W9OQ");

var $5DN8C = parcelRequire("5DN8C");
function $99991629c512342a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hLNOA.placements) : _options$allowedAutoP;
    var variation = (0, $cTtdJ.default)(placement);
    var placements = variation ? flipVariations ? (0, $hLNOA.variationPlacements) : (0, $hLNOA.variationPlacements).filter(function(placement) {
        return (0, $cTtdJ.default)(placement) === variation;
    }) : (0, $hLNOA.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7W9OQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5DN8C.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("2VS1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222ad0d139efc5fd$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $7W9OQ = parcelRequire("7W9OQ");
function $222ad0d139efc5fd$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $222ad0d139efc5fd$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hLNOA.top),
        (0, $hLNOA.right),
        (0, $hLNOA.bottom),
        (0, $hLNOA.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $222ad0d139efc5fd$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7W9OQ.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $7W9OQ.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $222ad0d139efc5fd$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $222ad0d139efc5fd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $222ad0d139efc5fd$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $222ad0d139efc5fd$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $222ad0d139efc5fd$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $222ad0d139efc5fd$var$hide
};

});

parcelRegister("BJXkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07171abb3b970e38$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $hLNOA = parcelRequire("hLNOA");
function $07171abb3b970e38$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5DN8C.default)(placement);
    var invertDistance = [
        (0, $hLNOA.left),
        (0, $hLNOA.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hLNOA.left),
        (0, $hLNOA.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $07171abb3b970e38$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hLNOA.placements).reduce(function(acc, placement) {
        acc[placement] = $07171abb3b970e38$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $07171abb3b970e38$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $07171abb3b970e38$var$offset
};

});

parcelRegister("lgEf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7ba4eded364f4f7$export$2e2bcd8739ae039; });

var $kx3pR = parcelRequire("kx3pR");
function $f7ba4eded364f4f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kx3pR.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7ba4eded364f4f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f7ba4eded364f4f7$var$popperOffsets,
    data: {}
};

});

parcelRegister("2bNRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19834a509ede1e0f$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $5DN8C = parcelRequire("5DN8C");

var $4G5YW = parcelRequire("4G5YW");

var $3pWci = parcelRequire("3pWci");

var $f3VaM = parcelRequire("f3VaM");

var $WjiIh = parcelRequire("WjiIh");

var $5Ulvj = parcelRequire("5Ulvj");

var $7W9OQ = parcelRequire("7W9OQ");

var $cTtdJ = parcelRequire("cTtdJ");

var $effgS = parcelRequire("effgS");

var $hPrig = parcelRequire("hPrig");
function $19834a509ede1e0f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7W9OQ.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5DN8C.default)(state.placement);
    var variation = (0, $cTtdJ.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4G5YW.default)(basePlacement);
    var altAxis = (0, $3pWci.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $hLNOA.top) : (0, $hLNOA.left);
        var altSide = mainAxis === 'y' ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hLNOA.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hLNOA.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $WjiIh.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $effgS.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $f3VaM.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5Ulvj.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $f3VaM.within)(tether ? (0, $hPrig.min)(min, tetherMin) : min, offset, tether ? (0, $hPrig.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $hLNOA.top) : (0, $hLNOA.left);
        var _altSide = mainAxis === 'x' ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hLNOA.top),
            (0, $hLNOA.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $f3VaM.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $f3VaM.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $19834a509ede1e0f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $19834a509ede1e0f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3pWci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d0d9b036ab2393$export$2e2bcd8739ae039; });
function $27d0d9b036ab2393$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("eUhUr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $ada4301381eadd7f$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $ada4301381eadd7f$export$8f7491d57c8f97a9; });

var $fZBdm = parcelRequire("fZBdm");

var $WjiIh = parcelRequire("WjiIh");

var $45J2h = parcelRequire("45J2h");

var $5Ulvj = parcelRequire("5Ulvj");

var $7jBcF = parcelRequire("7jBcF");

var $bMPJL = parcelRequire("bMPJL");

var $v25V6 = parcelRequire("v25V6");

var $7W9OQ = parcelRequire("7W9OQ");

var $fnwZW = parcelRequire("fnwZW");
var $ada4301381eadd7f$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $ada4301381eadd7f$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $ada4301381eadd7f$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ada4301381eadd7f$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $ada4301381eadd7f$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $fnwZW.isElement)(reference) ? (0, $45J2h.default)(reference) : reference.contextElement ? (0, $45J2h.default)(reference.contextElement) : [],
                    popper: (0, $45J2h.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7jBcF.default)((0, $v25V6.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ada4301381eadd7f$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fZBdm.default)(_$reference, (0, $5Ulvj.default)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $WjiIh.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bMPJL.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ada4301381eadd7f$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $ada4301381eadd7f$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ada4301381eadd7f$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fZBdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba496b91dbb50203$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");

var $92KCM = parcelRequire("92KCM");

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");

var $4bBtm = parcelRequire("4bBtm");

var $7oLJz = parcelRequire("7oLJz");

var $7kmIM = parcelRequire("7kmIM");

var $hPrig = parcelRequire("hPrig");
function $ba496b91dbb50203$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hPrig.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hPrig.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ba496b91dbb50203$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fnwZW.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fnwZW.isHTMLElement)(offsetParent) && $ba496b91dbb50203$var$isElementScaled(offsetParent);
    var documentElement = (0, $7oLJz.default)(offsetParent);
    var rect = (0, $ce6re.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4po09.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $7kmIM.default)(documentElement)) scroll = (0, $92KCM.default)(offsetParent);
        if ((0, $fnwZW.isHTMLElement)(offsetParent)) {
            offsets = (0, $ce6re.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4bBtm.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("92KCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6958779f792d73b3$export$2e2bcd8739ae039; });

var $gTYCU = parcelRequire("gTYCU");

var $75WJ3 = parcelRequire("75WJ3");

var $fnwZW = parcelRequire("fnwZW");

var $1Ovpk = parcelRequire("1Ovpk");
function $6958779f792d73b3$export$2e2bcd8739ae039(node) {
    if (node === (0, $75WJ3.default)(node) || !(0, $fnwZW.isHTMLElement)(node)) return (0, $gTYCU.default)(node);
    else return (0, $1Ovpk.default)(node);
}

});
parcelRegister("1Ovpk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1522d2d0b08b8e74$export$2e2bcd8739ae039; });
function $1522d2d0b08b8e74$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("7jBcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55372a8a1c1b1368$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");
function $55372a8a1c1b1368$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $55372a8a1c1b1368$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $55372a8a1c1b1368$var$order(modifiers); // order based on phase
    return (0, $hLNOA.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("bMPJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894c4f4cf7ffd620$export$2e2bcd8739ae039; });
function $894c4f4cf7ffd620$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("v25V6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05d485493b85a587$export$2e2bcd8739ae039; });
function $05d485493b85a587$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("gj0kA", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $bdeead69b159d288$export$8f7491d57c8f97a9; });

var $eUhUr = parcelRequire("eUhUr");

var $jB2gV = parcelRequire("jB2gV");

var $lgEf5 = parcelRequire("lgEf5");

var $5t115 = parcelRequire("5t115");

var $9XzE9 = parcelRequire("9XzE9");

var $BJXkZ = parcelRequire("BJXkZ");

var $gnTEb = parcelRequire("gnTEb");

var $2bNRN = parcelRequire("2bNRN");

var $bjTvB = parcelRequire("bjTvB");

var $2VS1U = parcelRequire("2VS1U");


var $bdeead69b159d288$export$d34966752335dd47 = [
    (0, $jB2gV.default),
    (0, $lgEf5.default),
    (0, $5t115.default),
    (0, $9XzE9.default),
    (0, $BJXkZ.default),
    (0, $gnTEb.default),
    (0, $2bNRN.default),
    (0, $bjTvB.default),
    (0, $2VS1U.default)
];
var $bdeead69b159d288$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eUhUr.popperGenerator)({
    defaultModifiers: $bdeead69b159d288$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("cvLMA", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $91bd71f001b9e709$export$8f7491d57c8f97a9; });

var $eUhUr = parcelRequire("eUhUr");

var $jB2gV = parcelRequire("jB2gV");

var $lgEf5 = parcelRequire("lgEf5");

var $5t115 = parcelRequire("5t115");

var $9XzE9 = parcelRequire("9XzE9");
var $91bd71f001b9e709$export$d34966752335dd47 = [
    (0, $jB2gV.default),
    (0, $lgEf5.default),
    (0, $5t115.default),
    (0, $9XzE9.default)
];
var $91bd71f001b9e709$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eUhUr.popperGenerator)({
    defaultModifiers: $91bd71f001b9e709$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});




var $9OVGD = parcelRequire("9OVGD");
globalThis.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));


parcelRequire("9OVGD");
parcelRequire("e4rvh");

var $9OVGD = parcelRequire("9OVGD");
/* ####################################################################################

UO-Accessibility

Author: Sarah Becker [UO True Digital Partners]
unternehmen online GmbH & Co. KG

#################################################################################### */ 
var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");
var $b52a5343ffee21e0$var$UoAccessability = /*#__PURE__*/ function() {
    "use strict";
    function UoAccessability(argumentObject) {
        var _this = this;
        (0, $eCXNS._)(this, UoAccessability);
        console.log("UO-Accessibility: Loaded");
        //All access helpers:
        this.helper = argumentObject.helper;
        //Setting hidden class for html-anchors
        this.hiddenClass = argumentObject.hiddenClass;
        //Setting focus visible styles
        this.overwriteFocusVisibleStyles = argumentObject.overwriteFocusVisibleStyles;
        // Get the current language from the HTML head
        this.language = document.documentElement.lang || 'de';
        console.log("UO-Accessibility: Language set to ".concat(this.language));
        this.helper.forEach(function(element) {
            console.log("UO-Accessibility: Element ".concat(element.helperName[_this.language] || element.helperName['de-DE'], " added"));
        });
        if (!this.checkDom()) return false;
        this.addAnchors();
        console.log("UO-Accessibility: Anchors added");
        this.addAccessibilityNav();
        console.log("UO-Accessibility: Accessibility nav added");
        this.doOverwriteFocusVisibleStyles();
    }
    (0, $7M9bt._)(UoAccessability, [
        {
            //Add html-anchors for all access helpers (each anchor is also an screenreader-only introductory heading)
            key: "addAnchors",
            value: function addAnchors() {
                var _this = this;
                this.helper.forEach(function(element) {
                    document.querySelector(element.targetSelector).insertAdjacentHTML("beforebegin", '<span tabindex="-1" class="'.concat(_this.hiddenClass, '" id="').concat(element.anchorID, '">').concat(element.helperName[_this.language] || element.helperName['de-DE'], "</span>"));
                });
            }
        },
        {
            //Add buttons at top of page as quick-access to all the anchors
            key: "addAccessibilityNav",
            value: function addAccessibilityNav() {
                var _this = this;
                //Create new div as container
                var accessibilityNav = document.createElement("div");
                //Add content and class to new div
                accessibilityNav.innerHTML = this.helper.map(function(element) {
                    return '<a href="#'.concat(element.anchorID, '" data-target="').concat(element.anchorID, '">').concat(element.linkText[_this.language] || element.linkText['de-DE'], "</a>");
                }).join("<br />");
                accessibilityNav.classList.add("uo-accessibility-buttons");
                var allLinks = accessibilityNav.querySelectorAll('a');
                console.log("allLinks: " + allLinks);
                allLinks.forEach(function(element) {
                    console.log("element: " + element);
                    // console.log("index: "+index);
                    element.addEventListener("click", function(event) {
                        // event.preventDefault();
                        var linkTarget = element.getAttribute("data-target");
                        //console.log(linkTarget);
                        document.getElementById(linkTarget).focus();
                    });
                });
                //Insert new div at beginning of page
                var body = document.body;
                body.insertBefore(accessibilityNav, body.firstChild);
            }
        },
        {
            //Add body-class to overwrite focus-visible-styles
            key: "doOverwriteFocusVisibleStyles",
            value: function doOverwriteFocusVisibleStyles() {
                if (this.overwriteFocusVisibleStyles) {
                    document.body.classList.add("uo-accessibility-focus");
                    console.log("UO-Accessibility: Overwrite focus styles TRUE");
                } else console.log("UO-Accessibility: Overwrite focus styles FALSE");
            }
        },
        {
            /**
	 * Checks the given helpers for the existance in the dom
	 * @returns boolean depending on if all targetSelectors are found
	 */ key: "checkDom",
            value: function checkDom() {
                var checkResult = true;
                this.helper.forEach(function(element) {
                    if (!document.querySelector(element.targetSelector)) {
                        checkResult = false;
                        console.log("UO-Accessibility: targetSelector ".concat(element.targetSelector, " does not exist!"));
                    }
                });
                return checkResult;
            }
        }
    ]);
    return UoAccessability;
}();
var $b52a5343ffee21e0$export$2e2bcd8739ae039 = $b52a5343ffee21e0$var$UoAccessability;


window.$ = window.jQuery;

window.bootstrap = (parcelRequire("e4rvh"));
function $e77e57f2abfd97c1$var$contentNav() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('section.content-nav').length) {
        var loadContentNav = function loadContentNav() {
            var headerHeight1 = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('header').height();
            var secPadding = 94;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() <= 1024) {
                headerHeight1 = 0;
                secPadding = 61;
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() >= contNav.offset().top - headerHeight1) {
                (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('html').css('scroll-margin-top', contNav.height() + headerHeight1 + secPadding + "px");
                contNav.addClass('fixed');
                if (paddadded == 0) contNav.next().css("padding-top", parseInt(contNav.next().css("padding-top")) + contNavHeight);
                paddadded = 1;
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() < contNav.next().offset().top - headerHeight1) {
                (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('html').css('scroll-margin-top', headerHeight1 + secPadding + "px");
                contNav.removeClass('fixed');
                if (paddadded == 1) contNav.next().css("padding-top", parseInt(contNav.next().css("padding-top")) - contNavHeight);
                paddadded = 0;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.navbar .nav-link').each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).hasClass('active')) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).parent('li').addClass('active');
                else (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).parent('li').removeClass('active');
                var linkId = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).attr('href');
                if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() >= (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(linkId).offset().top - (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('header').height() - parseInt((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('html').css('scroll-padding-top'))) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.nav-link').not(this).removeClass('active');
                    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).addClass('active');
                }
            });
        };
        var contNav = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('section.content-nav');
        var contNavHeight = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('section.content-nav').height();
        var navPosition = contNav.offset().top;
        var customOffset = 0;
        var paddadded = 0;
        loadContentNav();
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).on('scroll', function() {
            loadContentNav();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.content-nav .navbar .mobileOverlay').on('click', function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() <= 768) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).closest('.navbar').toggleClass('clicked');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('a.nav-link').on('click', function(ev) {
            var secId = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).attr('href');
            var headerHeight1 = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('header').height();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() <= 1024) {
                headerHeight1 = 0;
                (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).closest('.navbar').toggleClass('clicked');
            }
            history.pushState({}, "", secId);
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).on('load', function() {
    $e77e57f2abfd97c1$var$contentNav();
});
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.service-teaser').length) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() < 992) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.service-teaser').on('click', function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).toggleClass('opened');
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).find('ul').slideToggle(300);
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).find('p').slideToggle(300);
        });
    }
});
function $e77e57f2abfd97c1$var$magazinNav() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.magazine-content-nav').length) {
        var loadMagazinNav = function loadMagazinNav() {
            var headerHeight1 = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('header').height();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() <= 1024) headerHeight1 = 0;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() >= contPosition - headerHeight1) magNav.addClass('fixed');
            else magNav.removeClass('fixed');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() >= (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('footer').offset().top - parseInt((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('main').css('padding-bottom')) - parseInt(magNav.css('padding-bottom')) - headerHeight1 - magNav.height()) magNav.addClass('fixed-bottom');
            else magNav.removeClass('fixed-bottom');
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('#magazine-nav .nav-link').each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).hasClass('active')) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).parent('li').addClass('active');
                else (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).parent('li').removeClass('active');
                var linkId = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).attr('href');
                if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop() >= (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(linkId).offset().top - (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('header').height() - customOffset) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.nav-link').not(this).removeClass('active');
                    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).addClass('active');
                }
            });
        };
        var magCont = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".magazine-content");
        var magNav = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.magazine-content-nav');
        var contPosition = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.magazine-content').offset().top;
        var customOffset = 100;
        loadMagazinNav();
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).on('scroll', function() {
            loadMagazinNav();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('a.nav-link').on('click', function(ev) {
            var secId = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).attr('href');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).width() <= 1024) headerHeight = 0;
            history.pushState({}, "", secId);
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(function() {
    $e77e57f2abfd97c1$var$magazinNav();
});
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).on('scroll', function() {
    var scroll = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(window).scrollTop();
    if (scroll >= 1) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".header").addClass("stick");
    else (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".header").removeClass("stick");
});
document.addEventListener("DOMContentLoaded", function(event) {
    var inputBox = document.querySelector('.search-container');
    if (document.querySelectorAll('.search-bar').length) {
        var searchIcon = document.querySelector('.search-bar');
        searchIcon.addEventListener('click', function() {
            inputBox.classList.add('open');
        });
    }
    if (document.querySelectorAll('.close-icon').length) {
        var closeIcon = document.querySelector('.close-icon');
        closeIcon.addEventListener('click', function() {
            inputBox.classList.remove('open');
        });
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.collapse').on('show.bs.collapse', function(e) {
    // hide the open one
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.collapse.show').length) (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.collapse.show').collapse('hide');
});
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col').each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).append('<div class="info"><div>' + (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this).text() + '</div></div>');
    }).on('click', function(e) {
        e.stopPropagation();
        var ele = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(this);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col').hasClass('selected')) ele.addClass('selected');
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col').hasClass('selected')) {
            if (ele.hasClass('selected')) ele.removeClass('selected');
            else {
                (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col').removeClass('selected');
                setTimeout(function() {
                    ele.addClass('selected');
                }, 500);
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(document).on('click', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col').removeClass('selected');
    });
    setTimeout(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col:nth-child(2)').addClass('hovered');
        setTimeout(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.grid .col:nth-child(2)').removeClass('hovered').trigger('click');
        }, 654);
    }, 654);
});
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(document).ready(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.toast').delay(1000).slideDown(500);
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".btn-close").on('click', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".toast").slideUp(500);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))('.toast-extarnel').delay(1000).slideDown(500);
    (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".btn-close").on('click', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(".toast-extarnel").slideUp(500);
    });
});
var $e77e57f2abfd97c1$var$popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
var $e77e57f2abfd97c1$var$popoverList = $e77e57f2abfd97c1$var$popoverTriggerList.map(function(popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
});
// prevent browser from scrolling top while typing in searchfield
// Use addEventListener to attach the event handler
var $e77e57f2abfd97c1$var$e = document.getElementById('suggestionsearchscroller');
//we.addEventListener('keypress', myFunction);
function $e77e57f2abfd97c1$var$myFunction(event) {
    // Use event.key to get the pressed key
    $e77e57f2abfd97c1$var$e.value += event.key;
// If you want to prevent the default behavior of the keypress event, you may use:
// event.preventDefault();
// Provide more context about the variable 'r' or remove it if not needed
// r = ...; // <-- You need to define what 'r' is and what you want to do with it
}
document.addEventListener("DOMContentLoaded", function() {
    var uoAccessability = new (0, $b52a5343ffee21e0$export$2e2bcd8739ae039)({
        overwriteFocusVisibleStyles: true,
        hiddenClass: "visually-hidden",
        helper: [
            {
                helperName: {
                    'de-de': "Hauptnavigation"
                },
                targetSelector: "header .hamburger",
                anchorID: "uo-target-nav",
                linkText: {
                    'de-de': "Direkt zur Hauptnavigation"
                }
            },
            {
                helperName: {
                    'de-de': "Inhalt"
                },
                targetSelector: "main",
                anchorID: "uo-target-content",
                linkText: {
                    'de-de': "Direkt zum Inhalt"
                }
            },
            {
                helperName: {
                    'de-de': "Footer"
                },
                targetSelector: "footer",
                anchorID: "uo-target-footer",
                linkText: {
                    'de-de': "Direkt zum Footer"
                }
            }
        ]
    });
});
(function() {
    var back_to_top_button = document.createElement('a');
    back_to_top_button.className = 'back_to_top';
    back_to_top_button.title = "Zur\xfcck nach oben";
    back_to_top_button.innerHTML = '&uarr;';
    document.querySelector('main').append(back_to_top_button);
    function trackScroll() {
        var scrolled = window.scrollY;
        var coords = document.documentElement.clientHeight;
        if (scrolled > coords) goTopBtn.classList.add('back_to_top-show');
        if (scrolled < coords) goTopBtn.classList.remove('back_to_top-show');
    }
    function backToTop() {
        window.scrollTo(0, 0);
    }
    var goTopBtn = document.querySelector('.back_to_top');
    window.addEventListener('scroll', trackScroll);
    goTopBtn.addEventListener('click', backToTop);
})();
(0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)))(document).ready(function() {
    // CSS für die Kontrastversion
    var contrastClass = 'contrast';
    var storageKey = 'contrastVersionEnabled';
    var labelActivate = "Kontrast erh\xf6hen";
    var labelDeactivate = "Kontrast zur\xfccksetzen";
    function toggleTheme() {
        var isEnabled = localStorage.getItem(storageKey) === 'true';
        if (isEnabled) {
            document.body.classList.remove(contrastClass);
            localStorage.setItem(storageKey, 'false');
        } else {
            document.body.classList.add(contrastClass);
            localStorage.setItem(storageKey, 'true');
        }
    }
    function toggleLabel() {
        var btn = document.getElementById('contrast-version-btn');
        var isEnabled = localStorage.getItem(storageKey) === 'true';
        if (btn) btn.textContent = isEnabled ? labelDeactivate : labelActivate;
    }
    var prefersHighContrast = window.matchMedia('(prefers-contrast: more)').matches;
    var isAlreadyEnabled = localStorage.getItem(storageKey) === 'true';
    if (prefersHighContrast || isAlreadyEnabled) {
        document.body.classList.add(contrastClass);
        localStorage.setItem(storageKey, 'true');
    }
    toggleLabel();
    var contrastBtn = document.getElementById('contrast-version-btn');
    if (contrastBtn) contrastBtn.addEventListener('click', function(event) {
        event.preventDefault();
        toggleTheme();
        toggleLabel();
    });
});



var $9OVGD = parcelRequire("9OVGD");
var $5047cd7b7e211a50$exports = {};
!function(n, t) {
    $5047cd7b7e211a50$exports = t();
}($5047cd7b7e211a50$exports, function() {
    "use strict";
    function n() {
        return n = Object.assign || function(n) {
            for(var t = 1; t < arguments.length; t++){
                var e = arguments[t];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
            }
            return n;
        }, n.apply(this, arguments);
    }
    var t = "undefined" != typeof window, e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), i = t && "IntersectionObserver" in window, o = t && "classList" in document.createElement("p"), a = t && window.devicePixelRatio > 1, r = {
        elements_selector: ".lazy",
        container: e || t ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, c = function c(t) {
        return n({}, r, t);
    }, l = function l(n, t) {
        var e, i = "LazyLoad::Initialized", o = new n(t);
        try {
            e = new CustomEvent(i, {
                detail: {
                    instance: o
                }
            });
        } catch (n) {
            (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, {
                instance: o
            });
        }
        window.dispatchEvent(e);
    }, u = "src", s = "srcset", d = "sizes", f = "poster", _ = "llOriginalAttrs", g = "data", v = "loading", b = "loaded", p = "applied", m = "error", h = "native", E = "data-", I = "ll-status", y = function y(n, t) {
        return n.getAttribute(E + t);
    }, k = function k(n) {
        return y(n, I);
    }, w = function w(n, t) {
        return function(n, t, e) {
            var i = "data-ll-status";
            null !== e ? n.setAttribute(i, e) : n.removeAttribute(i);
        }(n, 0, t);
    }, A = function A(n) {
        return w(n, null);
    }, L = function L(n) {
        return null === k(n);
    }, O = function O(n) {
        return k(n) === h;
    }, x = [
        v,
        b,
        p,
        m
    ], C = function C(n, t, e, i) {
        n && "function" == typeof n && (void 0 === i ? void 0 === e ? n(t) : n(t, e) : n(t, e, i));
    }, N = function N(n, t) {
        "" !== t && (o ? n.classList.add(t) : n.className += (n.className ? " " : "") + t);
    }, M = function M(n, t) {
        "" !== t && (o ? n.classList.remove(t) : n.className = n.className.replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }, z = function z(n) {
        return n.llTempImage;
    }, T = function T(n, t) {
        if (t) {
            var e = t._observer;
            e && e.unobserve(n);
        }
    }, R = function R(n, t) {
        n && (n.loadingCount += t);
    }, G = function G(n, t) {
        n && (n.toLoadCount = t);
    }, j = function j(n) {
        for(var t, e = [], i = 0; t = n.children[i]; i += 1)"SOURCE" === t.tagName && e.push(t);
        return e;
    }, D = function D(n, t) {
        var e = n.parentNode;
        e && "PICTURE" === e.tagName && j(e).forEach(t);
    }, H = function H(n, t) {
        j(n).forEach(t);
    }, V = [
        u
    ], F = [
        u,
        f
    ], B = [
        u,
        s,
        d
    ], J = [
        g
    ], P = function P(n) {
        return !!n[_];
    }, S = function S(n) {
        return n[_];
    }, U = function U(n) {
        return delete n[_];
    }, $ = function $(n, t) {
        if (!P(n)) {
            var e = {};
            t.forEach(function(t) {
                e[t] = n.getAttribute(t);
            }), n[_] = e;
        }
    }, q = function q(n, t) {
        if (P(n)) {
            var e = S(n);
            t.forEach(function(t) {
                !function(n, t, e) {
                    e ? n.setAttribute(t, e) : n.removeAttribute(t);
                }(n, t, e[t]);
            });
        }
    }, K = function K(n, t, e) {
        N(n, t.class_applied), w(n, p), e && (t.unobserve_completed && T(n, t), C(t.callback_applied, n, e));
    }, Q = function Q(n, t, e) {
        N(n, t.class_loading), w(n, v), e && (R(e, 1), C(t.callback_loading, n, e));
    }, W = function W(n, t, e) {
        e && n.setAttribute(t, e);
    }, X = function X(n, t) {
        W(n, d, y(n, t.data_sizes)), W(n, s, y(n, t.data_srcset)), W(n, u, y(n, t.data_src));
    }, Y = {
        IMG: function IMG(n, t) {
            D(n, function(n) {
                $(n, B), X(n, t);
            }), $(n, B), X(n, t);
        },
        IFRAME: function IFRAME(n, t) {
            $(n, V), W(n, u, y(n, t.data_src));
        },
        VIDEO: function VIDEO(n, t) {
            H(n, function(n) {
                $(n, V), W(n, u, y(n, t.data_src));
            }), $(n, F), W(n, f, y(n, t.data_poster)), W(n, u, y(n, t.data_src)), n.load();
        },
        OBJECT: function OBJECT(n, t) {
            $(n, J), W(n, g, y(n, t.data_src));
        }
    }, Z = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], nn = function nn(n, t) {
        !t || function(n) {
            return n.loadingCount > 0;
        }(t) || function(n) {
            return n.toLoadCount > 0;
        }(t) || C(n.callback_finish, t);
    }, tn = function tn(n, t, e) {
        n.addEventListener(t, e), n.llEvLisnrs[t] = e;
    }, en = function en(n, t, e) {
        n.removeEventListener(t, e);
    }, on = function on(n) {
        return !!n.llEvLisnrs;
    }, an = function an(n) {
        if (on(n)) {
            var t = n.llEvLisnrs;
            for(var e in t){
                var i = t[e];
                en(n, e, i);
            }
            delete n.llEvLisnrs;
        }
    }, rn = function rn(n, t, e) {
        !function(n) {
            delete n.llTempImage;
        }(n), R(e, -1), function(n) {
            n && (n.toLoadCount -= 1);
        }(e), M(n, t.class_loading), t.unobserve_completed && T(n, e);
    }, cn = function cn(n, t, e) {
        var i = z(n) || n;
        on(i) || function(n, t, e) {
            on(n) || (n.llEvLisnrs = {});
            var i = "VIDEO" === n.tagName ? "loadeddata" : "load";
            tn(n, i, t), tn(n, "error", e);
        }(i, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_loaded), w(t, b), C(e.callback_loaded, t, i), o || nn(e, i);
            }(0, n, t, e), an(i);
        }, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_error), w(t, m), C(e.callback_error, t, i), e.restore_on_error && q(t, B), o || nn(e, i);
            }(0, n, t, e), an(i);
        });
    }, ln = function ln(n, t, e) {
        !function(n) {
            return Z.indexOf(n.tagName) > -1;
        }(n) ? function(n, t, e) {
            !function(n) {
                n.llTempImage = document.createElement("IMG");
            }(n), cn(n, t, e), function(n) {
                P(n) || (n[_] = {
                    backgroundImage: n.style.backgroundImage
                });
            }(n), function(n, t, e) {
                var i = y(n, t.data_bg), o = y(n, t.data_bg_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = 'url("'.concat(r, '")'), z(n).setAttribute(u, r), Q(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_multi), o = y(n, t.data_bg_multi_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = r, K(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_set);
                if (i) {
                    var o = i.split("|"), a = o.map(function(n) {
                        return "image-set(".concat(n, ")");
                    });
                    n.style.backgroundImage = a.join(), "" === n.style.backgroundImage && (a = o.map(function(n) {
                        return "-webkit-image-set(".concat(n, ")");
                    }), n.style.backgroundImage = a.join()), K(n, t, e);
                }
            }(n, t, e);
        }(n, t, e) : function(n, t, e) {
            cn(n, t, e), function(n, t, e) {
                var i = Y[n.tagName];
                i && (i(n, t), Q(n, t, e));
            }(n, t, e);
        }(n, t, e);
    }, un = function un(n) {
        n.removeAttribute(u), n.removeAttribute(s), n.removeAttribute(d);
    }, sn = function sn(n) {
        D(n, function(n) {
            q(n, B);
        }), q(n, B);
    }, dn = {
        IMG: sn,
        IFRAME: function IFRAME(n) {
            q(n, V);
        },
        VIDEO: function VIDEO(n) {
            H(n, function(n) {
                q(n, V);
            }), q(n, F), n.load();
        },
        OBJECT: function OBJECT(n) {
            q(n, J);
        }
    }, fn = function fn(n, t) {
        (function(n) {
            var _$t = dn[n.tagName];
            _$t ? _$t(n) : function(n) {
                if (P(n)) {
                    var _$t = S(n);
                    n.style.backgroundImage = _$t.backgroundImage;
                }
            }(n);
        })(n), function(n, t) {
            L(n) || O(n) || (M(n, t.class_entered), M(n, t.class_exited), M(n, t.class_applied), M(n, t.class_loading), M(n, t.class_loaded), M(n, t.class_error));
        }(n, t), A(n), U(n);
    }, _n = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], gn = function gn(n) {
        return n.use_native && "loading" in HTMLImageElement.prototype;
    }, vn = function vn(n, t, e) {
        n.forEach(function(n) {
            return function(n) {
                return n.isIntersecting || n.intersectionRatio > 0;
            }(n) ? function(n, t, e, i) {
                var o = function(n) {
                    return x.indexOf(k(n)) >= 0;
                }(n);
                w(n, "entered"), N(n, e.class_entered), M(n, e.class_exited), function(n, t, e) {
                    t.unobserve_entered && T(n, e);
                }(n, e, i), C(e.callback_enter, n, t, i), o || ln(n, e, i);
            }(n.target, n, t, e) : function(n, t, e, i) {
                L(n) || (N(n, e.class_exited), function(n, t, e, i) {
                    e.cancel_on_exit && function(n) {
                        return k(n) === v;
                    }(n) && "IMG" === n.tagName && (an(n), function(n) {
                        D(n, function(n) {
                            un(n);
                        }), un(n);
                    }(n), sn(n), M(n, e.class_loading), R(i, -1), A(n), C(e.callback_cancel, n, t, i));
                }(n, t, e, i), C(e.callback_exit, n, t, i));
            }(n.target, n, t, e);
        });
    }, bn = function bn(n) {
        return Array.prototype.slice.call(n);
    }, pn = function pn(n) {
        return n.container.querySelectorAll(n.elements_selector);
    }, mn = function mn(n) {
        return function(n) {
            return k(n) === m;
        }(n);
    }, hn = function hn(n, t) {
        return function(n) {
            return bn(n).filter(L);
        }(n || pn(t));
    }, En = function En(n, e) {
        var o = c(n);
        this._settings = o, this.loadingCount = 0, function(n, t) {
            i && !gn(n) && (t._observer = new IntersectionObserver(function(e) {
                vn(e, n, t);
            }, function(n) {
                return {
                    root: n.container === document ? null : n.container,
                    rootMargin: n.thresholds || n.threshold + "px"
                };
            }(n)));
        }(o, this), function(n, e) {
            t && (e._onlineHandler = function() {
                !function(n, t) {
                    var _$e;
                    (_$e = pn(n), bn(_$e).filter(mn)).forEach(function(t) {
                        M(t, n.class_error), A(t);
                    }), t.update();
                }(n, e);
            }, window.addEventListener("online", e._onlineHandler));
        }(o, this), this.update(e);
    };
    return En.prototype = {
        update: function update(n) {
            var t, o, a = this._settings, r = hn(n, a);
            G(this, r.length), !e && i ? gn(a) ? function(n, t, e) {
                n.forEach(function(n) {
                    -1 !== _n.indexOf(n.tagName) && function(n, t, e) {
                        n.setAttribute("loading", "lazy"), cn(n, t, e), function(n, t) {
                            var _$e = Y[n.tagName];
                            _$e && _$e(n, t);
                        }(n, t), w(n, h);
                    }(n, t, e);
                }), G(e, 0);
            }(r, a, this) : (o = r, function(n) {
                n.disconnect();
            }(t = this._observer), function(n, t) {
                t.forEach(function(t) {
                    n.observe(t);
                });
            }(t, o)) : this.loadAll(r);
        },
        destroy: function destroy() {
            this._observer && this._observer.disconnect(), t && window.removeEventListener("online", this._onlineHandler), pn(this._settings).forEach(function(n) {
                U(n);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function loadAll(n) {
            var t = this, e = this._settings;
            hn(n, e).forEach(function(n) {
                T(n, t), ln(n, e, t);
            });
        },
        restoreAll: function restoreAll() {
            var n = this._settings;
            pn(n).forEach(function(t) {
                fn(t, n);
            });
        }
    }, En.load = function(n, t) {
        var e = c(t);
        ln(n, e);
    }, En.resetStatus = function(n) {
        A(n);
    }, t && function(n, t) {
        if (t) {
            if (t.length) for(var e, i = 0; e = t[i]; i += 1)l(n, e);
            else l(n, t);
        }
    }(En, window.lazyLoadOptions), En;
});


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
var $6bb211c1e0e9d3c4$var$aLazyLoad = new (0, (/*@__PURE__*/$parcel$interopDefault($5047cd7b7e211a50$exports)))({
    threshold: 0
});



var $9HFeY = parcelRequire("9HFeY");

var $9OVGD = parcelRequire("9OVGD");
var $01f9aebbda4a6fa6$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ 
var $22yUM = parcelRequire("22yUM");

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $01f9aebbda4a6fa6$exports = factory((parcelRequire("9OVGD")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function step(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function complete() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && (typeof asNavFor === "undefined" ? "undefined" : (0, $22yUM._)(asNavFor)) === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                'tabindex': '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    'role': 'presentation'
                });
                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            'tabindex': '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if ((typeof opt === "undefined" ? "undefined" : (0, $22yUM._)(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
$(window).on('load', function() {
    var autospeed = 5000;
    var speed = 1000;
    $('.hero-slider').each(function() {
        var _obj;
        $(this).slick((_obj = {
            infinite: false,
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: autospeed,
            speed: speed
        }, (0, $9HFeY._)(_obj, "infinite", true), (0, $9HFeY._)(_obj, "rows", 0), (0, $9HFeY._)(_obj, "slidesToShow", 1), (0, $9HFeY._)(_obj, "swipeToSlide", true), (0, $9HFeY._)(_obj, "pauseOnFocus", true), (0, $9HFeY._)(_obj, "pauseOnHover", true), (0, $9HFeY._)(_obj, "slidesToScroll", 1), (0, $9HFeY._)(_obj, "accessibility", true), (0, $9HFeY._)(_obj, "focusOnSelect", true), _obj));
        var heroContainer = $(this).closest('.hero-slider-container');
        $(this).on('setPosition', function(event, slick, currentSlide, nextSlide) {
            var $video = $(this).find('.slick-current video');
            if ($video.length) {
                var video = $video[0];
                slick.options.autoplaySpeed = video.duration * 1000;
                video.currentTime = 0;
                video.play();
            // Timeline: setze individuelle Übergangsdauer für Progressbar bei Video
            // let videoSlide = $(this).find('.slick-current').data('slickIndex');
            // heroContainer.find('span[data-slick-index="'+videoSlide+'"]').children('span').css({
            // 	'transition-duration': video.duration+'s'
            // });
            } else slick.options.autoplaySpeed = autospeed;
            var slideIndex = $(this).find('.slick-current').data('slickIndex');
            heroContainer.find('span:not([data-slick-index="' + slideIndex + '"])').parent().removeClass('active');
            heroContainer.find('span[data-slick-index="' + slideIndex + '"]').parent().addClass('active');
        });
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var $video = $(this).find('.slick-current video');
            if ($video.length) {
                var video = $video[0];
                video.pause();
                video.currentTime = 0;
            }
        });
        // Timeline: initial aktiven Dot markieren
        // heroContainer.find('span[data-slick-index="0"]').parent().addClass('active');
        // Timeline: setze anfängliche Progressbar-Animation
        // heroContainer.find('span[data-slick-index]').children('span').css({
        // 	'transition-duration': autospeed+'ms'
        // });
        heroContainer.find('.progressbar-container div').on('click', function() {
            var goToThisIndex = $(this).find("span").data("slickIndex");
            heroContainer.find('.slick-dots li:nth-child(' + (goToThisIndex + 1) + ')').trigger('click');
        });
    });
    $('.hero-slider-subpage').each(function() {
        $(this).slick({
            infinite: false,
            arrows: false,
            dots: false,
            autoplay: false,
            speed: 1000,
            rows: 0,
            slidesToShow: 1,
            swipeToSlide: true,
            slidesToScroll: 1,
            focusOnSelect: true,
            pauseOnFocus: true
        });
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var $currentSlide = $(slick.$slides.get(nextSlide));
            var $video = $currentSlide.find('video');
            if ($video.length) {
                var video = $video[0];
                slick.options.autoplaySpeed = video.duration * 1000;
            } else slick.options.autoplaySpeed = 3000;
        });
    });
    function enable_ratiochecker() {
        function check_16by9() {
            var videos = document.getElementsByClassName("hero-video");
            var numvideos = videos.length;
            for(var i = 0; i < numvideos; i++)if (videos[i].offsetWidth / videos[i].offsetHeight >= 16 / 9) videos[i].classList.add("ratio16by9");
            else videos[i].classList.remove("ratio16by9");
        }
        window.addEventListener('resize', function(event) {
            check_16by9();
        }, true);
        check_16by9();
    }
    if (document.getElementsByClassName("hero-video").length > 0) enable_ratiochecker();
});
$('.hero-slider').each(function() {
    var $slider = $(this);
    var isKeyboardNavigation = false;
    // Eingabemodus lokal für diesen Slider erfassen
    $slider.on('keydown', function(event) {
        if (event.key === 'Tab' || event.key === 'ArrowRight' || event.key === 'ArrowLeft') isKeyboardNavigation = true;
    });
    $slider.on('mousedown', function() {
        isKeyboardNavigation = false;
    });
    // Fokus nur setzen, wenn per Tastatur navigiert wurde
    $slider.on('afterChange', function(event, slick, currentSlide) {
        if (!isKeyboardNavigation) return;
        var $currentSlide = $(slick.$slides.get(currentSlide));
        // 1. Link im Slide fokussieren
        var $firstLink = $currentSlide.find('a').first();
        if ($firstLink.length) $firstLink.focus();
        else {
            // 2. Oder h2 fokussieren
            var $heading = $currentSlide.find('h2').first();
            if ($heading.length) {
                if (!$heading.is('[tabindex]')) $heading.attr('tabindex', '-1');
                $heading.focus();
            }
        }
    });
});



var $9OVGD = parcelRequire("9OVGD");

window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
$(function() {
    $(".news-slider").each(function() {
        $(this).slick({
            infinite: false,
            arrows: true,
            dots: true,
            draggable: true,
            autoplay: false,
            speed: 800,
            slidesToShow: 3,
            variableWidth: false,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '80px',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
});
$(window).on('resize orientationchange', function() {
    $(".news-slider").each(function() {
        $(this).slick('init');
    });
});



var $9OVGD = parcelRequire("9OVGD");

window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
$(function() {
    $(".product-slider").each(function() {
        $(this).slick({
            infinite: false,
            arrows: true,
            dots: false,
            draggable: true,
            autoplay: false,
            speed: 800,
            slidesToShow: 3,
            variableWidth: false,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '80px',
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
});
$(window).on('resize orientationchange', function() {
    $(".news-slider").each(function() {
        $(this).slick('init');
    });
});



var $9OVGD = parcelRequire("9OVGD");

window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
//custom code
var $7877d114a3ec2119$var$slideCount = $('.gallery-slider-count');
var $7877d114a3ec2119$var$slickSlide = $('.gallery-slider');
$7877d114a3ec2119$var$slickSlide.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(this).find('.gallery-slider-count').html('<span class="slideCountItem">' + i + '</span> ' + '/' + ' <span class="slideCountAll">' + slick.slideCount + '</span>');
});
$7877d114a3ec2119$var$slickSlide.slick({
    slideToShow: 1,
    fade: false,
    arrows: true,
    rows: 0,
    prevArrow: '<button type="button" class="slide-btn slide-btn-prev"><i class="icon-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slide-btn slide-btn-next"><i class="icon-angle-right"></i></button>'
});



var $9OVGD = parcelRequire("9OVGD");
/*!
 * mmenu.js
 * mmenujs.com
 *
 * Copyright (c) Fred Heusschen
 * frebsite.nl
 */ //	Core

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $2b6Uo = parcelRequire("2b6Uo");
var $2bf941da729c3db4$var$options = {
    hooks: {},
    navbar: {
        add: true,
        title: 'Menu',
        titleLink: 'parent'
    },
    slidingSubmenus: true
};
var $2bf941da729c3db4$export$2e2bcd8739ae039 = $2bf941da729c3db4$var$options;


var $3124ec199023df72$var$configs = {
    classNames: {
        divider: 'Divider',
        nolistview: 'NoListview',
        nopanel: 'NoPanel',
        panel: 'Panel',
        selected: 'Selected',
        vertical: 'Vertical'
    },
    language: null,
    panelNodetype: [
        'ul',
        'ol',
        'div'
    ],
    screenReader: {
        closeSubmenu: 'Close submenu',
        openSubmenu: 'Open submenu',
        toggleSubmenu: 'Toggle submenu'
    }
};
var $3124ec199023df72$export$2e2bcd8739ae039 = $3124ec199023df72$var$configs;


/**
 * Deep extend an object with the given defaults.
 * Note that the extended object is not a clone, meaning the original object will also be updated.
 *
 * @param 	{object}	orignl	The object to extend to.
 * @param 	{object}	dfault	The object to extend from.
 * @return	{object}			The extended "orignl" object.
 */ var $2a955d1075ee79df$export$8b58be045bf06082 = function(orignl, dfault) {
    if ($2a955d1075ee79df$export$bf9fb029d174d554(orignl) != 'object') orignl = {};
    if ($2a955d1075ee79df$export$bf9fb029d174d554(dfault) != 'object') dfault = {};
    for(var k in dfault){
        if (!dfault.hasOwnProperty(k)) continue;
        if (typeof orignl[k] == 'undefined') orignl[k] = dfault[k];
        else if ($2a955d1075ee79df$export$bf9fb029d174d554(orignl[k]) == 'object') $2a955d1075ee79df$export$8b58be045bf06082(orignl[k], dfault[k]);
    }
    return orignl;
};
var $2a955d1075ee79df$export$c69521134f103c95 = function(surface) {
    var direction = '';
    var prevPosition = null;
    surface.addEventListener('touchstart', function(evnt) {
        if (evnt.touches.length === 1) {
            direction = '';
            prevPosition = evnt.touches[0].pageY;
        }
    });
    surface.addEventListener('touchend', function(evnt) {
        if (evnt.touches.length === 0) {
            direction = '';
            prevPosition = null;
        }
    });
    surface.addEventListener('touchmove', function(evnt) {
        direction = '';
        if (prevPosition && evnt.touches.length === 1) {
            var currentPosition = evnt.changedTouches[0].pageY;
            if (currentPosition > prevPosition) direction = 'down';
            else if (currentPosition < prevPosition) direction = 'up';
            prevPosition = currentPosition;
        }
    });
    return {
        get: function() {
            return direction;
        }
    };
};
var $2a955d1075ee79df$export$bf9fb029d174d554 = function(variable) {
    return ({}).toString.call(variable).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
var $2a955d1075ee79df$export$8b15d37bc3f197d4 = function() {
    return "mm-".concat($2a955d1075ee79df$var$__id++);
};
var $2a955d1075ee79df$var$__id = 0;
var $2a955d1075ee79df$export$e901557d2458811 = function(id) {
    if (id.slice(0, 9) == 'mm-clone-') return id;
    return "mm-clone-".concat(id);
};
var $2a955d1075ee79df$export$77c7ff3a98df843b = function(id) {
    if (id.slice(0, 9) == 'mm-clone-') return id.slice(9);
    return id;
};


var $ff00179c1540dc31$var$translations = {};
var $ff00179c1540dc31$export$57bf213be019eeb0 = function() {
    return $ff00179c1540dc31$var$translations;
};
var $ff00179c1540dc31$export$e16d8520af44a096 = function(text, language) {
    if (typeof $ff00179c1540dc31$var$translations[language] === 'undefined') $ff00179c1540dc31$var$translations[language] = {};
    (0, $2a955d1075ee79df$export$8b58be045bf06082)($ff00179c1540dc31$var$translations[language], text);
};
var $ff00179c1540dc31$export$3988ae62b71be9a3 = function(text, language) {
    if (typeof language === 'string' && typeof $ff00179c1540dc31$var$translations[language] !== 'undefined') return $ff00179c1540dc31$var$translations[language][text] || text;
    return text;
};


var $0a2c51174c4fc35b$export$2e2bcd8739ae039 = {
    'Close submenu': "Untermen\xfc schlie\xdfen",
    'Menu': "Men\xfc",
    'Open submenu': "Untermen\xfc \xf6ffnen",
    'Toggle submenu': "Untermen\xfc wechseln"
};


var $116647de368c8740$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0628\u0633\u062A\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    'Menu': "\u0645\u0646\u0648",
    'Open submenu': "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    'Toggle submenu': "\u0633\u0648\u06CC\u06CC\u0686 \u0632\u06CC\u0631\u0645\u0646\u0648"
};


var $1cba2ffa24b4f0bc$export$2e2bcd8739ae039 = {
    'Close submenu': 'Submenu sluiten',
    'Menu': 'Menu',
    'Open submenu': 'Submenu openen',
    'Toggle submenu': 'Submenu wisselen'
};


var $e2db927df38dccb0$export$2e2bcd8739ae039 = {
    'Close submenu': 'Fechar submenu',
    'Menu': 'Menu',
    'Open submenu': 'Abrir submenu',
    'Toggle submenu': 'Alternar submenu'
};


var $1b3b01e4aff1c4b5$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    'Menu': "\u041C\u0435\u043D\u044E",
    'Open submenu': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    'Toggle submenu': "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E"
};


var $76dade0308cce0c0$export$2e2bcd8739ae039 = {
    'Close submenu': "Zatvori\u0165 submenu",
    'Menu': 'Menu',
    'Open submenu': "Otvori\u0165 submenu",
    'Toggle submenu': "Prepn\xfa\u0165 submenu"
};


var $cffd281947872879$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E",
    'Menu': "\u041C\u0435\u043D\u044E",
    'Open submenu': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E",
    'Toggle submenu': "\u041F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E"
};


function $7d6bddb36e88d9c4$export$2e2bcd8739ae039() {
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $0a2c51174c4fc35b$export$2e2bcd8739ae039), 'de');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $116647de368c8740$export$2e2bcd8739ae039), 'fa');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $1cba2ffa24b4f0bc$export$2e2bcd8739ae039), 'nl');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $e2db927df38dccb0$export$2e2bcd8739ae039), 'pt_br');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $1b3b01e4aff1c4b5$export$2e2bcd8739ae039), 'ru');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $76dade0308cce0c0$export$2e2bcd8739ae039), 'sk');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $cffd281947872879$export$2e2bcd8739ae039), 'uk');
}


/**
 * Create an element with classname.
 *
 * @param 	{string}		selector	The nodeName and classnames for the element to create.
 * @return	{HTMLElement}				The created element.
 */ 
var $2b6Uo = parcelRequire("2b6Uo");
var $6fd43b8bf55d8da0$export$185802fd694ee1f5 = function(selector) {
    var _elem_classList;
    var args = selector.split('.'), elem = document.createElement(args.shift());
    (_elem_classList = elem.classList).add.apply(_elem_classList, (0, $2b6Uo._)(args));
    return elem;
};
var $6fd43b8bf55d8da0$export$71aa6c912b956294 = function(element, filter) {
    return filter.length ? [].slice.call(element.querySelectorAll(filter)) : [];
};
var $6fd43b8bf55d8da0$export$bacb5cc5a11aef16 = function(element, filter) {
    var children = Array.prototype.slice.call(element.children);
    return filter ? children.filter(function(child) {
        return child.matches(filter);
    }) : children;
};
var $6fd43b8bf55d8da0$export$b3ad2b0b0d33f91a = function(element) {
    return element ? [].slice.call(element.childNodes).filter(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    }).map(function(node) {
        return node.nodeValue.trim();
    }).join(' ') : '';
};
var $6fd43b8bf55d8da0$export$6f093cfa640b7166 = function(element) {
    return [].slice.call(element.childNodes).filter(function(child) {
        return !child.ariaHidden;
    }).map(function(child) {
        return child.textContent;
    }).join(' ');
};
var $6fd43b8bf55d8da0$export$7901f6cd558b9a93 = function(element, filter) {
    /** Array of preceding elements that match the selector. */ var parents = [];
    /** Array of preceding elements that match the selector. */ var parent = element.parentElement;
    while(parent){
        parents.push(parent);
        parent = parent.parentElement;
    }
    return filter ? parents.filter(function(parent) {
        return parent.matches(filter);
    }) : parents;
};
var $6fd43b8bf55d8da0$export$5a01ccd45552d0b4 = function(element, filter) {
    /** Array of previous siblings that match the selector. */ var previous = [];
    /** Current element in the loop */ var current = element.previousElementSibling;
    while(current){
        if (!filter || current.matches(filter)) previous.push(current);
        current = current.previousElementSibling;
    }
    return previous;
};
var $6fd43b8bf55d8da0$export$cc800923e997bb8 = function(element, direction) {
    return element.getBoundingClientRect()[direction] + document.body[direction === 'left' ? 'scrollLeft' : 'scrollTop'];
};
var $6fd43b8bf55d8da0$export$72ac92c27fa3be94 = function(listitems) {
    return listitems.filter(function(listitem) {
        return !listitem.matches('.mm-hidden');
    });
};
var $6fd43b8bf55d8da0$export$f6486d4f577dfcc4 = function(listitems) {
    var anchors = [];
    $6fd43b8bf55d8da0$export$72ac92c27fa3be94(listitems).forEach(function(listitem) {
        var _anchors;
        (_anchors = anchors).push.apply(_anchors, (0, $2b6Uo._)($6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, 'a.mm-listitem__text')));
    });
    return anchors.filter(function(anchor) {
        return !anchor.matches('.mm-btn--next');
    });
};
var $6fd43b8bf55d8da0$export$9604f4b73fb157f3 = function(element, oldClass, newClass) {
    if (element.matches('.' + oldClass)) element.classList.add(newClass);
};



/** Collection of callback functions for media querys. */ var $7eb8de21b7625c44$var$listeners = {};
var $7eb8de21b7625c44$export$e16d8520af44a096 = function(query, yes, no) {
    if (typeof query == 'number') query = '(min-width: ' + query + 'px)';
    $7eb8de21b7625c44$var$listeners[query] = $7eb8de21b7625c44$var$listeners[query] || [];
    $7eb8de21b7625c44$var$listeners[query].push({
        yes: yes,
        no: no
    });
};
var $7eb8de21b7625c44$export$3db5d71bdb2d5499 = function() {
    var _loop = function(query) {
        var mqlist = window.matchMedia(query);
        $7eb8de21b7625c44$export$46ff36df9b99bc25(query, mqlist);
        mqlist.onchange = function(evnt) {
            $7eb8de21b7625c44$export$46ff36df9b99bc25(query, mqlist);
        };
    };
    for(var query in $7eb8de21b7625c44$var$listeners)_loop(query);
};
var $7eb8de21b7625c44$export$46ff36df9b99bc25 = function(query, mqlist) {
    var fn = mqlist.matches ? 'yes' : 'no';
    for(var m = 0; m < $7eb8de21b7625c44$var$listeners[query].length; m++)$7eb8de21b7625c44$var$listeners[query][m][fn]();
};



var $09042cef4d06f7c9$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
};
var $09042cef4d06f7c9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $09042cef4d06f7c9$var$_panelObserver, $09042cef4d06f7c9$var$_listviewObserver, $09042cef4d06f7c9$var$_listitemObserver;
//  Add the translations.
(0, $7d6bddb36e88d9c4$export$2e2bcd8739ae039)();
var $09042cef4d06f7c9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Mmenu(menu, options, configs) {
        (0, $eCXNS._)(this, Mmenu);
        /** MutationObserver for adding a listview to a panel. */ $09042cef4d06f7c9$var$_panelObserver.set(this, void 0);
        /** MutationObserver for adding a listitem to a listview. */ $09042cef4d06f7c9$var$_listviewObserver.set(this, void 0);
        /** MutationObserver for adding a listview to a listitem. */ $09042cef4d06f7c9$var$_listitemObserver.set(this, void 0);
        //	Extend options and configuration from defaults.
        this.opts = (0, $2a955d1075ee79df$export$8b58be045bf06082)(options, (0, $2bf941da729c3db4$export$2e2bcd8739ae039));
        this.conf = (0, $2a955d1075ee79df$export$8b58be045bf06082)(configs, (0, $3124ec199023df72$export$2e2bcd8739ae039));
        //	Methods to expose in the API.
        this._api = [
            'i18n',
            'bind',
            'openPanel',
            'closePanel',
            'setSelected'
        ];
        //	Storage objects for nodes and hooks.
        this.node = {};
        this.hook = {};
        //	Get menu node from string or element.
        this.node.menu = typeof menu == 'string' ? document.querySelector(menu) : menu;
        if (typeof this._deprecatedWarnings == 'function') this._deprecatedWarnings();
        this.trigger('init:before');
        this._initObservers();
        this._initAddons();
        this._initHooks();
        this._initAPI();
        this._initMenu();
        this._initPanels();
        this._initOpened();
        $7eb8de21b7625c44$export$3db5d71bdb2d5499();
        this.trigger('init:after');
        return this;
    }
    (0, $7M9bt._)(Mmenu, [
        {
            /**
     * Open a panel.
     * @param {HTMLElement} panel               Panel to open.
     * @param {boolean}     [animation=true]    Whether or not to use an animation.
     * @param {boolean}     [setfocus=true]     Whether or not to set focus to the panel.
     */ key: "openPanel",
            value: function openPanel(panel) {
                var animation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, setfocus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                //	Find panel.
                if (!panel) return;
                panel = panel.closest('.mm-panel');
                //	Invoke "before" hook.
                this.trigger('openPanel:before', [
                    panel,
                    {
                        animation: animation,
                        setfocus: setfocus
                    }
                ]);
                /** Wrapping listitem (for a vertical panel) */ var listitem = panel.closest('.mm-listitem--vertical');
                //	Open a "vertical" panel.
                if (listitem) {
                    listitem.classList.add('mm-listitem--opened');
                    /** The parent panel */ var parent = listitem.closest('.mm-panel');
                    this.openPanel(parent);
                //	Open a "horizontal" panel.
                } else {
                    /** Currently opened panel. */ var current = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
                    //  Ensure current panel stays on top while closing it.
                    if (panel.matches('.mm-panel--parent') && current) current.classList.add('mm-panel--highest');
                    //  Remove opened, parent, animation and highest classes from all panels.
                    var remove = [
                        'mm-panel--opened',
                        'mm-panel--parent'
                    ];
                    var add = [];
                    if (animation) remove.push('mm-panel--noanimation');
                    else add.push('mm-panel--noanimation');
                    $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel').forEach(function(pnl) {
                        var _pnl_classList, _pnl_classList1;
                        (_pnl_classList = pnl.classList).add.apply(_pnl_classList, (0, $2b6Uo._)(add));
                        (_pnl_classList1 = pnl.classList).remove.apply(_pnl_classList1, (0, $2b6Uo._)(remove));
                        if (pnl !== current) pnl.classList.remove('mm-panel--highest');
                        // Set inert attribute.
                        if (pnl === panel) pnl.removeAttribute('inert');
                        else pnl.setAttribute('inert', 'true');
                    });
                    //  Open new panel.
                    panel.classList.add('mm-panel--opened');
                    /** The parent panel */ var parent1 = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, "#".concat(panel.dataset.mmParent))[0];
                    //	Set parent panels as "parent".
                    while(parent1){
                        parent1 = parent1.closest('.mm-panel');
                        parent1.classList.add('mm-panel--parent');
                        parent1 = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, "#".concat(parent1.dataset.mmParent))[0];
                    }
                }
                //	Invoke "after" hook.
                this.trigger('openPanel:after', [
                    panel,
                    {
                        animation: animation,
                        setfocus: setfocus
                    }
                ]);
            }
        },
        {
            /**
     * Close a panel.
     * @param {HTMLElement} panel               Panel to close.
     * @param {boolean}     [animation=true]    Whether or not to use an animation.
     * @param {boolean}     [setfocus=true]     Whether or not to set focus to the panel.
     */ key: "closePanel",
            value: function closePanel(panel) {
                var animation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, setfocus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (!panel) return;
                if (!panel.matches('.mm-panel--opened') && !panel.parentElement.matches('.mm-listitem--opened')) return;
                //	Invoke "before" hook.
                this.trigger('closePanel:before', [
                    panel
                ]);
                //	Close a "vertical" panel.
                if (panel.parentElement.matches('.mm-listitem--vertical')) panel.parentElement.classList.remove('mm-listitem--opened');
                else //  ... open its parent...
                if (panel.dataset.mmParent) {
                    var parent = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, "#".concat(panel.dataset.mmParent))[0];
                    this.openPanel(parent, animation, setfocus);
                // ... or the last opened
                } else {
                    var lastPanel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--parent').pop();
                    if (lastPanel && lastPanel !== panel) this.openPanel(lastPanel, animation, setfocus);
                    else {
                        var firstPanel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel')[0];
                        if (firstPanel && firstPanel !== panel) this.openPanel(firstPanel, animation, setfocus);
                    }
                }
                //	Invoke "after" hook.
                this.trigger('closePanel:after', [
                    panel
                ]);
            }
        },
        {
            /**
     * Toggle a panel opened/closed.
     * @param {HTMLElement} panel Panel to open or close.
     */ key: "togglePanel",
            value: function togglePanel(panel) {
                var listitem = panel.parentElement;
                /** The function to invoke (open or close). */ var fn = 'openPanel';
                //	Toggle only works for "vertical" panels.
                if (listitem.matches('.mm-listitem--opened') || panel.matches('.mm-panel--opened')) fn = 'closePanel';
                this[fn](panel);
            }
        },
        {
            /**
     * Display a listitem as being "selected".
     * @param {HTMLElement} listitem Listitem to mark.
     */ key: "setSelected",
            value: function setSelected(listitem) {
                //	Invoke "before" hook.
                this.trigger('setSelected:before', [
                    listitem
                ]);
                //	Remove the selected class from all listitems.
                $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.menu, '.mm-listitem--selected').forEach(function(li) {
                    li.classList.remove('mm-listitem--selected');
                });
                //	Add the selected class to the provided listitem.
                listitem.classList.add('mm-listitem--selected');
                //	Invoke "after" hook.
                this.trigger('setSelected:after', [
                    listitem
                ]);
            }
        },
        {
            /**
     * Bind functions to a hook (subscriber).
     * @param {string} 		hook The hook.
     * @param {function} 	func The function.
     */ key: "bind",
            value: function bind(hook, func) {
                //	Create an array for the hook if it does not yet excist.
                this.hook[hook] = this.hook[hook] || [];
                //	Push the function to the array.
                this.hook[hook].push(func);
            }
        },
        {
            /**
     * Invoke the functions bound to a hook (publisher).
     * @param {string} 	hook  	The hook.
     * @param {array}	[args] 	Arguments for the function.
     */ key: "trigger",
            value: function trigger(hook, args) {
                if (this.hook[hook]) for(var h = 0, l = this.hook[hook].length; h < l; h++)this.hook[hook][h].apply(this, args);
            }
        },
        {
            /**
     * Create the observers.
     */ key: "_initObservers",
            value: function _initObservers() {
                var _this = this;
                $09042cef4d06f7c9$var$__classPrivateFieldSet(this, $09042cef4d06f7c9$var$_panelObserver, new MutationObserver(function(mutationsList) {
                    mutationsList.forEach(function(mutation) {
                        mutation.addedNodes.forEach(function(listview) {
                            if (listview.matches(_this.conf.panelNodetype.join(', '))) _this._initListview(listview);
                        });
                    });
                }));
                $09042cef4d06f7c9$var$__classPrivateFieldSet(this, $09042cef4d06f7c9$var$_listviewObserver, new MutationObserver(function(mutationsList) {
                    mutationsList.forEach(function(mutation) {
                        mutation.addedNodes.forEach(function(listitem) {
                            _this._initListitem(listitem);
                        });
                    });
                }));
                $09042cef4d06f7c9$var$__classPrivateFieldSet(this, $09042cef4d06f7c9$var$_listitemObserver, new MutationObserver(function(mutationsList) {
                    mutationsList.forEach(function(mutation) {
                        mutation.addedNodes.forEach(function(subpanel) {
                            if (subpanel === null || subpanel === void 0 ? void 0 : subpanel.matches(_this.conf.panelNodetype.join(', '))) _this._initSubPanel(subpanel);
                        });
                    });
                }));
            }
        },
        {
            /**
     * Create the API.
     */ key: "_initAPI",
            value: function _initAPI() {
                var _this = this;
                //	We need this=that because:
                //	1) the "arguments" object can not be referenced in an arrow function in ES3 and ES5.
                var that = this;
                this.API = {};
                this._api.forEach(function(fn) {
                    _this.API[fn] = function() {
                        return that[fn].apply(that, arguments); // 1)
                    };
                });
                //	Store the API in the HTML node for external usage.
                this.node.menu['mmApi'] = this.API;
            }
        },
        {
            /**
     * Bind the hooks specified in the options (publisher).
     */ key: "_initHooks",
            value: function _initHooks() {
                for(var hook in this.opts.hooks)this.bind(hook, this.opts.hooks[hook]);
            }
        },
        {
            /**
     * Initialize all available add-ons.
     */ key: "_initAddons",
            value: function _initAddons() {
                //	Invoke "before" hook.
                this.trigger('initAddons:before');
                for(var addon in Mmenu.addons)Mmenu.addons[addon].call(this);
                //	Invoke "after" hook.
                this.trigger('initAddons:after');
            }
        },
        {
            /**
     * Initialize the menu.
     */ key: "_initMenu",
            value: function _initMenu() {
                var _this = this;
                //	Invoke "before" hook.
                this.trigger('initMenu:before');
                //	Add class to the wrapper.
                this.node.wrpr = this.node.wrpr || this.node.menu.parentElement;
                this.node.wrpr.classList.add('mm-wrapper');
                //	Add class to the menu.
                this.node.menu.classList.add('mm-menu');
                //	Add an ID to the menu if it does not yet have one.
                this.node.menu.id = this.node.menu.id || (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
                this.node.menu.setAttribute('aria-label', this.i18n(this.opts.navbar.title || 'Menu'));
                this.node.menu.setAttribute('aria-modal', 'true');
                this.node.menu.setAttribute('role', 'dialog');
                /** All panel nodes in the menu. */ var panels = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.menu).filter(function(panel) {
                    return panel.matches(_this.conf.panelNodetype.join(', '));
                });
                //	Wrap the panels in a node.
                this.node.pnls = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-panels');
                this.node.menu.append(this.node.pnls);
                //  Initiate all panel like nodes
                panels.forEach(function(panel) {
                    _this._initPanel(panel);
                });
                //	Invoke "after" hook.
                this.trigger('initMenu:after');
            }
        },
        {
            /**
     * Initialize panels.
     */ key: "_initPanels",
            value: function _initPanels() {
                var _this = this;
                //	Invoke "before" hook.
                this.trigger('initPanels:before');
                //	Open / close panels.
                this.node.menu.addEventListener('click', function(event) {
                    var _a, _b;
                    /** The href attribute for the clicked anchor. */ var href = ((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a[href]')) === null || _b === void 0 ? void 0 : _b.getAttribute('href')) || '';
                    if (href.slice(0, 1) === '#') try {
                        /** The targeted panel */ var panel = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.menu, href)[0];
                        if (panel) {
                            event.preventDefault();
                            _this.togglePanel(panel);
                        }
                    } catch (err) {}
                }, {
                    // useCapture to ensure the logical order.
                    capture: true
                });
                //	Invoke "after" hook.
                this.trigger('initPanels:after');
            }
        },
        {
            /**
     * Initialize a single panel.
     * @param  {HTMLElement} 		panel 	Panel to initialize.
     * @return {HTMLElement|null} 			Initialized panel.
     */ key: "_initPanel",
            value: function _initPanel(panel) {
                var _this = this;
                var _a;
                if (panel.matches('.mm-panel')) return;
                //	Refactor panel classnames
                $6fd43b8bf55d8da0$export$9604f4b73fb157f3(panel, this.conf.classNames.panel, 'mm-panel');
                $6fd43b8bf55d8da0$export$9604f4b73fb157f3(panel, this.conf.classNames.nopanel, 'mm-nopanel');
                //	Stop if not supposed to be a panel.
                if (panel.matches('.mm-nopanel')) return;
                //	Invoke "before" hook.
                this.trigger('initPanel:before', [
                    panel
                ]);
                //  Must have an ID
                panel.id = panel.id || (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
                //	Wrap UL/OL in DIV
                if (panel.matches('ul, ol')) {
                    /** The panel. */ var wrapper = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div');
                    //  Transport the ID
                    wrapper.id = panel.id;
                    panel.removeAttribute('id');
                    //  Transport "mm-" prefixed classnames.
                    [].slice.call(panel.classList).filter(function(classname) {
                        return classname.slice(0, 3) === 'mm-';
                    }).forEach(function(classname) {
                        wrapper.classList.add(classname);
                        panel.classList.remove(classname);
                    });
                    //  Transport "mm" prefixed data attributes.
                    Object.keys(panel.dataset).filter(function(attr) {
                        return attr.slice(0, 2) === 'mm';
                    }).forEach(function(attr) {
                        wrapper.dataset[attr] = panel.dataset[attr];
                        delete panel.dataset[attr];
                    });
                    //	Wrap the listview in the panel.
                    panel.before(wrapper);
                    wrapper.append(panel);
                    panel = wrapper;
                }
                panel.classList.add('mm-panel');
                //  Append to the panels node if not vertically expanding
                if (!((_a = panel.parentElement) === null || _a === void 0 ? void 0 : _a.matches('.mm-listitem--vertical'))) this.node.pnls.append(panel);
                //  Initialize tha navbar.
                this._initNavbar(panel);
                //  Initialize the listview(s).
                $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, 'ul, ol').forEach(function(listview) {
                    _this._initListview(listview);
                });
                // Observe the panel for added listviews.
                $09042cef4d06f7c9$var$__classPrivateFieldGet(this, $09042cef4d06f7c9$var$_panelObserver).observe(panel, {
                    childList: true
                });
                //	Invoke "after" hook.
                this.trigger('initPanel:after', [
                    panel
                ]);
                return panel;
            }
        },
        {
            /**
     * Initialize a navbar.
     * @param {HTMLElement} panel Panel for the navbar.
     */ key: "_initNavbar",
            value: function _initNavbar(panel) {
                //	Only one navbar per panel.
                if ($6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, '.mm-navbar').length) return;
                /** The parent listitem. */ var parentListitem = null;
                /** The parent panel. */ var parentPanel = null;
                //  The parent listitem and parent panel
                if (panel.dataset.mmParent) {
                    parentListitem = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, "#".concat(panel.dataset.mmParent))[0];
                    parentPanel = parentListitem.closest('.mm-panel');
                    while(parentPanel.closest('.mm-listitem--vertical'))parentPanel = parentPanel.parentElement.closest('.mm-panel');
                }
                //  No navbar needed for vertical submenus.
                if (parentListitem === null || parentListitem === void 0 ? void 0 : parentListitem.matches('.mm-listitem--vertical')) return;
                //	Invoke "before" hook.
                this.trigger('initNavbar:before', [
                    panel
                ]);
                /** The navbar element. */ var navbar = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-navbar');
                //  Hide navbar if specified in options.
                if (!this.opts.navbar.add) navbar.classList.add('mm-hidden');
                //  Add the back button.
                if (parentPanel) {
                    /** The back button. */ var prev = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-btn.mm-btn--prev.mm-navbar__btn');
                    prev.href = "#".concat(parentPanel.id);
                    prev.setAttribute('aria-label', this.i18n(this.conf.screenReader.closeSubmenu));
                    navbar.append(prev);
                }
                /** The anchor that opens the panel. */ var opener = null;
                //  The anchor is in a listitem.
                if (parentListitem) opener = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(parentListitem, '.mm-listitem__text')[0];
                else if (parentPanel) opener = $6fd43b8bf55d8da0$export$71aa6c912b956294(parentPanel, 'a[href="#' + panel.id + '"]')[0];
                //  Add the title.
                /** The title */ var title = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-navbar__title');
                title.tabIndex = -1;
                title.setAttribute('aria-hidden', 'true');
                switch(this.opts.navbar.titleLink){
                    case 'anchor':
                        if (opener) title.href = opener.getAttribute('href');
                        break;
                    case 'parent':
                        if (parentPanel) title.href = "#".concat(parentPanel.id);
                        break;
                }
                /** Text in the title */ var titleText = $6fd43b8bf55d8da0$export$185802fd694ee1f5('span');
                titleText.innerHTML = panel.dataset.mmTitle || $6fd43b8bf55d8da0$export$b3ad2b0b0d33f91a(opener) || this.i18n(this.opts.navbar.title || 'Menu');
                //  Add to DOM
                panel.prepend(navbar);
                navbar.append(title);
                title.append(titleText);
                //	Invoke "after" hook.
                this.trigger('initNavbar:after', [
                    panel
                ]);
            }
        },
        {
            /**
     * Initialize a listview.
     * @param {HTMLElement} listview Listview to initialize.
     */ key: "_initListview",
            value: function _initListview(listview) {
                var _this = this;
                //  Assert UL
                if (![
                    'htmlulistelement',
                    'htmlolistelement'
                ].includes((0, $2a955d1075ee79df$export$bf9fb029d174d554)(listview))) return;
                if (listview.matches('.mm-listview')) return;
                $6fd43b8bf55d8da0$export$9604f4b73fb157f3(listview, this.conf.classNames.nolistview, 'mm-nolistview');
                if (listview.matches('.mm-nolistview')) return;
                //	Invoke "before" hook.
                this.trigger('initListview:before', [
                    listview
                ]);
                listview.classList.add('mm-listview');
                //  Initiate the listitem(s).
                $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listview).forEach(function(listitem) {
                    _this._initListitem(listitem);
                });
                // Observe the listview for added listitems.
                $09042cef4d06f7c9$var$__classPrivateFieldGet(this, $09042cef4d06f7c9$var$_listviewObserver).observe(listview, {
                    childList: true
                });
                //	Invoke "after" hook.
                this.trigger('initListview:after', [
                    listview
                ]);
            }
        },
        {
            /**
     * Initialte a listitem.
     * @param {HTMLElement} listitem Listitem to initiate.
     */ key: "_initListitem",
            value: function _initListitem(listitem) {
                var _this = this;
                //  Assert LI
                if (![
                    'htmllielement'
                ].includes((0, $2a955d1075ee79df$export$bf9fb029d174d554)(listitem))) return;
                if (listitem.matches('.mm-listitem')) return;
                $6fd43b8bf55d8da0$export$9604f4b73fb157f3(listitem, this.conf.classNames.divider, 'mm-divider');
                if (listitem.matches('.mm-divider')) return;
                //	Invoke "before" hook.
                this.trigger('initListitem:before', [
                    listitem
                ]);
                listitem.classList.add('mm-listitem');
                $6fd43b8bf55d8da0$export$9604f4b73fb157f3(listitem, this.conf.classNames.selected, 'mm-listitem--selected');
                $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, 'a, span').forEach(function(text) {
                    text.classList.add('mm-listitem__text');
                });
                //  Initiate the subpanel.
                $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, this.conf.panelNodetype.join(', ')).forEach(function(subpanel) {
                    _this._initSubPanel(subpanel);
                });
                // Observe the listitem for added listviews.
                $09042cef4d06f7c9$var$__classPrivateFieldGet(this, $09042cef4d06f7c9$var$_listitemObserver).observe(listitem, {
                    childList: true
                });
                //	Invoke "after" hook.
                this.trigger('initListitem:after', [
                    listitem
                ]);
            }
        },
        {
            /**
     * Initiate a subpanel.
     * @param {HTMLElement} subpanel Subpanel to initiate.
     */ key: "_initSubPanel",
            value: function _initSubPanel(subpanel) {
                if (subpanel.matches('.mm-panel')) return;
                /** The parent element for the panel. */ var listitem = subpanel.parentElement;
                /** Whether or not the listitem expands vertically */ var vertical = subpanel.matches('.' + this.conf.classNames.vertical) || !this.opts.slidingSubmenus;
                // Make it expand vertically
                if (vertical) listitem.classList.add('mm-listitem--vertical');
                //  Force an ID
                listitem.id = listitem.id || (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
                subpanel.id = subpanel.id || (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
                //  Store parent/child relation
                listitem.dataset.mmChild = subpanel.id;
                subpanel.dataset.mmParent = listitem.id;
                /** The open link. */ var button = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, '.mm-btn')[0];
                //  Init item text
                if (!button) {
                    button = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-btn.mm-btn--next.mm-listitem__btn');
                    $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, 'a, span').forEach(function(text) {
                        //  If the item has no link,
                        //      Replace the item with the open link.
                        if (text.matches('span')) {
                            button.classList.add('mm-listitem__text');
                            button.innerHTML = text.innerHTML;
                            listitem.insertBefore(button, text.nextElementSibling);
                            text.remove();
                        } else listitem.insertBefore(button, text.nextElementSibling);
                    });
                    button.setAttribute('aria-label', this.i18n(this.conf.screenReader[listitem.matches('.mm-listitem--vertical') ? 'toggleSubmenu' : 'openSubmenu']));
                }
                button.href = "#".concat(subpanel.id);
                this._initPanel(subpanel);
            }
        },
        {
            /**
     * Find and open the correct panel after creating the menu.
     */ key: "_initOpened",
            value: function _initOpened() {
                //	Invoke "before" hook.
                this.trigger('initOpened:before');
                /** The selected listitem(s). */ var listitem = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, '.mm-listitem--selected').pop();
                /**	The current opened panel. */ var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel')[0];
                if (listitem) {
                    this.setSelected(listitem);
                    panel = listitem.closest('.mm-panel');
                }
                //	Open the current opened panel.
                this.openPanel(panel, false, false);
                //	Invoke "after" hook.
                this.trigger('initOpened:after');
            }
        },
        {
            /**
     * Get the translation for a text.
     * @param  {string}     text 	Text to translate.
     * @return {string}		        The translated text.
     */ key: "i18n",
            value: function i18n1(text) {
                return $ff00179c1540dc31$export$3988ae62b71be9a3(text, this.conf.language);
            }
        }
    ], [
        {
            key: "i18n",
            value: /**
     * Get all translations for the given language.
     * @return {object}	The translations.
     */ function i18n1() {
                var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
                if (text && language) $ff00179c1540dc31$export$e16d8520af44a096(text, language);
                else return $ff00179c1540dc31$export$57bf213be019eeb0();
            }
        }
    ]);
    return Mmenu;
}();
$09042cef4d06f7c9$var$_panelObserver = new WeakMap(), $09042cef4d06f7c9$var$_listviewObserver = new WeakMap(), $09042cef4d06f7c9$var$_listitemObserver = new WeakMap();
/**	Available add-ons for the plugin. */ $09042cef4d06f7c9$export$2e2bcd8739ae039.addons = {};
/**	Globally used HTML elements. */ $09042cef4d06f7c9$export$2e2bcd8739ae039.node = {};
/** Globally used v. */ $09042cef4d06f7c9$export$2e2bcd8739ae039.vars = {};



var $64c79094a8a0298b$var$options = {
    use: true,
    position: 'left'
};
var $64c79094a8a0298b$export$2e2bcd8739ae039 = $64c79094a8a0298b$var$options;


var $0d7c6d73bc557c3e$var$configs = {
    clone: false,
    menu: {
        insertMethod: 'append',
        insertSelector: 'body'
    },
    page: {
        nodetype: 'div',
        selector: null,
        noSelector: []
    },
    screenReader: {
        closeMenu: 'Close menu',
        openMenu: 'Open menu'
    }
};
var $0d7c6d73bc557c3e$export$2e2bcd8739ae039 = $0d7c6d73bc557c3e$var$configs;




var $387f1e4ffbbbf6b5$var$possiblePositions = [
    'left',
    'left-front',
    'right',
    'right-front',
    'top',
    'bottom'
];
function $387f1e4ffbbbf6b5$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.offCanvas = this.opts.offCanvas || {};
    this.conf.offCanvas = this.conf.offCanvas || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.offCanvas, (0, $64c79094a8a0298b$export$2e2bcd8739ae039));
    var configs = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.conf.offCanvas, (0, $0d7c6d73bc557c3e$export$2e2bcd8739ae039));
    if (!options.use) return;
    if (!$387f1e4ffbbbf6b5$var$possiblePositions.includes(options.position)) options.position = $387f1e4ffbbbf6b5$var$possiblePositions[0];
    //	Add methods to the API.
    this._api.push('open', 'close', 'setPage', 'position');
    //  Clone menu if needed.
    if (configs.clone) {
        //	Clone the original menu and store it.
        this.node.menu = this.node.menu.cloneNode(true);
        //	Prefix all ID's in the cloned menu.
        if (this.node.menu.id) this.node.menu.id = (0, $2a955d1075ee79df$export$e901557d2458811)(this.node.menu.id);
        $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.menu, '[id]').forEach(function(elem) {
            elem.id = (0, $2a955d1075ee79df$export$e901557d2458811)(elem.id);
        });
    }
    //  Prepend the menu to the <body>.
    this.bind('initMenu:before', function() {
        _this.node.wrpr = document.querySelector(configs.menu.insertSelector);
        _this.node.wrpr[configs.menu.insertMethod](_this.node.menu);
    });
    //	Setup the UI blocker.
    if (!(0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.blck) this.bind('initMenu:before', function() {
        /** The UI blocker node. */ var blocker = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-wrapper__blocker.mm-blocker.mm-slideout');
        blocker.id = (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
        blocker.setAttribute('aria-label', _this.i18n(configs.screenReader.closeMenu));
        blocker.setAttribute('inert', 'true');
        //	Append the blocker node to the body.
        document.querySelector(configs.menu.insertSelector).append(blocker);
        //	Store the blocker node.
        (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.blck = blocker;
    });
    this.bind('initMenu:after', function() {
        //	Setup the page.
        _this.setPage((0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page);
        //	Setup the menu.
        _this.node.menu.classList.add('mm-menu--offcanvas');
        _this.node.menu.setAttribute('inert', 'true');
        if ($387f1e4ffbbbf6b5$var$possiblePositions.includes(options.position)) {
            _this.node.wrpr.classList.add("mm-wrapper--position-".concat(options.position));
            _this.node.menu.classList.add("mm-menu--position-".concat(options.position));
        }
        //	Open if url hash equals menu id (usefull when user clicks the hamburger icon before the menu is created)
        var hash = window.location.hash;
        if (hash) {
            var id = (0, $2a955d1075ee79df$export$77c7ff3a98df843b)(_this.node.menu.id);
            if (id && id == hash.slice(1)) setTimeout(function() {
                _this.open();
            }, 1000);
        }
    });
    //	Open / close the menu.
    document.addEventListener('click', function(event) {
        var _a;
        /** THe href attribute for the clicked anchor. */ var href = (_a = event.target.closest('a')) === null || _a === void 0 ? void 0 : _a.getAttribute('href');
        switch(href){
            //	Open menu if the clicked anchor links to the menu.
            case "#".concat((0, $2a955d1075ee79df$export$77c7ff3a98df843b)(_this.node.menu.id)):
                event.preventDefault();
                _this.open();
                break;
            //	Close menu if the clicked anchor links to the page.
            case "#".concat((0, $2a955d1075ee79df$export$77c7ff3a98df843b)((0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page.id)):
                event.preventDefault();
                _this.close();
                break;
        }
    });
    //	Close the menu with ESC key.
    document.addEventListener('keyup', function(event) {
        if (event.key == 'Escape') _this.close();
    });
}
/**
 * Open the menu.
 */ (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).prototype.open = function() {
    if (this.node.menu.matches('.mm-menu--opened')) return;
    //	Invoke "before" hook.
    this.trigger('open:before');
    //	Open
    this.node.wrpr.classList.add('mm-wrapper--opened', "mm-wrapper--position-".concat(this.opts.offCanvas.position));
    this.node.menu.classList.add('mm-menu--opened');
    this.node.menu.removeAttribute('inert');
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.blck.removeAttribute('inert');
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page.setAttribute('inert', 'true');
    //  Store the last focesed element.
    this.node.open = document.activeElement;
    //	Invoke "after" hook.
    this.trigger('open:after');
};
/**
 * Close the menu.
 */ (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).prototype.close = function() {
    var _a;
    if (!this.node.menu.matches('.mm-menu--opened')) return;
    //	Invoke "before" hook.
    this.trigger('close:before');
    this.node.wrpr.classList.remove('mm-wrapper--opened', "mm-wrapper--position-".concat(this.opts.offCanvas.position));
    this.node.menu.classList.remove('mm-menu--opened');
    this.node.menu.setAttribute('inert', 'true');
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.blck.setAttribute('inert', 'true');
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
    /** Element to focus. */ var focus = this.node.open || document.querySelector('[href="#'.concat(this.node.menu.id, '"]')) || null;
    (_a = focus) === null || _a === void 0 || _a.focus();
    // Prevent html/body from scrolling due to focus.
    document.body.scrollLeft = 0;
    document.documentElement.scrollLeft = 0;
    //	Invoke "after" hook.
    this.trigger('close:after');
};
/**
 * Set the "page" node.
 *
 * @param {HTMLElement} page Element to set as the page.
 */ (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).prototype.setPage = function(page) {
    /** Offcanvas config */ var configs = this.conf.offCanvas;
    //	If no page was specified, find it.
    if (!page) {
        /** Array of elements that are / could be "the page". */ var pages = typeof configs.page.selector == 'string' ? $6fd43b8bf55d8da0$export$71aa6c912b956294(document.body, configs.page.selector) : $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(document.body, configs.page.nodetype);
        //	Filter out elements that are absolutely not "the page".
        pages = pages.filter(function(page) {
            return !page.matches('.mm-menu, .mm-wrapper__blocker');
        });
        //	Filter out elements that are configured to not be "the page".
        if (configs.page.noSelector.length) pages = pages.filter(function(page) {
            return !page.matches(configs.page.noSelector.join(', '));
        });
        //	Wrap multiple pages in a single element.
        if (pages.length > 1) {
            var wrapper = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div');
            pages[0].before(wrapper);
            pages.forEach(function(page) {
                wrapper.append(page);
            });
            pages = [
                wrapper
            ];
        }
        page = pages[0];
    }
    //	Invoke "before" hook.
    this.trigger('setPage:before', [
        page
    ]);
    //  Set the classes
    page.classList.add('mm-page', 'mm-slideout');
    //  Set the ID.
    page.id = page.id || (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
    //	Sync the blocker to target the page.
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.blck.setAttribute('href', "#".concat(page.id));
    //	Store the page node.
    (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page = page;
    //	Invoke "after" hook.
    this.trigger('setPage:after', [
        page
    ]);
};


var $3467806f48ba94f5$var$options = {
    fix: true
};
var $3467806f48ba94f5$export$2e2bcd8739ae039 = $3467806f48ba94f5$var$options;



/** Whether or not touch gestures are supported by the browser. */ var $3cc8baf6108a5db3$export$d0b7ea69ab6056df = 'ontouchstart' in window || (navigator.msMaxTouchPoints ? true : false) || false;



function $f2e6597f1bda7372$export$2e2bcd8739ae039() {
    var _this = this;
    //	The scrollBugFix add-on fixes a scrolling bug
    //		1) on touch devices
    //		2) in an off-canvas menu
    if (!$3cc8baf6108a5db3$export$d0b7ea69ab6056df || // 1
    !this.opts.offCanvas.use // 2
    ) return;
    this.opts.scrollBugFix = this.opts.scrollBugFix || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.scrollBugFix, (0, $3467806f48ba94f5$export$2e2bcd8739ae039));
    if (!options.fix) return;
    /** The touch-direction instance. */ var touchDir = (0, $2a955d1075ee79df$export$c69521134f103c95)(this.node.menu);
    //  Prevent the page from scrolling when scrolling in the menu.
    this.node.menu.addEventListener('scroll', function(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
    }, {
        //  Make sure to tell the browser the event will be prevented.
        passive: false
    });
    //  Prevent the page from scrolling when dragging in the menu.
    this.node.menu.addEventListener('touchmove', function(evnt) {
        var wrapper = evnt.target.closest('.mm-panel, .mm-iconbar__top, .mm-iconbar__bottom');
        if (wrapper && wrapper.closest('.mm-listitem--vertical')) wrapper = $6fd43b8bf55d8da0$export$7901f6cd558b9a93(wrapper, '.mm-panel').pop();
        if (wrapper) {
            //  When dragging a non-scrollable panel/iconbar,
            //      we can simply stopPropagation.
            if (wrapper.scrollHeight === wrapper.offsetHeight) evnt.stopPropagation();
            else if (//  When scrolled up and dragging down
            wrapper.scrollTop == 0 && touchDir.get() == 'down' || //  When scrolled down and dragging up
            wrapper.scrollHeight == wrapper.scrollTop + wrapper.offsetHeight && touchDir.get() == 'up') evnt.stopPropagation();
        //  When dragging anything other than a panel/iconbar.
        } else evnt.stopPropagation();
    }, {
        //  Make sure to tell the browser the event can be prevented.
        passive: false
    });
    //  Some small additional improvements
    //	Scroll the current opened panel to the top when opening the menu.
    this.bind('open:after', function() {
        var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--opened')[0];
        if (panel) panel.scrollTop = 0;
    });
    //	Fix issue after device rotation change.
    window.addEventListener('orientationchange', function(evnt) {
        var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--opened')[0];
        if (panel) {
            panel.scrollTop = 0;
            //	Apparently, changing the overflow-scrolling property triggers some event :)
            panel.style['-webkit-overflow-scrolling'] = 'auto';
            panel.style['-webkit-overflow-scrolling'] = 'touch';
        }
    });
}



var $c4ac94e7c296475f$var$options = 'light';
var $c4ac94e7c296475f$export$2e2bcd8739ae039 = $c4ac94e7c296475f$var$options;


/** A list of available themes. */ var $ff3c174c287bd9e1$var$possibleThemes = [
    'light',
    'dark',
    'white',
    'black',
    'light-contrast',
    'dark-contrast',
    'white-contrast',
    'black-contrast'
];
function $ff3c174c287bd9e1$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.theme = this.opts.theme || (0, $c4ac94e7c296475f$export$2e2bcd8739ae039);
    var theme = this.opts.theme;
    if (!$ff3c174c287bd9e1$var$possibleThemes.includes(theme)) this.opts.theme = $ff3c174c287bd9e1$var$possibleThemes[0];
    this._api.push('theme');
    this.bind('initMenu:after', function() {
        _this.theme(_this.opts.theme);
    });
}
/**
 * Get or set the theme for the menu.
 *
 * @param {string} [position] The theme for the menu.
 */ (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).prototype.theme = function() {
    var theme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    /** The previously used theme */ var oldTheme = this.opts.theme;
    if (theme) {
        if ($ff3c174c287bd9e1$var$possibleThemes.includes(theme)) {
            this.node.menu.classList.remove("mm-menu--theme-".concat(oldTheme));
            this.node.menu.classList.add("mm-menu--theme-".concat(theme));
            this.opts.theme = theme;
        }
    } else return oldTheme;
};


var $d5fee348090cf027$var$options = {
    close: false,
    open: false
};
var $d5fee348090cf027$export$2e2bcd8739ae039 = $d5fee348090cf027$var$options;




function $b62988ab217aed9a$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.backButton = this.opts.backButton || {};
    if (!this.opts.offCanvas.use) return;
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.backButton, (0, $d5fee348090cf027$export$2e2bcd8739ae039));
    var _menu = "#".concat(this.node.menu.id);
    //	Close menu
    if (options.close) {
        var states = [];
        var setStates = function() {
            states = [
                _menu
            ];
            $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--opened, .mm-panel--parent').forEach(function(panel) {
                states.push('#' + panel.id);
            });
        };
        this.bind('open:after', function() {
            history.pushState(null, '', location.pathname + location.search + _menu);
        });
        this.bind('open:after', setStates);
        this.bind('openPanel:after', setStates);
        this.bind('close:after', function() {
            states = [];
            history.back();
            history.pushState(null, '', location.pathname + location.search);
        });
        window.addEventListener('popstate', function() {
            if (_this.node.menu.matches('.mm-menu--opened')) {
                if (states.length) {
                    states = states.slice(0, -1);
                    var hash = states[states.length - 1];
                    if (hash == _menu) _this.close();
                    else {
                        _this.openPanel(_this.node.menu.querySelector(hash));
                        history.pushState(null, '', location.pathname + location.search + _menu);
                    }
                }
            }
        });
    }
    if (options.open) window.addEventListener('popstate', function(evnt) {
        if (!_this.node.menu.matches('.mm-menu--opened') && location.hash == _menu) _this.open();
    });
}



var $2b6Uo = parcelRequire("2b6Uo");
var $80e7508473fb834c$var$options = {
    add: false
};
var $80e7508473fb834c$export$2e2bcd8739ae039 = $80e7508473fb834c$var$options;




function $ecb550e06b69415b$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.counters = this.opts.counters || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.counters, (0, $80e7508473fb834c$export$2e2bcd8739ae039));
    if (!options.add) return;
    /**
     * Counting the visible listitems and setting it to the counter element.
     * @param {HTMLElement} panel Panel to count LIs in.
     */ var count = function(panel) {
        /** Parent panel for the mutated listitem. */ var parent = _this.node.pnls.querySelector("#".concat(panel.dataset.mmParent));
        if (!parent) return;
        /** The counter for the listitem. */ var counter = parent.querySelector('.mm-counter');
        if (!counter) return;
        /** The listitems */ var listitems = [];
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, '.mm-listview').forEach(function(listview) {
            var _listitems;
            (_listitems = listitems).push.apply(_listitems, (0, $2b6Uo._)($6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listview, '.mm-listitem')));
        });
        counter.innerHTML = $6fd43b8bf55d8da0$export$72ac92c27fa3be94(listitems).length.toString();
    };
    /** Mutation observer the the listitems. */ var listitemObserver = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.attributeName == 'class') count(mutation.target.closest('.mm-panel'));
        });
    });
    //	Add the counters after a listview is initiated.
    this.bind('initListview:after', function(listview) {
        /** The panel where the listview is in. */ var panel = listview.closest('.mm-panel');
        /** The parent LI for the panel */ var parent = _this.node.pnls.querySelector("#".concat(panel.dataset.mmParent));
        if (!parent) return;
        /** The button inside the parent LI */ var button = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(parent, '.mm-btn')[0];
        if (!button) return;
        //	Check if no counter already excists.
        if (!$6fd43b8bf55d8da0$export$bacb5cc5a11aef16(button, '.mm-counter').length) {
            /** The counter for the listitem. */ var counter = $6fd43b8bf55d8da0$export$185802fd694ee1f5('span.mm-counter');
            counter.setAttribute('aria-hidden', 'true');
            button.prepend(counter);
        }
        //  Count immediately.
        count(panel);
    });
    //  Count when LI classname changes.
    this.bind('initListitem:after', function(listitem) {
        /** The panel where the listitem is in. */ var panel = listitem.closest('.mm-panel');
        if (!panel) return;
        /** The parent LI for the panel. */ var parent = _this.node.pnls.querySelector("#".concat(panel.dataset.mmParent));
        if (!parent) return;
        listitemObserver.observe(listitem, {
            attributes: true
        });
    });
}


var $b210f630188f47b9$var$options = {
    use: false,
    top: [],
    bottom: [],
    position: 'left',
    type: 'default'
};
var $b210f630188f47b9$export$2e2bcd8739ae039 = $b210f630188f47b9$var$options;





function $a51654911df513dc$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.iconbar = this.opts.iconbar || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.iconbar, (0, $b210f630188f47b9$export$2e2bcd8739ae039));
    if (!options.use) return;
    var iconbar;
    [
        'top',
        'bottom'
    ].forEach(function(position, n) {
        var ctnt = options[position];
        //	Extend shorthand options
        if ((0, $2a955d1075ee79df$export$bf9fb029d174d554)(ctnt) != 'array') ctnt = [
            ctnt
        ];
        //	Create node
        var part = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-iconbar__' + position);
        //	Add content
        for(var c = 0, l = ctnt.length; c < l; c++)if (typeof ctnt[c] == 'string') part.innerHTML += ctnt[c];
        else part.append(ctnt[c]);
        if (part.children.length) {
            if (!iconbar) iconbar = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-iconbar');
            iconbar.append(part);
        }
    });
    //	Add to menu
    if (iconbar) {
        //	Add the iconbar.
        this.bind('initMenu:after', function() {
            _this.node.menu.prepend(iconbar);
        });
        //	En-/disable the iconbar.
        var classname = 'mm-menu--iconbar-' + options.position;
        var enable = function() {
            _this.node.menu.classList.add(classname);
        };
        var disable = function() {
            _this.node.menu.classList.remove(classname);
        };
        if (typeof options.use == 'boolean') this.bind('initMenu:after', enable);
        else $7eb8de21b7625c44$export$e16d8520af44a096(options.use, enable, disable);
        //	Tabs
        if (options.type == 'tabs') {
            iconbar.classList.add('mm-iconbar--tabs');
            iconbar.addEventListener('click', function(evnt) {
                var anchor = evnt.target.closest('.mm-iconbar__tab');
                if (!anchor) return;
                if (anchor.matches('.mm-iconbar__tab--selected')) {
                    evnt.stopImmediatePropagation();
                    return;
                }
                try {
                    var panel = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.menu, "".concat(anchor.getAttribute('href'), ".mm-panel"))[0];
                    if (panel) {
                        evnt.preventDefault();
                        evnt.stopImmediatePropagation();
                        _this.openPanel(panel, false);
                    }
                } catch (err) {}
            });
            var selectTab = function(panel) {
                $6fd43b8bf55d8da0$export$71aa6c912b956294(iconbar, 'a').forEach(function(anchor) {
                    anchor.classList.remove('mm-iconbar__tab--selected');
                });
                var anchor = $6fd43b8bf55d8da0$export$71aa6c912b956294(iconbar, '[href="#' + panel.id + '"]')[0];
                if (anchor) anchor.classList.add('mm-iconbar__tab--selected');
                else {
                    var parent = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.pnls, "#".concat(panel.dataset.mmParent))[0];
                    if (parent) selectTab(parent.closest('.mm-panel'));
                }
            };
            this.bind('openPanel:before', selectTab);
        }
    }
}



var $2b6Uo = parcelRequire("2b6Uo");
var $cf2272d682b6c438$var$options = {
    add: false,
    blockPanel: true,
    visible: 3
};
var $cf2272d682b6c438$export$2e2bcd8739ae039 = $cf2272d682b6c438$var$options;




function $93a983465c344953$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.iconPanels = this.opts.iconPanels || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.iconPanels, (0, $cf2272d682b6c438$export$2e2bcd8739ae039));
    var keepFirst = false;
    if (options.visible == 'first') {
        keepFirst = true;
        options.visible = 1;
    }
    options.visible = Math.min(3, Math.max(1, options.visible));
    options.visible++;
    //	Add the iconpanels
    if (options.add) {
        this.bind('initMenu:after', function() {
            _this.node.menu.classList.add('mm-menu--iconpanel');
        });
        /** The classnames that can be set to a panel */ var classnames = [
            'mm-panel--iconpanel-0',
            'mm-panel--iconpanel-1',
            'mm-panel--iconpanel-2',
            'mm-panel--iconpanel-3'
        ];
        //  Show only the main panel.
        if (keepFirst) this.bind('initMenu:after', function() {
            var _a;
            (_a = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel')[0]) === null || _a === void 0 || _a.classList.add('mm-panel--iconpanel-first');
        });
        else this.bind('openPanel:after', function(panel) {
            //  Do nothing when opening a vertical submenu
            if (panel.closest('.mm-listitem--vertical')) return;
            var panels = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel');
            //	Filter out panels that are not opened.
            panels = panels.filter(function(panel) {
                return panel.matches('.mm-panel--parent');
            });
            //	Add the current panel to the list.
            panels.push(panel);
            //	Slice the opened panels to the max visible amount.
            panels = panels.slice(-options.visible);
            //	Add the "iconpanel" classnames.
            panels.forEach(function(panel, p) {
                var _panel_classList;
                (_panel_classList = panel.classList).remove.apply(_panel_classList, [
                    'mm-panel--iconpanel-first'
                ].concat((0, $2b6Uo._)(classnames)));
                panel.classList.add("mm-panel--iconpanel-".concat(p));
            });
        });
    // this.bind('initPanel:after', (panel: HTMLElement) => {
    //     if (!panel.closest('.mm-listitem--vertical') &&
    //         !DOM.children(panel, '.mm-panel__blocker')[0]
    //     ) {
    //         const blocker = DOM.create('div.mm-blocker.mm-panel__blocker') as HTMLElement;
    //         panel.prepend(blocker);
    //     }
    // });
    }
}


var $3cfc4e44025499e1$var$configs = {
    breadcrumbs: {
        separator: '/',
        removeFirst: false
    }
};
var $3cfc4e44025499e1$export$2e2bcd8739ae039 = $3cfc4e44025499e1$var$configs;


/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */ 
var $22yUM = parcelRequire("22yUM");
function $fac718c2f4e909bb$export$4f8b0ef91d76ca33(options) {
    if (typeof options == 'boolean' && options) options = {};
    if ((typeof options === "undefined" ? "undefined" : (0, $22yUM._)(options)) != 'object') options = {};
    if (typeof options.content == 'undefined') options.content = [
        'prev',
        'title'
    ];
    if (!(options.content instanceof Array)) options.content = [
        options.content
    ];
    if (typeof options.use == 'undefined') options.use = true;
    return options;
}






function $1e1ea7fa703b5b1d$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    //	Add content
    var breadcrumbs = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-navbar__breadcrumbs');
    navbar.append(breadcrumbs);
    this.bind('initNavbar:after', function(panel) {
        if (panel.querySelector('.mm-navbar__breadcrumbs')) return;
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].classList.add('mm-hidden');
        var crumbs = [], breadcrumbs = $6fd43b8bf55d8da0$export$185802fd694ee1f5('span.mm-navbar__breadcrumbs'), current = panel, first = true;
        while(current){
            current = current.closest('.mm-panel');
            if (!current.parentElement.matches('.mm-listitem--vertical')) {
                var title = $6fd43b8bf55d8da0$export$71aa6c912b956294(current, '.mm-navbar__title span')[0];
                if (title) {
                    var text = title.textContent;
                    if (text.length) crumbs.unshift(first ? "<span>".concat(text, "</span>") : '<a \n                                    href="#'.concat(current.id, '" \n                                    title="').concat(_this.i18n(_this.conf.screenReader.openSubmenu), '"\n                                    >').concat(text, "</a>"));
                }
                first = false;
            }
            current = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.pnls, "#".concat(current.dataset.mmParent))[0];
        }
        if (_this.conf.navbars.breadcrumbs.removeFirst) crumbs.shift();
        breadcrumbs.innerHTML = crumbs.join('<span class="mm-separator">' + _this.conf.navbars.breadcrumbs.separator + '</span>');
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].append(breadcrumbs);
    });
    //	Update for to opened panel
    this.bind('openPanel:before', function(panel) {
        var crumbs = panel.querySelector('.mm-navbar__breadcrumbs');
        breadcrumbs.innerHTML = crumbs ? crumbs.innerHTML : '';
    });
}



function $0ab36c0e105544f9$export$2e2bcd8739ae039(navbar) {
    /** The close button. */ var close = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-btn.mm-btn--close.mm-navbar__btn');
    close.setAttribute('aria-label', this.i18n(this.conf.offCanvas.screenReader.closeMenu));
    //	Add the button to the navbar.
    navbar.append(close);
    //	Update to target the page node.
    this.bind('setPage:after', function(page) {
        close.href = "#".concat(page.id);
    });
}



function $55126368869e6513$export$2e2bcd8739ae039(navbar) {
    /** The prev button. */ var prev = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-btn.mm-hidden');
    //	Add button to navbar.
    navbar.append(prev);
    //  Hide navbar in the panel.
    this.bind('initNavbar:after', function(panel) {
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].classList.add('mm-hidden');
    });
    // Update the button href when opening a panel.
    this.bind('openPanel:before', function(panel) {
        if (panel.parentElement.matches('.mm-listitem--vertical')) return;
        prev.classList.add('mm-hidden');
        /** Original button in the panel. */ var original = panel.querySelector('.mm-navbar__btn.mm-btn--prev');
        if (original) {
            /** Clone of the original button in the panel. */ var clone = original.cloneNode(true);
            prev.after(clone);
            prev.remove();
            prev = clone;
        }
    });
}




function $6cb4f69b9cbb6080$export$2e2bcd8739ae039(navbar) {
    /** Empty wrapper for the searchfield. */ var wrapper = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-navbar__searchfield');
    wrapper.id = (0, $2a955d1075ee79df$export$8b15d37bc3f197d4)();
    //	Add button to navbar.
    navbar.append(wrapper);
    this.opts.searchfield = this.opts.searchfield || {};
    this.opts.searchfield.add = true;
    this.opts.searchfield.addTo = "#".concat(wrapper.id);
}



function $36a1b0e557cc898e$export$2e2bcd8739ae039(navbar) {
    /** The title node in the navbar. */ var title = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-navbar__title');
    //	Add title to the navbar.
    navbar.append(title);
    //	Update the title to the opened panel.
    this.bind('openPanel:before', function(panel) {
        //	Do nothing in a vertically expanding panel.
        if (panel.parentElement.matches('.mm-listitem--vertical')) return;
        /** Original title in the panel. */ var original = panel.querySelector('.mm-navbar__title');
        if (original) {
            /** Clone of the original title in the panel. */ var clone = original.cloneNode(true);
            title.after(clone);
            title.remove();
            title = clone;
        }
    });
}



function $68c937d5ea510fb3$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    navbar.classList.add('mm-navbar--tabs');
    navbar.closest('.mm-navbars').classList.add('mm-navbars--has-tabs');
    $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(navbar, 'a').forEach(function(anchor) {
        anchor.classList.add('mm-navbar__tab');
    });
    /**
     * Mark a tab as selected.
     * @param {HTMLElement} panel Opened panel.
     */ function selectTab(panel) {
        /** The tab that links to the opened panel. */ var anchor = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(navbar, '.mm-navbar__tab[href="#'.concat(panel.id, '"]'))[0];
        if (anchor) {
            anchor.classList.add('mm-navbar__tab--selected');
            // @ts-ignore
            anchor.ariaExpanded = 'true';
        } else {
            /** The parent listitem. */ var parent = $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, "#".concat(panel.dataset.mmParent))[0];
            if (parent) selectTab.call(this, parent.closest('.mm-panel'));
        }
    }
    this.bind('openPanel:before', function(panel) {
        //  Remove selected class.
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(navbar, 'a').forEach(function(anchor) {
            anchor.classList.remove('mm-navbar__tab--selected');
            // @ts-ignore
            anchor.ariaExpanded = 'false';
        });
        selectTab.call(_this, panel);
    });
    this.bind('initPanels:after', function() {
        //	Add animation class to panel.
        navbar.addEventListener('click', function(event) {
            var _a, _b, _c;
            /** The href for the clicked tab. */ var href = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('.mm-navbar__tab')) === null || _b === void 0 ? void 0 : _b.getAttribute('href');
            try {
                (_c = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.pnls, "".concat(href, ".mm-panel"))[0]) === null || _c === void 0 || _c.classList.add('mm-panel--noanimation');
            } catch (err) {}
        }, {
            // useCapture to ensure the logical order.
            capture: true
        });
    });
}


$7e2e30116d74c6c0$export$2e2bcd8739ae039.navbarContents = {
    breadcrumbs: (0, $1e1ea7fa703b5b1d$export$2e2bcd8739ae039),
    close: (0, $0ab36c0e105544f9$export$2e2bcd8739ae039),
    prev: (0, $55126368869e6513$export$2e2bcd8739ae039),
    searchfield: (0, $6cb4f69b9cbb6080$export$2e2bcd8739ae039),
    title: (0, $36a1b0e557cc898e$export$2e2bcd8739ae039)
};
$7e2e30116d74c6c0$export$2e2bcd8739ae039.navbarTypes = {
    tabs: (0, $68c937d5ea510fb3$export$2e2bcd8739ae039)
};
function $7e2e30116d74c6c0$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.navbars = this.opts.navbars || [];
    this.conf.navbars = this.conf.navbars || {};
    //	Extend options.
    (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.conf.navbars, (0, $3cfc4e44025499e1$export$2e2bcd8739ae039));
    var navs = this.opts.navbars;
    if (typeof navs == 'undefined') return;
    if (!(navs instanceof Array)) navs = [
        navs
    ];
    if (!navs.length) return;
    var navbars = {};
    navs.forEach(function(options) {
        options = (0, $fac718c2f4e909bb$export$4f8b0ef91d76ca33)(options);
        if (!options.use) return;
        //	Create the navbar element.
        var navbar = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-navbar');
        //	Get the position for the navbar.
        var position = options.position;
        //	Restrict the position to either "bottom" or "top" (default).
        if (position !== 'bottom') position = 'top';
        //	Create the wrapper for the navbar position.
        if (!navbars[position]) navbars[position] = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-navbars.mm-navbars--' + position);
        navbars[position].append(navbar);
        //	Add content to the navbar.
        for(var c = 0, l = options.content.length; c < l; c++){
            var ctnt = options.content[c];
            //	The content is a string.
            if (typeof ctnt == 'string') {
                var func = $7e2e30116d74c6c0$export$2e2bcd8739ae039.navbarContents[ctnt];
                //	The content refers to one of the navbar-presets ("prev", "title", etc).
                if (typeof func == 'function') //	Call the preset function.
                func.call(_this, navbar);
                else {
                    //	Add the HTML.
                    //  Wrap the HTML in a single node
                    var node = $6fd43b8bf55d8da0$export$185802fd694ee1f5('span');
                    node.innerHTML = ctnt;
                    //  If there was only a single node, use that.
                    var children = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(node);
                    if (children.length == 1) node = children[0];
                    navbar.append(node);
                }
            //	The content is not a string, it must be an element.
            } else navbar.append(ctnt);
        }
        //	The type option is set.
        if (typeof options.type == 'string') {
            //	The function refers to one of the navbar-presets ("tabs").
            var func1 = $7e2e30116d74c6c0$export$2e2bcd8739ae039.navbarTypes[options.type];
            if (typeof func1 == 'function') //	Call the preset function.
            func1.call(_this, navbar);
        }
        //	En-/disable the navbar.
        var enable = function() {
            navbar.classList.remove('mm-hidden');
        };
        var disable = function() {
            navbar.classList.add('mm-hidden');
        };
        if (typeof options.use == 'boolean') _this.bind('initMenu:after', enable);
        else $7eb8de21b7625c44$export$e16d8520af44a096(options.use, enable, disable);
    });
    //	Add to menu.
    this.bind('initMenu:after', function() {
        for(var position in navbars)_this.node.pnls[position == 'bottom' ? 'after' : 'before'](navbars[position]);
    });
}



var $d3c0f6db0d427a6f$var$options = {
    scroll: false,
    update: false
};
var $d3c0f6db0d427a6f$export$2e2bcd8739ae039 = $d3c0f6db0d427a6f$var$options;


var $db05e8b790855103$var$configs = {
    scrollOffset: 0,
    updateOffset: 50
};
var $db05e8b790855103$export$2e2bcd8739ae039 = $db05e8b790855103$var$configs;




function $79f3ccd9ed37e704$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.pageScroll = this.opts.pageScroll || {};
    this.conf.pageScroll = this.conf.pageScroll || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.pageScroll, (0, $d3c0f6db0d427a6f$export$2e2bcd8739ae039));
    var configs = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.conf.pageScroll, (0, $db05e8b790855103$export$2e2bcd8739ae039));
    /** The currently "active" section */ var section;
    function scrollTo() {
        if (section) // section.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({
            top: section.getBoundingClientRect().top + document.scrollingElement.scrollTop - configs.scrollOffset,
            behavior: 'smooth'
        });
        section = null;
    }
    function anchorInPage(href) {
        try {
            if (href.slice(0, 1) == '#') return $6fd43b8bf55d8da0$export$71aa6c912b956294((0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page, href)[0];
        } catch (err) {}
        return null;
    }
    if (this.opts.offCanvas.use && options.scroll) {
        //	Scroll to section after clicking menu item.
        this.bind('close:after', function() {
            scrollTo();
        });
        this.node.menu.addEventListener('click', function(event) {
            var _a, _b;
            var href = ((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a[href]')) === null || _b === void 0 ? void 0 : _b.getAttribute('href')) || '';
            section = anchorInPage(href);
            if (section) {
                event.preventDefault();
                //	If the sidebar add-on is "expanded"...
                if (_this.node.menu.matches('.mm-menu--sidebar-expanded') && _this.node.wrpr.matches('.mm-wrapper--sidebar-expanded')) //	... scroll the page to the section.
                scrollTo();
                else //	... close the menu.
                _this.close();
            }
        });
    }
    //	Update selected menu item after scrolling.
    if (options.update) {
        var scts = [];
        this.bind('initListview:after', function(listview) {
            var listitems = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listview, '.mm-listitem');
            $6fd43b8bf55d8da0$export$f6486d4f577dfcc4(listitems).forEach(function(anchor) {
                var section = anchorInPage(anchor.getAttribute('href'));
                if (section) scts.unshift(section);
            });
        });
        var _selected = -1;
        window.addEventListener('scroll', function(evnt) {
            var scrollTop = window.scrollY;
            for(var s = 0; s < scts.length; s++)if (scts[s].offsetTop < scrollTop + configs.updateOffset) {
                if (_selected !== s) {
                    _selected = s;
                    var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--opened')[0];
                    var listitems = $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-listitem');
                    var anchors = $6fd43b8bf55d8da0$export$f6486d4f577dfcc4(listitems);
                    anchors = anchors.filter(function(anchor) {
                        return anchor.matches('[href="#' + scts[s].id + '"]');
                    });
                    if (anchors.length) _this.setSelected(anchors[0].parentElement);
                }
                break;
            }
        }, {
            passive: true
        });
    }
}



var $2b6Uo = parcelRequire("2b6Uo");
var $a56704931dfc6884$var$options = {
    add: false,
    addTo: 'panels',
    noResults: 'No results found.',
    placeholder: 'Search',
    search: true,
    searchIn: 'panels',
    splash: '',
    title: 'Search'
};
var $a56704931dfc6884$export$2e2bcd8739ae039 = $a56704931dfc6884$var$options;


var $51ef7b47b7797518$var$configs = {
    cancel: true,
    clear: true,
    form: {},
    input: {},
    panel: {},
    submit: false
};
var $51ef7b47b7797518$export$2e2bcd8739ae039 = $51ef7b47b7797518$var$configs;



var $61edf8497ceee649$export$2e2bcd8739ae039 = {
    'cancel': 'abbrechen',
    'Cancel searching': 'Suche abbrechen',
    'Clear searchfield': "Suchfeld l\xf6schen",
    'No results found.': 'Keine Ergebnisse gefunden.',
    'Search': 'Suche'
};


var $925eea064f699aab$export$2e2bcd8739ae039 = {
    'cancel': "\u0627\u0646\u0635\u0631\u0627\u0641",
    'Cancel searching': "\u0644\u063A\u0648 \u062C\u0633\u062A\u062C\u0648",
    'Clear searchfield': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u0641\u06CC\u0644\u062F \u062C\u0633\u062A\u062C\u0648",
    'No results found.': "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
    'Search': "\u062C\u0633\u062A\u062C\u0648"
};


var $455872f6b7473271$export$2e2bcd8739ae039 = {
    'cancel': 'annuleren',
    'Cancel searching': 'Zoeken annuleren',
    'Clear searchfield': 'Zoekveld leeg maken',
    'No results found.': 'Geen resultaten gevonden.',
    'Search': 'Zoeken'
};


var $3aff9d4981b2cca2$export$2e2bcd8739ae039 = {
    'cancel': 'cancelar',
    'Cancel searching': 'Cancelar pesquisa',
    'Clear searchfield': 'Limpar campo de pesquisa',
    'No results found.': 'Nenhum resultado encontrado.',
    'Search': 'Buscar'
};


var $483c7836ecbade83$export$2e2bcd8739ae039 = {
    'cancel': "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
    'Cancel searching': "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A",
    'Clear searchfield': "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435 \u043F\u043E\u0438\u0441\u043A\u0430",
    'No results found.': "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    'Search': "\u041D\u0430\u0439\u0442\u0438"
};


var $e5686c204813abaa$export$2e2bcd8739ae039 = {
    'cancel': "zru\u0161i\u0165",
    'Cancel searching': "Zru\u0161i\u0165 vyh\u013Ead\xe1vanie",
    'Clear searchfield': "Vymaza\u0165 pole vyh\u013Ead\xe1vania",
    'No results found.': "Neboli n\xe1jden\xe9 \u017Eiadne v\xfdsledky.",
    'Search': "Vyh\u013Ead\xe1vanie"
};


var $bdcf7e799ce621dd$export$2e2bcd8739ae039 = {
    'cancel': "\u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'Cancel searching': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A",
    'Clear searchfield': "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u043B\u0435 \u043F\u043E\u0448\u0443\u043A\u0443",
    'No results found.': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    'Search': "\u041F\u043E\u0448\u0443\u043A"
};


function $548ea6d26a63f99a$export$2e2bcd8739ae039() {
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $61edf8497ceee649$export$2e2bcd8739ae039), 'de');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $925eea064f699aab$export$2e2bcd8739ae039), 'fa');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $455872f6b7473271$export$2e2bcd8739ae039), 'nl');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $3aff9d4981b2cca2$export$2e2bcd8739ae039), 'pt_br');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $483c7836ecbade83$export$2e2bcd8739ae039), 'ru');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $e5686c204813abaa$export$2e2bcd8739ae039), 'sk');
    (0, $ff00179c1540dc31$export$e16d8520af44a096)((0, $bdcf7e799ce621dd$export$2e2bcd8739ae039), 'uk');
}




//  Add the translations.
(0, $548ea6d26a63f99a$export$2e2bcd8739ae039)();
function $ca02763e3971f63a$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.searchfield = this.opts.searchfield || {};
    this.conf.searchfield = this.conf.searchfield || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.searchfield, (0, $a56704931dfc6884$export$2e2bcd8739ae039));
    var configs = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.conf.searchfield, (0, $51ef7b47b7797518$export$2e2bcd8739ae039));
    if (!options.add) return;
    switch(options.addTo){
        case 'panels':
            options.addTo = '.mm-panel';
            break;
        case 'searchpanel':
            options.addTo = '.mm-panel--search';
            break;
    }
    switch(options.searchIn){
        case 'panels':
            options.searchIn = '.mm-panel';
            break;
    }
    //  Add a searchfield to panels matching the "addTo" querySelector.
    this.bind('initPanel:after', function(panel) {
        if (panel.matches(options.addTo) && !panel.closest('.mm-listitem--vertical')) $ca02763e3971f63a$var$initPanel.call(_this, panel);
    });
    this.bind('initMenu:after', function() {
        //  Create the resultspanel.
        var resultspanel = $ca02763e3971f63a$var$createResultsPanel.call(_this);
        $ca02763e3971f63a$var$initPanel.call(_this, resultspanel);
        //  Add a searchfield to anything other than a panel (most likely a navbar).
        $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.menu, options.addTo).forEach(function(wrapper) {
            if (!wrapper.matches('.mm-panel')) {
                /** The searchform. */ var form = $ca02763e3971f63a$var$createSearchfield.call(_this, true);
                //  Add the form to the panel.
                wrapper.append(form);
                /** The input node. */ var input = $6fd43b8bf55d8da0$export$71aa6c912b956294(form, 'input')[0];
                //  Bind events for opening and closing the resultspanel.
                // With a splash...
                if (options.splash.length) {
                    //  Open on focus.
                    input.addEventListener('focusin', function() {
                        _this.openPanel(resultspanel, false, false);
                    });
                    //  Show cancel button if searchpanel is opened.
                    _this.bind('openPanel:after', function(panel) {
                        if (panel.matches('.mm-panel--search')) form.classList.add('mm-searchfield--cancelable');
                        else form.classList.remove('mm-searchfield--cancelable');
                    });
                // ...without splash.
                } else {
                    //  Open resultspanel when searching.
                    _this.bind('search:after', function() {
                        _this.openPanel(resultspanel, false, false);
                    });
                    //  Close resultspanel when resetting.
                    input.addEventListener('focusout', function() {
                        if (!input.value.length) _this.closePanel(resultspanel, false);
                    });
                }
                //  Initialize searching.
                $ca02763e3971f63a$var$initSearch.call(_this, form);
            }
        });
    });
    //	Blur searchfield
    this.bind('close:before', function() {
        $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.menu, '.mm-searchfield input').forEach(function(input) {
            input.blur();
        });
    });
}
/**
 * Create the searchpanel.
 * @param {Mmenu} this
 */ var $ca02763e3971f63a$var$createResultsPanel = function createResultsPanel() {
    /** Options for the searchfield. */ var options = this.opts.searchfield;
    /** Configs for the searchfield. */ var configs = this.conf.searchfield;
    /** The panel. */ var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--search')[0];
    //	Only once
    if (panel) return panel;
    panel = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-panel--search');
    //	Add attributes to the panel.    
    $ca02763e3971f63a$var$_addAttributes(panel, configs.panel);
    //  Add a title to the panel.
    if (options.title.length) panel.dataset.mmTitle = this.i18n(options.title);
    //  Add a listview to the panel.
    panel.append($6fd43b8bf55d8da0$export$185802fd694ee1f5('ul'));
    this._initPanel(panel);
    return panel;
};
/**
 * Add a searchfield, splash message and no-results message to a panel.
 * @param {Mmenu}       this
 * @param {HTMLElement} panel The panel to initialise.
 */ var $ca02763e3971f63a$var$initPanel = function initPanel(panel) {
    /** Options for the searchfield. */ var options = this.opts.searchfield;
    //	Create the searchfield.
    if (panel.matches(options.addTo)) {
        /** Whether or not the panel is the resultspanel */ var isResultspanel = panel.matches('.mm-panel--search');
        //  Only one per panel.
        if (!$6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-searchfield').length) {
            /** The searchform. */ var form = $ca02763e3971f63a$var$createSearchfield.call(this, isResultspanel);
            if (isResultspanel) form.classList.add('mm-searchfield--cancelable');
            //  Add the form to the panel.
            panel.prepend(form);
            //  Initialize searching.
            $ca02763e3971f63a$var$initSearch.call(this, form);
        }
    }
    //	Create the splash content.
    if (options.splash.length && panel.matches('.mm-panel--search')) //  Only one per panel.
    {
        if (!$6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-panel__splash').length) {
            /** The splash content node. */ var splash = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-panel__splash');
            splash.innerHTML = options.splash;
            panel.append(splash);
        }
    }
    //  Add no results message.
    if (options.noResults.length) //	Only once per panel.
    {
        if (!$6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-panel__noresults').length) {
            /** The no results message node. */ var message = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-panel__noresults');
            message.innerHTML = this.i18n(options.noResults);
            panel.append(message);
        }
    }
};
/**
 * Create the searchfield.
 * @param {Mmenu}   this
 * @param {boolean} [addCancel=false] Whether or not to add the cancel button
 */ var $ca02763e3971f63a$var$createSearchfield = function createSearchfield() {
    var _this = this;
    var addCancel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    /** Options for the searchfield. */ var options = this.opts.searchfield;
    /** Configs for the searchfield. */ var configs = this.conf.searchfield;
    /** The form node. */ var form = $6fd43b8bf55d8da0$export$185802fd694ee1f5('form.mm-searchfield');
    //	Add attributes to the form
    $ca02763e3971f63a$var$_addAttributes(form, configs.form);
    /** The fieldset node. */ var field = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-searchfield__input');
    form.append(field);
    /** The input node. */ var input = $6fd43b8bf55d8da0$export$185802fd694ee1f5('input');
    field.append(input);
    //	Add attributes to the input
    input.type = 'text';
    input.autocomplete = 'off';
    input.placeholder = this.i18n(options.placeholder);
    input.setAttribute('aria-label', this.i18n(options.placeholder));
    $ca02763e3971f63a$var$_addAttributes(input, configs.input);
    //	Add a button to submit to the form.
    if (configs.submit) {
        /** The submit button. */ var submit = $6fd43b8bf55d8da0$export$185802fd694ee1f5('button.mm-btnreset.mm-btn.mm-btn--next.mm-searchfield__btn');
        submit.type = 'submit';
        field.append(submit);
    } else if (configs.clear) {
        /** The reset button. */ var reset = $6fd43b8bf55d8da0$export$185802fd694ee1f5('button.mm-btnreset.mm-btn.mm-btn--close.mm-searchfield__btn');
        reset.type = 'reset';
        reset.setAttribute('aria-label', this.i18n('Clear searchfield'));
        field.append(reset);
        //  Apparently, resetting a form doesn't trigger any event on the input,
        //  so we manually dispatch the event, one frame later :/
        form.addEventListener('reset', function() {
            window.requestAnimationFrame(function() {
                input.dispatchEvent(new Event('input'));
            });
        });
    }
    // Add a button to close the searchpanel.
    if (configs.cancel && addCancel) {
        /** The cancel button. */ var cancel = $6fd43b8bf55d8da0$export$185802fd694ee1f5('a.mm-searchfield__cancel');
        cancel.href = '#';
        cancel.setAttribute('aria-label', this.i18n('Cancel searching'));
        cancel.textContent = this.i18n('cancel');
        form.append(cancel);
        // Close the search panel.
        cancel.addEventListener('click', function(event) {
            event.preventDefault();
            _this.closePanel($6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--search')[0], false);
        });
    }
    return form;
};
/**
 * Initialize the searching.
 * @param {Mmenu}       this
 * @param {HTMLElement} form The searchform.
 */ var $ca02763e3971f63a$var$initSearch = function initSearch(form) {
    var _this = this;
    /** Options for the searchfield. */ var options = this.opts.searchfield;
    /** The panel the results will be in. */ var resultspanel = form.closest('.mm-panel') || $6fd43b8bf55d8da0$export$71aa6c912b956294(this.node.pnls, '.mm-panel--search')[0];
    /** The input node. */ var input = $6fd43b8bf55d8da0$export$71aa6c912b956294(form, 'input')[0];
    /** Where to search. */ var searchIn = resultspanel.matches('.mm-panel--search') ? $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(this.node.pnls, options.searchIn) : [
        resultspanel
    ];
    //  Filter out the resultspanel
    searchIn = searchIn.filter(function(panel) {
        return !panel.matches('.mm-panel--search');
    });
    /** Search */ var search = function() {
        /** The searchquery */ var query = input.value.toLowerCase().trim();
        if (query.length) form.classList.add('mm-searchfield--searching');
        else form.classList.remove('mm-searchfield--searching');
        if (!options.search) return;
        /** All listitems */ var listitems = [];
        searchIn.forEach(function(panel) {
            var //  Find listitems.
            _listitems;
            //  Scroll all panels to top.
            panel.scrollTop = 0;
            (_listitems = listitems).push.apply(_listitems, (0, $2b6Uo._)($6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-listitem')));
        });
        //	Search
        if (query.length) {
            // Trigger event.
            _this.trigger('search:before');
            resultspanel.classList.add('mm-panel--searching');
            //	Add data attribute to the matching listitems.
            listitems.forEach(function(listitem) {
                var text = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listitem, '.mm-listitem__text')[0];
                if (!text || $6fd43b8bf55d8da0$export$6f093cfa640b7166(text).toLowerCase().indexOf(query) > -1) listitem.dataset.mmSearchresult = query;
            });
            /** The number of matching results. */ var count = 0;
            //  Resultspanel: Copy results to resultspanel.
            if (resultspanel.matches('.mm-panel--search')) count = $ca02763e3971f63a$var$_searchResultsPanel(resultspanel, query, searchIn);
            else count = $ca02763e3971f63a$var$_searchPerPanel(query, searchIn);
            resultspanel.classList[count == 0 ? 'add' : 'remove']('mm-panel--noresults');
            // Trigger event.
            _this.trigger('search:after');
        //  Don't search, reset all.
        } else {
            // Trigger event.
            _this.trigger('clear:before');
            resultspanel.classList.remove('mm-panel--searching', 'mm-panel--noresults');
            //  Resultspanel.
            if (resultspanel.matches('.mm-panel--search')) {
                $ca02763e3971f63a$var$_resetResultsPanel(resultspanel);
                if (!options.splash) _this.closePanel(resultspanel, false, false);
            //  Search per panel: Show all listitems and dividers.
            } else $ca02763e3971f63a$var$_resetPerPanel(searchIn);
            // Trigger event.
            _this.trigger('clear:after');
        }
    };
    input.addEventListener('input', search);
    search();
};
var $ca02763e3971f63a$var$_searchResultsPanel = function(resultspanel, query, searchIn) {
    /** The listview for the results/ */ var listview = $6fd43b8bf55d8da0$export$71aa6c912b956294(resultspanel, '.mm-listview')[0];
    //  Clear listview.
    listview.innerHTML = '';
    /** Amount of resutls found. */ var count = 0;
    searchIn.forEach(function(panel) {
        /** The results in this panel. */ var results = $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '[data-mm-searchresult="'.concat(query, '"]'));
        count += results.length;
        if (results.length) {
            /** Title for the panel. */ var title = $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-navbar__title')[0];
            //  Add a divider to indicate in what panel the results are.
            if (title) {
                var divider = $6fd43b8bf55d8da0$export$185802fd694ee1f5('li.mm-divider');
                divider.innerHTML = title.innerHTML;
                listview.append(divider);
            }
            //  Add the results
            results.forEach(function(result) {
                var clone = result.cloneNode(true);
                listview.append(clone);
            });
        }
    });
    //  Remove inline subpanels.
    $6fd43b8bf55d8da0$export$71aa6c912b956294(listview, '.mm-panel').forEach(function(panel) {
        panel.remove();
    });
    //  Remove ID's and data-attributes
    [
        'id',
        'data-mm-parent',
        'data-mm-child'
    ].forEach(function(attr) {
        $6fd43b8bf55d8da0$export$71aa6c912b956294(listview, "[".concat(attr, "]")).forEach(function(elem) {
            elem.removeAttribute(attr);
        });
    });
    //  Remove "opened" class
    $6fd43b8bf55d8da0$export$71aa6c912b956294(listview, '.mm-listitem--opened').forEach(function(listitem) {
        listitem.classList.remove('mm-listitem--opened');
    });
    return count;
};
var $ca02763e3971f63a$var$_resetResultsPanel = function(resultspanel) {
    /** The listview for the results. */ var listview = $6fd43b8bf55d8da0$export$71aa6c912b956294(resultspanel, '.mm-listview')[0];
    //  Clear listview.
    listview.innerHTML = '';
};
var $ca02763e3971f63a$var$_searchPerPanel = function(query, searchIn) {
    /** Amount of resutls found. */ var count = 0;
    searchIn.forEach(function(panel) {
        /** The results in this panel. */ var results = $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '[data-mm-searchresult="'.concat(query, '"]'));
        count += results.length;
        if (results.length) //  Add first preceeding divider to the results.
        results.forEach(function(result) {
            var divider = $6fd43b8bf55d8da0$export$5a01ccd45552d0b4(result, '.mm-divider')[0];
            if (divider) divider.dataset.mmSearchresult = query;
        });
        $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-listitem, .mm-divider').forEach(function(item) {
            //  Hide all
            item.classList.add('mm-hidden');
            //  Show matching + its parents.
            if (item.dataset.mmSearchresult === query) [
                item
            ].concat((0, $2b6Uo._)($6fd43b8bf55d8da0$export$7901f6cd558b9a93(item, '.mm-listitem'))).forEach(function(item2) {
                item2.classList.remove('mm-hidden');
            });
        });
    });
    return count;
};
var $ca02763e3971f63a$var$_resetPerPanel = function(searchIn) {
    searchIn.forEach(function(panel) {
        $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-listitem, .mm-divider').forEach(function(item) {
            item.classList.remove('mm-hidden');
        });
    });
};
/**
 * Add array of attributes to an element.
 * @param {HTMLEement}  element     The element to add the attributes to.
 * @param {Object}      attributes  The attributes to add.
 */ var $ca02763e3971f63a$var$_addAttributes = function(element, attributes) {
    if (attributes) Object.keys(attributes).forEach(function(a) {
        element[a] = attributes[a];
    });
};


var $74f53ca01abae8d6$var$options = {
    add: false,
    addTo: 'panels'
};
var $74f53ca01abae8d6$export$2e2bcd8739ae039 = $74f53ca01abae8d6$var$options;





function $5cb2fab81fe4b99d$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.sectionIndexer = this.opts.sectionIndexer || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.sectionIndexer, (0, $74f53ca01abae8d6$export$2e2bcd8739ae039));
    if (!options.add) return;
    this.bind('initPanels:after', function() {
        //	Add the indexer, only if it does not allready excists
        if (!_this.node.indx) {
            var buttons = '';
            'abcdefghijklmnopqrstuvwxyz'.split('').forEach(function(letter) {
                buttons += '<a href="#">' + letter + '</a>';
            });
            var indexer = $6fd43b8bf55d8da0$export$185802fd694ee1f5('div.mm-sectionindexer');
            indexer.innerHTML = buttons;
            _this.node.pnls.prepend(indexer);
            _this.node.indx = indexer;
            //	Prevent default behavior when clicking an anchor
            _this.node.indx.addEventListener('click', function(evnt) {
                var anchor = evnt.target;
                if (anchor.matches('a')) evnt.preventDefault();
            });
            //	Scroll onMouseOver / onTouchStart
            var mouseOverEvent = function(evnt) {
                if (!evnt.target.matches('a')) return;
                var letter = evnt.target.textContent;
                var panel = $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(_this.node.pnls, '.mm-panel--opened')[0];
                var newTop = -1, oldTop = panel.scrollTop;
                panel.scrollTop = 0;
                $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-divider').filter(function(divider) {
                    return !divider.matches('.mm-hidden');
                }).forEach(function(divider) {
                    if (newTop < 0 && letter == divider.textContent.trim().slice(0, 1).toLowerCase()) newTop = divider.offsetTop;
                });
                panel.scrollTop = newTop > -1 ? newTop : oldTop;
            };
            if ($3cc8baf6108a5db3$export$d0b7ea69ab6056df) {
                _this.node.indx.addEventListener('touchstart', mouseOverEvent);
                _this.node.indx.addEventListener('touchmove', mouseOverEvent);
            } else _this.node.indx.addEventListener('mouseover', mouseOverEvent);
        }
        //	Show or hide the indexer
        _this.bind('openPanel:before', function(panel) {
            var active = $6fd43b8bf55d8da0$export$71aa6c912b956294(panel, '.mm-divider').filter(function(divider) {
                return !divider.matches('.mm-hidden');
            }).length;
            _this.node.indx.classList[active ? 'add' : 'remove']('mm-sectionindexer--active');
        });
    });
}


var $e6e379e770cc5c29$var$options = {
    current: true,
    hover: false,
    parent: false
};
var $e6e379e770cc5c29$export$2e2bcd8739ae039 = $e6e379e770cc5c29$var$options;




function $8365315ded158d81$export$2e2bcd8739ae039() {
    var _this = this;
    this.opts.setSelected = this.opts.setSelected || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.setSelected, (0, $e6e379e770cc5c29$export$2e2bcd8739ae039));
    //	Find current by URL
    if (options.current == 'detect') {
        var findCurrent = function(url) {
            url = url.split('?')[0].split('#')[0];
            var anchor = _this.node.menu.querySelector('a[href="' + url + '"], a[href="' + url + '/"]');
            if (anchor) _this.setSelected(anchor.parentElement);
            else {
                var arr = url.split('/').slice(0, -1);
                if (arr.length) findCurrent(arr.join('/'));
            }
        };
        this.bind('initMenu:after', function() {
            findCurrent.call(_this, window.location.href);
        });
    //	Remove current selected item
    } else if (!options.current) this.bind('initListview:after', function(listview) {
        $6fd43b8bf55d8da0$export$bacb5cc5a11aef16(listview, '.mm-listitem--selected').forEach(function(listitem) {
            listitem.classList.remove('mm-listitem--selected');
        });
    });
    //	Add :hover effect on items
    if (options.hover) this.bind('initMenu:after', function() {
        _this.node.menu.classList.add('mm-menu--selected-hover');
    });
    //	Set parent item selected for submenus
    if (options.parent) {
        this.bind('openPanel:after', function(panel) {
            //	Remove all
            $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.pnls, '.mm-listitem--selected-parent').forEach(function(listitem) {
                listitem.classList.remove('mm-listitem--selected-parent');
            });
            //	Move up the DOM tree
            var current = panel;
            while(current){
                var li = $6fd43b8bf55d8da0$export$71aa6c912b956294(_this.node.pnls, "#".concat(current.dataset.mmParent))[0];
                current = li === null || li === void 0 ? void 0 : li.closest('.mm-panel');
                if (li && !li.matches('.mm-listitem--vertical')) li.classList.add('mm-listitem--selected-parent');
            }
        });
        this.bind('initMenu:after', function() {
            _this.node.menu.classList.add('mm-menu--selected-parent');
        });
    }
}



var $aa3d0e6e1cace86c$var$options = {
    collapsed: {
        use: false
    },
    expanded: {
        use: false,
        initial: 'open'
    }
};
var $aa3d0e6e1cace86c$export$2e2bcd8739ae039 = $aa3d0e6e1cace86c$var$options;




function $2e382f23980973ac$export$2e2bcd8739ae039() {
    var _this = this;
    // Only for off-canvas menus.
    if (!this.opts.offCanvas.use) return;
    this.opts.sidebar = this.opts.sidebar || {};
    //	Extend options.
    var options = (0, $2a955d1075ee79df$export$8b58be045bf06082)(this.opts.sidebar, (0, $aa3d0e6e1cace86c$export$2e2bcd8739ae039));
    //	Collapsed
    if (options.collapsed.use) {
        //	Make the menu collapsable.
        this.bind('initMenu:after', function() {
            _this.node.menu.classList.add('mm-menu--sidebar-collapsed');
        });
        /** Enable the collapsed sidebar */ var enable = function() {
            _this.node.wrpr.classList.add('mm-wrapper--sidebar-collapsed');
        };
        /** Disable the collapsed sidebar */ var disable = function() {
            _this.node.wrpr.classList.remove('mm-wrapper--sidebar-collapsed');
        };
        if (typeof options.collapsed.use === 'boolean') this.bind('initMenu:after', enable);
        else $7eb8de21b7625c44$export$e16d8520af44a096(options.collapsed.use, enable, disable);
    }
    //	Expanded
    if (options.expanded.use) {
        //	Make the menu expandable
        this.bind('initMenu:after', function() {
            _this.node.menu.classList.add('mm-menu--sidebar-expanded');
        });
        var expandedEnabled = false;
        /** Enable the expanded sidebar */ var enable1 = function() {
            expandedEnabled = true;
            _this.node.wrpr.classList.add('mm-wrapper--sidebar-expanded');
            _this.node.menu.removeAttribute('aria-modal');
            _this.open();
            (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
        };
        /** Disable the expanded sidebar */ var disable1 = function() {
            expandedEnabled = false;
            _this.node.wrpr.classList.remove('mm-wrapper--sidebar-expanded');
            _this.node.menu.setAttribute('aria-modal', 'true');
            _this.close();
        };
        if (typeof options.expanded.use == 'boolean') this.bind('initMenu:after', enable1);
        else $7eb8de21b7625c44$export$e16d8520af44a096(options.expanded.use, enable1, disable1);
        //  Store exanded state when opening and closing the menu.
        this.bind('close:after', function() {
            if (expandedEnabled) window.sessionStorage.setItem('mmenuExpandedState', 'closed');
        });
        this.bind('open:after', function() {
            if (expandedEnabled) {
                window.sessionStorage.setItem('mmenuExpandedState', 'open');
                (0, $09042cef4d06f7c9$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
            }
        });
        //  Set the initial state
        var initialState = options.expanded.initial;
        var state = window.sessionStorage.getItem('mmenuExpandedState');
        switch(state){
            case 'open':
            case 'closed':
                initialState = state;
                break;
        }
        if (initialState === 'closed') this.bind('init:after', function() {
            _this.close();
        });
    }
}


(0, $09042cef4d06f7c9$export$2e2bcd8739ae039).addons = {
    //	Core add-ons
    offcanvas: (0, $387f1e4ffbbbf6b5$export$2e2bcd8739ae039),
    scrollBugFix: (0, $f2e6597f1bda7372$export$2e2bcd8739ae039),
    theme: (0, $ff3c174c287bd9e1$export$2e2bcd8739ae039),
    //	Add-ons
    backButton: (0, $b62988ab217aed9a$export$2e2bcd8739ae039),
    counters: (0, $ecb550e06b69415b$export$2e2bcd8739ae039),
    iconbar: (0, $a51654911df513dc$export$2e2bcd8739ae039),
    iconPanels: (0, $93a983465c344953$export$2e2bcd8739ae039),
    navbars: (0, $7e2e30116d74c6c0$export$2e2bcd8739ae039),
    pageScroll: (0, $79f3ccd9ed37e704$export$2e2bcd8739ae039),
    searchfield: (0, $ca02763e3971f63a$export$2e2bcd8739ae039),
    sectionIndexer: (0, $5cb2fab81fe4b99d$export$2e2bcd8739ae039),
    setSelected: (0, $8365315ded158d81$export$2e2bcd8739ae039),
    sidebar: (0, $2e382f23980973ac$export$2e2bcd8739ae039)
};
var //  Export module
$f41de1080a111f7e$export$2e2bcd8739ae039 = (0, $09042cef4d06f7c9$export$2e2bcd8739ae039);
//	Global namespace
if (window) window.Mmenu = (0, $09042cef4d06f7c9$export$2e2bcd8739ae039);


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
document.addEventListener("DOMContentLoaded", function() {
    var menuEl = document.querySelector('#menu');
    var metaNav = document.querySelector('#meta-nav-mobil');
    var eyeAbleContainer = document.getElementById('eyeAble_container_ID');
    if (menuEl && metaNav) {
        var metanav = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = metaNav.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                metanav.push(child.outerHTML);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        metanav.push('close');
        new Mmenu("#menu", {
            navbars: [
                {
                    position: "top",
                    titleLink: "anchor",
                    content: metanav
                }
            ],
            offCanvas: {
                slidingSubmenus: false,
                position: "left-front",
                theme: "light"
            }
        }, {
            classNames: {
                selected: "selected"
            }
        });
        menuEl.setAttribute('tabindex', '-1');
        var initPanels = menuEl.querySelectorAll('.mm-panel');
        initPanels.forEach(function(panel) {
            panel.setAttribute('tabindex', '-1');
        });
        menuEl.addEventListener('openPanel:after', function(event) {
            var panel = event.detail.panel;
            if (panel) panel.setAttribute('tabindex', '-1');
            var isRoot = panel && panel.id === 'mm-1';
            setTimeout(function() {
                var navbar = document.querySelector('.mm-navbars--top .mm-navbar');
                if (!navbar) return;
                var newsBtn = navbar.querySelector('.menu-meta.news');
                var closeBtn = navbar.querySelector('.mm-btn--close');
                var focusTarget = null;
                if (window.innerWidth < 1280 && newsBtn) focusTarget = newsBtn;
                else if (closeBtn) focusTarget = closeBtn;
                else focusTarget = navbar.querySelector('a, button');
                if (focusTarget && typeof focusTarget.focus === 'function') {
                    var originalTabIndex = focusTarget.getAttribute('tabindex');
                    focusTarget.setAttribute('tabindex', '-1');
                    focusTarget.focus();
                    setTimeout(function() {
                        if (originalTabIndex === null) focusTarget.removeAttribute('tabindex');
                        else focusTarget.setAttribute('tabindex', originalTabIndex);
                    }, 100);
                }
            }, isRoot ? 300 : 100);
        });
        menuEl.addEventListener('click', function(e) {
            var backBtn = e.target.closest('.mm-btn--prev');
            if (!backBtn) return;
            setTimeout(function() {
                var _backBtn_getAttribute;
                var panelId = (_backBtn_getAttribute = backBtn.getAttribute('href')) === null || _backBtn_getAttribute === void 0 ? void 0 : _backBtn_getAttribute.substring(1);
                var targetPanel = document.getElementById(panelId);
                if (backBtn && typeof backBtn.focus === 'function') {
                    backBtn.setAttribute('tabindex', '-1');
                    backBtn.focus();
                    setTimeout(function() {
                        backBtn.removeAttribute('tabindex');
                    }, 100);
                } else if (targetPanel) {
                    targetPanel.setAttribute('tabindex', '-1');
                    targetPanel.focus();
                }
            }, 350);
        });
        menuEl.addEventListener('keydown', function(e) {
            if (e.key !== 'Tab') return;
            var panel = menuEl.querySelector('.mm-panel--opened');
            if (!panel) return;
            var panelItems = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var navbar = document.querySelector('.mm-navbars--top .mm-navbar');
            if (panelItems.length === 0 || !navbar) return;
            var firstNavbarLink = navbar.querySelector('a.menu-meta.news');
            var closeButton = navbar.querySelector('a.mm-btn--close');
            var lastItem = panelItems[panelItems.length - 1];
            var firstItem = panelItems[0];
            var target = window.innerWidth < 1280 && firstNavbarLink ? firstNavbarLink : closeButton;
            var blocker = document.querySelector('.mm-wrapper__blocker');
            if (blocker) {
                blocker.setAttribute('tabindex', '-1');
                blocker.setAttribute('aria-hidden', 'true');
                blocker.addEventListener('focus', function(e) {
                    return e.preventDefault();
                });
            }
            if (!e.shiftKey && document.activeElement === lastItem && target) {
                e.preventDefault();
                target.focus();
            }
            if (e.shiftKey && document.activeElement === target) {
                e.preventDefault();
                lastItem.focus();
            }
        });
        var weglot = document.querySelector('.weglot-container.wg-default');
        var updateAccessibility = function() {
            var isMenuOpen = document.body.classList.contains('mm-wrapper--opened');
            if (weglot) {
                if (isMenuOpen) {
                    weglot.setAttribute('tabindex', '-1');
                    weglot.setAttribute('aria-hidden', 'true');
                } else {
                    weglot.removeAttribute('tabindex');
                    weglot.removeAttribute('aria-hidden');
                }
            }
            if (eyeAbleContainer) {
                if (isMenuOpen) {
                    eyeAbleContainer.setAttribute('aria-hidden', 'true');
                    eyeAbleContainer.setAttribute('inert', '');
                } else {
                    eyeAbleContainer.removeAttribute('aria-hidden');
                    eyeAbleContainer.removeAttribute('inert');
                }
            }
        };
        var observer = new MutationObserver(updateAccessibility);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        updateAccessibility();
    }
    var blocker = document.querySelector('.mm-wrapper__blocker');
    if (blocker) blocker.setAttribute('tabindex', '-1');
});




var $9OVGD = parcelRequire("9OVGD");
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
$('input[type="range"]').each(function(event) {
    var sheet = document.createElement('style'), $rangeInput = $(this);
    var num = event;
    $rangeInput.parent('.range').attr('id', 'range-' + num);
    var $rangeLabels = $(this).parent('.range').prev('ul.range-labels');
    var getTrackStyle = function getTrackStyle(el) {
        var curVal = el.value, val = (curVal - 1) * 24, style = '';
        // Set active label    
        $rangeLabels.find('li').removeClass('active selected');
        var curLabel = $rangeLabels.find('li:nth-child(' + curVal + ')');
        curLabel.addClass('active selected');
        curLabel.prevAll().addClass('selected');
    };
    $rangeInput.on('input', function() {
        sheet.textContent = getTrackStyle(this);
    });
    // Change input value on label click
    $rangeLabels.find('li').on('click', function() {
        var index = $(this).index();
        $rangeInput.val(index + 1).trigger('input');
    });
});



var $9OVGD = parcelRequire("9OVGD");
"use strict";
function $c300bab1e7099971$var$throttle(e, t, n) {
    var i, r;
    return function() {
        var o = n || this, a = +new Date, s = arguments;
        i && a < i + t ? (clearTimeout(r), r = setTimeout(function() {
            i = a, e.apply(o, s);
        }, t)) : (i = a, e.apply(o, s));
    };
}
var $c300bab1e7099971$var$FC = $c300bab1e7099971$var$FC || {};
$c300bab1e7099971$var$FC.menu = {
    menuSelector: "",
    menuItemSelector: "",
    contentSelector: "",
    unfoldedContentBefore: "",
    unfoldedContentAfter: "",
    closeButtonMarkup: "",
    init: function init(e, t, n, i, r, o) {
        $c300bab1e7099971$var$FC.menu.menuSelector = e, $c300bab1e7099971$var$FC.menu.menuItemSelector = t, $c300bab1e7099971$var$FC.menu.contentSelector = n, $c300bab1e7099971$var$FC.menu.unfoldedContentBefore = i, $c300bab1e7099971$var$FC.menu.unfoldedContentAfter = r, $c300bab1e7099971$var$FC.menu.closeButtonMarkup = o, $c300bab1e7099971$var$FC.menu.setupMenu(), $c300bab1e7099971$var$FC.menu.labelRows(), $c300bab1e7099971$var$FC.events.addParentClickEvent(), $c300bab1e7099971$var$FC.events.addCloseClickEvent(), $c300bab1e7099971$var$FC.resize.init();
    },
    setupMenu: function setupMenu() {
        for(var e = jQuery($c300bab1e7099971$var$FC.menu.menuItemSelector, $c300bab1e7099971$var$FC.menu.menuSelector), t = jQuery($c300bab1e7099971$var$FC.menu.menuSelector), n = 0; n < e.length; n++){
            var i = e.eq(n), r = i.children($c300bab1e7099971$var$FC.menu.contentSelector);
            i.data("data-fc-key", "fcid-" + n).children("a").attr("href", "javascript:"), i.hasClass("folding-parent") || i.addClass("folding-parent"), t.data("fcid-" + n, r), r.remove();
        }
    },
    labelRows: function labelRows() {
        jQuery(".row-end").removeClass("row-end"), jQuery(".row-begin").removeClass("row-begin");
        var e = jQuery($c300bab1e7099971$var$FC.menu.menuItemSelector, $c300bab1e7099971$var$FC.menu.menuSelector), t = -1, n = "";
        e.each(function() {
            var e = jQuery(this), i = e.position().top;
            i != t && (e.addClass("row-begin"), n = e.prev(), n.hasClass("unfolded-content") && (n = n.prev()), n.addClass("row-end"), t = i);
        }), e.last().addClass("row-end");
    },
    cleanUpActiveFoldingMenu: function cleanUpActiveFoldingMenu() {
        jQuery(".active-item").css("height", "").removeClass("active-item"), jQuery(".unfolded-content").slideUp(400, function() {
            jQuery(this).remove();
        });
    },
    activeItemRow: function activeItemRow(e) {
        for(var t = "", n = e, i = 0; i < 100; i++)n.hasClass("row-begin") ? (t = n, i += 200) : n = n.prev();
        var r = "";
        n = e;
        for(var o = 0; o < 100; o++)n.hasClass("row-end") ? (r = n, o += 200) : n = n.next();
        return {
            begin: t,
            end: r
        };
    },
    equalizeItemHeight: function equalizeItemHeight(e) {
        for(var t = $c300bab1e7099971$var$FC.menu.activeItemRow(e).begin, n = 0, i = t, r = jQuery(); 100 > n;)n++, r = r.add(i), i.hasClass("row-end") ? n += 200 : i = i.next();
        var o = 0;
        if (r.each(function() {
            var _$e = jQuery(this);
            o < _$e.outerHeight() && (o = _$e.outerHeight());
        }), e.outerHeight() < o) {
            e.css("height", "");
            var a = e.outerHeight() - e.height(), s = o - a;
            e.height(s);
        }
    }
}, $c300bab1e7099971$var$FC.events = {
    addParentClickEvent: function addParentClickEvent() {
        jQuery($c300bab1e7099971$var$FC.menu.menuSelector).on("click", ".folding-parent", function() {
            var e = jQuery(this);
            if (e.hasClass("active-item")) return void $c300bab1e7099971$var$FC.menu.cleanUpActiveFoldingMenu();
            $c300bab1e7099971$var$FC.menu.cleanUpActiveFoldingMenu(), e.addClass("active-item"), $c300bab1e7099971$var$FC.menu.equalizeItemHeight(e);
            var t = '<div class="close-unfolded-content">' + $c300bab1e7099971$var$FC.menu.closeButtonMarkup + "</div>";
            t = $c300bab1e7099971$var$FC.menu.unfoldedContentBefore + t + $c300bab1e7099971$var$FC.menu.unfoldedContentAfter;
            var n = $c300bab1e7099971$var$FC.menu.activeItemRow(e).end;
            jQuery(t).insertAfter(n);
            var i = n.next();
            i.addClass("unfolded-content");
            var r = e.data("data-fc-key"), o = jQuery($c300bab1e7099971$var$FC.menu.menuSelector).data(r);
            o.appendTo(i), i.slideDown(400);
        });
    },
    addCloseClickEvent: function addCloseClickEvent() {
        jQuery($c300bab1e7099971$var$FC.menu.menuSelector).on("click", ".close-unfolded-content", function() {
            $c300bab1e7099971$var$FC.menu.cleanUpActiveFoldingMenu();
        });
    }
}, $c300bab1e7099971$var$FC.resize = {
    init: function init() {
        var e = jQuery($c300bab1e7099971$var$FC.menu.menuSelector);
        $c300bab1e7099971$var$FC.resize.addResizeCanary(e);
        var t = jQuery(".fc-resize-canary")[0];
        addResizeListener(t, $c300bab1e7099971$var$FC.resize.menuResize);
    },
    addResizeCanary: function addResizeCanary(e) {
        var t = '<div class="fc-resize-canary" style="height: 20px; margin-bottom: -20px;"></div>';
        jQuery($c300bab1e7099971$var$FC.menu.menuSelector).parent().prepend(t);
    },
    menuResize: $c300bab1e7099971$var$throttle(function() {
        var e = jQuery(".unfolded-content").detach();
        $c300bab1e7099971$var$FC.menu.labelRows();
        var t = jQuery(".active-item");
        if (t.length) {
            t.css("height", ""), $c300bab1e7099971$var$FC.menu.equalizeItemHeight(t);
            var n = $c300bab1e7099971$var$FC.menu.activeItemRow(t).end;
            e.insertAfter(n);
        }
    }, 300)
}, jQuery.fn.foldingContent = function(e) {
    jQuery(document).ready(function() {
        var t = e, n = t.menuSelector, i = t.menuItemSelector, r = t.contentSelector, o = t.unfoldBeforeMarkup, a = t.unfoldAfterMarkup, s = "";
        t.closeMarkup && (s = t.closeMarkup), $c300bab1e7099971$var$FC.menu.init(n, i, r, o, a, s);
    });
}, function() {
    function e() {
        if (!n) {
            var e = (g ? g : "") + ".resize-triggers { " + (p ? p : "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', t = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
            i.type = "text/css", i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e)), t.appendChild(i), n = !0;
        }
    }
    var t = document.attachEvent, n = !1;
    if (!t) {
        var i = function() {
            var e = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(e) {
                return window.setTimeout(e, 20);
            };
            return function(t) {
                return e(t);
            };
        }(), r = function() {
            var e = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
            return function(t) {
                return e(t);
            };
        }(), o = function o(e) {
            var t = e.__resizeTriggers__, n = t.firstElementChild, i = t.lastElementChild, r = n.firstElementChild;
            i.scrollLeft = i.scrollWidth, i.scrollTop = i.scrollHeight, r.style.width = n.offsetWidth + 1 + "px", r.style.height = n.offsetHeight + 1 + "px", n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight;
        }, a = function a(e) {
            return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
        }, s = function s(e) {
            var t = this;
            o(this), this.__resizeRAF__ && r(this.__resizeRAF__), this.__resizeRAF__ = i(function() {
                a(t) && (t.__resizeLast__.width = t.offsetWidth, t.__resizeLast__.height = t.offsetHeight, t.__resizeListeners__.forEach(function(n) {
                    n.call(t, e);
                }));
            });
        }, u = !1, c = "animation", l = "", d = "animationstart", m = "Webkit Moz O ms".split(" "), f = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), v = "", h = document.createElement("fakeelement");
        if (void 0 !== h.style.animationName && (u = !0), u === !1) {
            for(var _ = 0; _ < m.length; _++)if (void 0 !== h.style[m[_] + "AnimationName"]) {
                v = m[_], c = v + "Animation", l = "-" + v.toLowerCase() + "-", d = f[_], u = !0;
                break;
            }
        }
        var C = "resizeanim", g = "@" + l + "keyframes " + C + " { from { opacity: 0; } to { opacity: 0; } } ", p = l + "animation: 1ms " + C + "; ";
    }
    window.addResizeListener = function(n, i) {
        t ? n.attachEvent("onresize", i) : (n.__resizeTriggers__ || ("static" == getComputedStyle(n).position && (n.style.position = "relative"), e(), n.__resizeLast__ = {}, n.__resizeListeners__ = [], (n.__resizeTriggers__ = document.createElement("div")).className = "resize-triggers", n.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', n.appendChild(n.__resizeTriggers__), o(n), n.addEventListener("scroll", s, !0), d && n.__resizeTriggers__.addEventListener(d, function(e) {
            e.animationName == C && o(n);
        })), n.__resizeListeners__.push(i));
    }, window.removeResizeListener = function(e, n) {
        t ? e.detachEvent("onresize", n) : (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(n), 1), e.__resizeListeners__.length || (e.removeEventListener("scroll", s), e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__)));
    };
}();


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9OVGD)));
$(function() {
    if ($('.folding-menu').length) $('.folding-menu').foldingContent({
        menuSelector: '.folding-menu',
        menuItemSelector: '.menu-item',
        contentSelector: '.folding-content',
        unfoldBeforeMarkup: '<li>',
        unfoldAfterMarkup: '</li>',
        closeMarkup: '<span class="your-icon-class">X</span>'
    });
});



})();
//# sourceMappingURL=modules.js.map
